import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2251 2251"
      id="vector">
      <g
        id="group"
        transform="translate(190 157)">
        <path
          id="path"
          d="M 1840.5 0 L 1849 0.5 L 1840.5 1 L 1840.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 20.5 1 L 29 1.5 L 20.5 2 L 20.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 1830.5 2 L 1833 2.5 L 1830.5 3 L 1830.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1825.5 3 L 1828 3.5 L 1825.5 4 L 1825.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1856.5 3 L 1857.5 5 L 1856.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 1820.5 4 L 1823 4.5 L 1820.5 5 L 1820.5 4 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 10.5 5 L 5.5 11 L 10.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 1815.5 5 L 1818 5.5 L 1815.5 6 L 1815.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 1810.5 6 L 1813 6.5 L 1810.5 7 L 1810.5 6 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1860.5 6 L 1861.5 8 L 1860.5 6 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 1805.5 7 L 1808 7.5 L 1805.5 8 L 1805.5 7 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 1800.5 8 L 1803 8.5 L 1800.5 9 L 1800.5 8 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 1795.5 9 L 1798 9.5 L 1795.5 10 L 1795.5 9 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1790.5 10 L 1793 10.5 L 1790.5 11 L 1790.5 10 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 1863.5 10 L 1864.5 12 L 1863.5 10 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 76.5 11 L 79 11.5 L 76.5 12 L 76.5 11 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 1785.5 11 L 1788 11.5 L 1785.5 12 L 1785.5 11 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 81.5 12 L 84 12.5 L 81.5 13 L 81.5 12 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 86.5 13 L 89 13.5 L 86.5 14 L 86.5 13 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1769.5 14 L 1772 14.5 L 1769.5 15 L 1769.5 14 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 1764.5 15 L 1767 15.5 L 1764.5 16 L 1764.5 15 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 102.5 16 L 105 16.5 L 102.5 17 L 102.5 16 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 107.5 17 L 110 17.5 L 107.5 18 L 107.5 17 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1753.5 17 L 1756 17.5 L 1753.5 18 L 1753.5 17 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 113.5 18 L 116 18.5 L 113.5 19 L 113.5 18 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1748.5 18 L 1751 18.5 L 1748.5 19 L 1748.5 18 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 118.5 19 L 121 19.5 L 118.5 20 L 118.5 19 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1867.5 19 L 1868 27.5 L 1867 27.5 L 1867.5 19 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 1737.5 20 L 1740 20.5 L 1737.5 21 L 1737.5 20 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 129.5 21 L 132 21.5 L 129.5 22 L 129.5 21 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 135.5 22 L 138 22.5 L 135.5 23 L 135.5 22 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 1726.5 22 L 1729 22.5 L 1726.5 23 L 1726.5 22 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 140.5 23 L 143 23.5 L 140.5 24 L 140.5 23 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1720.5 23 L 1723 23.5 L 1720.5 24 L 1720.5 23 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 146.5 24 L 149 24.5 L 146.5 25 L 146.5 24 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1715.5 24 L 1718 24.5 L 1715.5 25 L 1715.5 24 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 152.5 25 L 155 25.5 L 152.5 26 L 152.5 25 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1709.5 25 L 1712 25.5 L 1709.5 26 L 1709.5 25 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 157.5 26 L 160 26.5 L 157.5 27 L 157.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 1703.5 26 L 1706 26.5 L 1703.5 27 L 1703.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 163.5 27 L 166 27.5 L 163.5 28 L 163.5 27 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1697.5 27 L 1700 27.5 L 1697.5 28 L 1697.5 27 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 169.5 28 L 172 28.5 L 169.5 29 L 169.5 28 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 175.5 29 L 178 29.5 L 175.5 30 L 175.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 1686.5 29 L 1689 29.5 L 1686.5 30 L 1686.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 181.5 30 L 184 30.5 L 181.5 31 L 181.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 1680.5 30 L 1683 30.5 L 1680.5 31 L 1680.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 187.5 31 L 190 31.5 L 187.5 32 L 187.5 31 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 1674.5 31 L 1677 31.5 L 1674.5 32 L 1674.5 31 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 193.5 32 L 196 32.5 L 193.5 33 L 193.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 1668.5 32 L 1671 32.5 L 1668.5 33 L 1668.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 199.5 33 L 202 33.5 L 199.5 34 L 199.5 33 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 1661.5 33 L 1665 33.5 L 1661.5 34 L 1661.5 33 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 205.5 34 L 208 34.5 L 205.5 35 L 205.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 1655.5 34 L 1658 34.5 L 1655.5 35 L 1655.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 211.5 35 L 215 35.5 L 211.5 36 L 211.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1649.5 35 L 1652 35.5 L 1649.5 36 L 1649.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 218.5 36 L 221 36.5 L 218.5 37 L 218.5 36 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 1643.5 36 L 1646 36.5 L 1643.5 37 L 1643.5 36 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 4.5 37 L 5.5 39 L 4.5 37 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 224.5 37 L 227 37.5 L 224.5 38 L 224.5 37 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1636.5 37 L 1640 37.5 L 1636.5 38 L 1636.5 37 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 1863.5 37 L 1858.5 43 L 1863.5 37 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 230.5 38 L 234 38.5 L 230.5 39 L 230.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 1630.5 38 L 1633 38.5 L 1630.5 39 L 1630.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 237.5 39 L 240 39.5 L 237.5 40 L 237.5 39 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 1623.5 39 L 1627 39.5 L 1623.5 40 L 1623.5 39 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 243.5 40 L 247 40.5 L 243.5 41 L 243.5 40 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 1617.5 40 L 1620 40.5 L 1617.5 41 L 1617.5 40 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 250.5 41 L 253 41.5 L 250.5 42 L 250.5 41 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1610.5 41 L 1614 41.5 L 1610.5 42 L 1610.5 41 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 257.5 42 L 260 42.5 L 257.5 43 L 257.5 42 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 1604.5 42 L 1607 42.5 L 1604.5 43 L 1604.5 42 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 10.5 43 L 11.5 45 L 10.5 43 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 263.5 43 L 267 43.5 L 263.5 44 L 263.5 43 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 1597.5 43 L 1600 43.5 L 1597.5 44 L 1597.5 43 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 1856.5 43 L 1855.5 45 L 1856.5 43 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 270.5 44 L 274 44.5 L 270.5 45 L 270.5 44 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 1590.5 44 L 1593 44.5 L 1590.5 45 L 1590.5 44 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 277.5 45 L 281 45.5 L 277.5 46 L 277.5 45 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1583.5 45 L 1586 45.5 L 1583.5 46 L 1583.5 45 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 284.5 46 L 288 46.5 L 284.5 47 L 284.5 46 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 1576.5 46 L 1579 46.5 L 1576.5 47 L 1576.5 46 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1848.5 46 L 1851 46.5 L 1848.5 47 L 1848.5 46 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 291.5 47 L 295 47.5 L 291.5 48 L 291.5 47 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1569.5 47 L 1572 47.5 L 1569.5 48 L 1569.5 47 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 298.5 48 L 302 48.5 L 298.5 49 L 298.5 48 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1562.5 48 L 1565 48.5 L 1562.5 49 L 1562.5 48 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 27.5 49 L 30 49.5 L 27.5 50 L 27.5 49 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 306.5 49 L 309 49.5 L 306.5 50 L 306.5 49 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 1554.5 49 L 1558 49.5 L 1554.5 50 L 1554.5 49 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 32.5 50 L 35 50.5 L 32.5 51 L 32.5 50 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 313.5 50 L 317 50.5 L 313.5 51 L 313.5 50 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 1547.5 50 L 1551 50.5 L 1547.5 51 L 1547.5 50 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 37.5 51 L 40 51.5 L 37.5 52 L 37.5 51 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 320.5 51 L 324 51.5 L 320.5 52 L 320.5 51 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 1539.5 51 L 1543 51.5 L 1539.5 52 L 1539.5 51 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 1824.5 51 L 1827 51.5 L 1824.5 52 L 1824.5 51 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 42.5 52 L 45 52.5 L 42.5 53 L 42.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 328.5 52 L 332 52.5 L 328.5 53 L 328.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 1532.5 52 L 1536 52.5 L 1532.5 53 L 1532.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1819.5 52 L 1822 52.5 L 1819.5 53 L 1819.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 47.5 53 L 50 53.5 L 47.5 54 L 47.5 53 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 335.5 53 L 339 53.5 L 335.5 54 L 335.5 53 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 1524.5 53 L 1528 53.5 L 1524.5 54 L 1524.5 53 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 1814.5 53 L 1817 53.5 L 1814.5 54 L 1814.5 53 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 52.5 54 L 55 54.5 L 52.5 55 L 52.5 54 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 343.5 54 L 347 54.5 L 343.5 55 L 343.5 54 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 1516.5 54 L 1520 54.5 L 1516.5 55 L 1516.5 54 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 1809.5 54 L 1812 54.5 L 1809.5 55 L 1809.5 54 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 57.5 55 L 60 55.5 L 57.5 56 L 57.5 55 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 351.5 55 L 355 55.5 L 351.5 56 L 351.5 55 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 1509.5 55 L 1513 55.5 L 1509.5 56 L 1509.5 55 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 62.5 56 L 65 56.5 L 62.5 57 L 62.5 56 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 359.5 56 L 363 56.5 L 359.5 57 L 359.5 56 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1501.5 56 L 1505 56.5 L 1501.5 57 L 1501.5 56 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 367.5 57 L 371 57.5 L 367.5 58 L 367.5 57 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1492.5 57 L 1496 57.5 L 1492.5 58 L 1492.5 57 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 375.5 58 L 379 58.5 L 375.5 59 L 375.5 58 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1484.5 58 L 1488 58.5 L 1484.5 59 L 1484.5 58 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 1788.5 58 L 1791 58.5 L 1788.5 59 L 1788.5 58 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 78.5 59 L 81 59.5 L 78.5 60 L 78.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 384.5 59 L 388 59.5 L 384.5 60 L 384.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 1476.5 59 L 1480 59.5 L 1476.5 60 L 1476.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 1783.5 59 L 1786 59.5 L 1783.5 60 L 1783.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 83.5 60 L 86 60.5 L 83.5 61 L 83.5 60 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 392.5 60 L 396 60.5 L 392.5 61 L 392.5 60 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 1467.5 60 L 1471 60.5 L 1467.5 61 L 1467.5 60 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 1778.5 60 L 1781 60.5 L 1778.5 61 L 1778.5 60 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 88.5 61 L 91 61.5 L 88.5 62 L 88.5 61 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 401.5 61 L 405 61.5 L 401.5 62 L 401.5 61 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 1458.5 61 L 1463 61.5 L 1458.5 62 L 1458.5 61 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 410.5 62 L 414 62.5 L 410.5 63 L 410.5 62 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 1450.5 62 L 1454 62.5 L 1450.5 63 L 1450.5 62 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 1767.5 62 L 1770 62.5 L 1767.5 63 L 1767.5 62 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 99.5 63 L 102 63.5 L 99.5 64 L 99.5 63 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 418.5 63 L 423 63.5 L 418.5 64 L 418.5 63 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1441.5 63 L 1445 63.5 L 1441.5 64 L 1441.5 63 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 1762.5 63 L 1765 63.5 L 1762.5 64 L 1762.5 63 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 428.5 64 L 432 64.5 L 428.5 65 L 428.5 64 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 1431.5 64 L 1436 64.5 L 1431.5 65 L 1431.5 64 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 110.5 65 L 113 65.5 L 110.5 66 L 110.5 65 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 437.5 65 L 442 65.5 L 437.5 66 L 437.5 65 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1422.5 65 L 1427 65.5 L 1422.5 66 L 1422.5 65 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1751.5 65 L 1754 65.5 L 1751.5 66 L 1751.5 65 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 115.5 66 L 118 66.5 L 115.5 67 L 115.5 66 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 446.5 66 L 451 66.5 L 446.5 67 L 446.5 66 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 1412.5 66 L 1417 66.5 L 1412.5 67 L 1412.5 66 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 121.5 67 L 124 67.5 L 121.5 68 L 121.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 456.5 67 L 461 67.5 L 456.5 68 L 456.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 1403.5 67 L 1408 67.5 L 1403.5 68 L 1403.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 1740.5 67 L 1743 67.5 L 1740.5 68 L 1740.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 466.5 68 L 471 68.5 L 466.5 69 L 466.5 68 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 1393.5 68 L 1398 68.5 L 1393.5 69 L 1393.5 68 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 132.5 69 L 135 69.5 L 132.5 70 L 132.5 69 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 476.5 69 L 481 69.5 L 476.5 70 L 476.5 69 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 1382.5 69 L 1388 69.5 L 1382.5 70 L 1382.5 69 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 1729.5 69 L 1732 69.5 L 1729.5 70 L 1729.5 69 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 138.5 70 L 141 70.5 L 138.5 71 L 138.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 486.5 70 L 492 70.5 L 486.5 71 L 486.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 1372.5 70 L 1377 70.5 L 1372.5 71 L 1372.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 1723.5 70 L 1726 70.5 L 1723.5 71 L 1723.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 497.5 71 L 502 71.5 L 497.5 72 L 497.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1361.5 71 L 1367 71.5 L 1361.5 72 L 1361.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 1717.5 71 L 1720 71.5 L 1717.5 72 L 1717.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 149.5 72 L 152 72.5 L 149.5 73 L 149.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 508.5 72 L 513 72.5 L 508.5 73 L 508.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1350.5 72 L 1356 72.5 L 1350.5 73 L 1350.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 1712.5 72 L 1715 72.5 L 1712.5 73 L 1712.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 155.5 73 L 158 73.5 L 155.5 74 L 155.5 73 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 519.5 73 L 525 73.5 L 519.5 74 L 519.5 73 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 1339.5 73 L 1345 73.5 L 1339.5 74 L 1339.5 73 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 1706.5 73 L 1709 73.5 L 1706.5 74 L 1706.5 73 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 161.5 74 L 164 74.5 L 161.5 75 L 161.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 530.5 74 L 536 74.5 L 530.5 75 L 530.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 1327.5 74 L 1333 74.5 L 1327.5 75 L 1327.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 1700.5 74 L 1703 74.5 L 1700.5 75 L 1700.5 74 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 167.5 75 L 170 75.5 L 167.5 76 L 167.5 75 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 542.5 75 L 548 75.5 L 542.5 76 L 542.5 75 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 1315.5 75 L 1321 75.5 L 1315.5 76 L 1315.5 75 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 1694.5 75 L 1697 75.5 L 1694.5 76 L 1694.5 75 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 173.5 76 L 176 76.5 L 173.5 77 L 173.5 76 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 555.5 76 L 561 76.5 L 555.5 77 L 555.5 76 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 1303.5 76 L 1309 76.5 L 1303.5 77 L 1303.5 76 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 1688.5 76 L 1691 76.5 L 1688.5 77 L 1688.5 76 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 179.5 77 L 182 77.5 L 179.5 78 L 179.5 77 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 567.5 77 L 574 77.5 L 567.5 78 L 567.5 77 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 1290.5 77 L 1296 77.5 L 1290.5 78 L 1290.5 77 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1682.5 77 L 1685 77.5 L 1682.5 78 L 1682.5 77 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 185.5 78 L 188 78.5 L 185.5 79 L 185.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 580.5 78 L 587 78.5 L 580.5 79 L 580.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 1276.5 78 L 1283 78.5 L 1276.5 79 L 1276.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1676.5 78 L 1679 78.5 L 1676.5 79 L 1676.5 78 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 191.5 79 L 194 79.5 L 191.5 80 L 191.5 79 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 594.5 79 L 601 79.5 L 594.5 80 L 594.5 79 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 1262.5 79 L 1269 79.5 L 1262.5 80 L 1262.5 79 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 1670.5 79 L 1673 79.5 L 1670.5 80 L 1670.5 79 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 197.5 80 L 200 80.5 L 197.5 81 L 197.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 608.5 80 L 616 80.5 L 608.5 81 L 608.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 1248.5 80 L 1255 80.5 L 1248.5 81 L 1248.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1664.5 80 L 1667 80.5 L 1664.5 81 L 1664.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 203.5 81 L 206 81.5 L 203.5 82 L 203.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 623.5 81 L 631 81.5 L 623.5 82 L 623.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 1232.5 81 L 1240 81.5 L 1232.5 82 L 1232.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1658.5 81 L 1661 81.5 L 1658.5 82 L 1658.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 210.5 82 L 213 82.5 L 210.5 83 L 210.5 82 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 639.5 82 L 647 82.5 L 639.5 83 L 639.5 82 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1216.5 82 L 1224 82.5 L 1216.5 83 L 1216.5 82 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1651.5 82 L 1654 82.5 L 1651.5 83 L 1651.5 82 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 216.5 83 L 219 83.5 L 216.5 84 L 216.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 656.5 83 L 665 83.5 L 656.5 84 L 656.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 1199.5 83 L 1208 83.5 L 1199.5 84 L 1199.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 1645.5 83 L 1648 83.5 L 1645.5 84 L 1645.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 222.5 84 L 226 84.5 L 222.5 85 L 222.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 674.5 84 L 683 84.5 L 674.5 85 L 674.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 1180.5 84 L 1190 84.5 L 1180.5 85 L 1180.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 1638.5 84 L 1642 84.5 L 1638.5 85 L 1638.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 229.5 85 L 232 85.5 L 229.5 86 L 229.5 85 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 693.5 85 L 703 85.5 L 693.5 86 L 693.5 85 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1160.5 85 L 1171 85.5 L 1160.5 86 L 1160.5 85 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 1632.5 85 L 1635 85.5 L 1632.5 86 L 1632.5 85 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 235.5 86 L 239 86.5 L 235.5 87 L 235.5 86 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 714.5 86 L 725 86.5 L 714.5 87 L 714.5 86 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1138.5 86 L 1150 86.5 L 1138.5 87 L 1138.5 86 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 1625.5 86 L 1629 86.5 L 1625.5 87 L 1625.5 86 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 242.5 87 L 245 87.5 L 242.5 88 L 242.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 737.5 87 L 750 87.5 L 737.5 88 L 737.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 1114.5 87 L 1127 87.5 L 1114.5 88 L 1114.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1619.5 87 L 1622 87.5 L 1619.5 88 L 1619.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 249.5 88 L 252 88.5 L 249.5 89 L 249.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 763.5 88 L 778 88.5 L 763.5 89 L 763.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 1085.5 88 L 1100 88.5 L 1085.5 89 L 1085.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1612.5 88 L 1615 88.5 L 1612.5 89 L 1612.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 255.5 89 L 259 89.5 L 255.5 90 L 255.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 795.5 89 L 814 89.5 L 795.5 90 L 795.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1050.5 89 L 1069 89.5 L 1050.5 90 L 1050.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 1605.5 89 L 1609 89.5 L 1605.5 90 L 1605.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 262.5 90 L 266 90.5 L 262.5 91 L 262.5 90 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 836.5 90 L 866 90.5 L 836.5 91 L 836.5 90 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 997.5 90 L 1027 90.5 L 997.5 91 L 997.5 90 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 1598.5 90 L 1602 90.5 L 1598.5 91 L 1598.5 90 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 269.5 91 L 273 91.5 L 269.5 92 L 269.5 91 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 1592.5 91 L 1595 91.5 L 1592.5 92 L 1592.5 91 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 276.5 92 L 280 92.5 L 276.5 93 L 276.5 92 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 1585.5 92 L 1588 92.5 L 1585.5 93 L 1585.5 92 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 283.5 93 L 287 93.5 L 283.5 94 L 283.5 93 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 1577.5 93 L 1581 93.5 L 1577.5 94 L 1577.5 93 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 290.5 94 L 294 94.5 L 290.5 95 L 290.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 1570.5 94 L 1574 94.5 L 1570.5 95 L 1570.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 298.5 95 L 301 95.5 L 298.5 96 L 298.5 95 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 1563.5 95 L 1567 95.5 L 1563.5 96 L 1563.5 95 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 305.5 96 L 309 96.5 L 305.5 97 L 305.5 96 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1556.5 96 L 1559 96.5 L 1556.5 97 L 1556.5 96 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 312.5 97 L 316 97.5 L 312.5 98 L 312.5 97 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 1548.5 97 L 1552 97.5 L 1548.5 98 L 1548.5 97 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 320.5 98 L 324 98.5 L 320.5 99 L 320.5 98 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 1541.5 98 L 1544 98.5 L 1541.5 99 L 1541.5 98 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 327.5 99 L 331 99.5 L 327.5 100 L 327.5 99 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 1533.5 99 L 1537 99.5 L 1533.5 100 L 1533.5 99 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 335.5 100 L 339 100.5 L 335.5 101 L 335.5 100 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 1525.5 100 L 1529 100.5 L 1525.5 101 L 1525.5 100 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 343.5 101 L 347 101.5 L 343.5 102 L 343.5 101 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 1517.5 101 L 1521 101.5 L 1517.5 102 L 1517.5 101 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 351.5 102 L 355 102.5 L 351.5 103 L 351.5 102 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 357.5 103 L 358 107.5 L 357 107.5 L 357.5 103 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 1465.5 107 Q 1472.3 104.8 1470 111.5 L 1469 111.5 Q 1470.8 106.3 1465.5 108 L 1465.5 107 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 1516.5 107 L 1517 111.5 L 1516 111.5 L 1516.5 107 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 404.5 108 L 408 108.5 L 404.5 109 L 404.5 108 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 1456.5 108 L 1460 108.5 L 1456.5 109 L 1456.5 108 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 413.5 109 L 417 109.5 L 413.5 110 L 413.5 109 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1447.5 109 L 1451 109.5 L 1447.5 110 L 1447.5 109 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 422.5 110 L 426 110.5 L 422.5 111 L 422.5 110 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 1438.5 110 L 1442 110.5 L 1438.5 111 L 1438.5 110 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 431.5 111 L 436 111.5 L 431.5 112 L 431.5 111 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 1428.5 111 L 1433 111.5 L 1428.5 112 L 1428.5 111 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 440.5 112 L 445 112.5 L 440.5 113 L 440.5 112 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 1419.5 112 L 1424 112.5 L 1419.5 113 L 1419.5 112 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 356.5 113 L 357 117.5 L 356 117.5 L 356.5 113 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 403.5 113 L 404 117.5 L 403 117.5 L 403.5 113 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 450.5 113 L 455 113.5 L 450.5 114 L 450.5 113 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1409.5 113 L 1414 113.5 L 1409.5 114 L 1409.5 113 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 460.5 114 L 465 114.5 L 460.5 115 L 460.5 114 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 1399.5 114 L 1404 114.5 L 1399.5 115 L 1399.5 114 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 470.5 115 L 475 115.5 L 470.5 116 L 470.5 115 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 1389.5 115 L 1394 115.5 L 1389.5 116 L 1389.5 115 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 480.5 116 L 485 116.5 L 480.5 117 L 480.5 116 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1378.5 116 L 1384 116.5 L 1378.5 117 L 1378.5 116 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 491.5 117 L 496 117.5 L 491.5 118 L 491.5 117 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 1368.5 117 L 1373 117.5 L 1368.5 118 L 1368.5 117 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1470.5 117 L 1471 121.5 L 1470 121.5 L 1470.5 117 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 1517.5 117 L 1518 121.5 L 1517 121.5 L 1517.5 117 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 502.5 118 L 507 118.5 L 502.5 119 L 502.5 118 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 1357.5 118 L 1362 118.5 L 1357.5 119 L 1357.5 118 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 513.5 119 L 518 119.5 L 513.5 120 L 513.5 119 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 1346.5 119 L 1351 119.5 L 1346.5 120 L 1346.5 119 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 524.5 120 L 530 120.5 L 524.5 121 L 524.5 120 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 1334.5 120 L 1340 120.5 L 1334.5 121 L 1334.5 120 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 536.5 121 L 542 121.5 L 536.5 122 L 536.5 121 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 1322.5 121 L 1328 121.5 L 1322.5 122 L 1322.5 121 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 548.5 122 L 554 122.5 L 548.5 123 L 548.5 122 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 1310.5 122 L 1316 122.5 L 1310.5 123 L 1310.5 122 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 355.5 123 L 356 127.5 L 355 127.5 L 355.5 123 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 402.5 123 L 403 127.5 L 402 127.5 L 402.5 123 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 560.5 123 L 567 123.5 L 560.5 124 L 560.5 123 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 1297.5 123 L 1303 123.5 L 1297.5 124 L 1297.5 123 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 573.5 124 L 580 124.5 L 573.5 125 L 573.5 124 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 1284.5 124 L 1290 124.5 L 1284.5 125 L 1284.5 124 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 587.5 125 L 594 125.5 L 587.5 126 L 587.5 125 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 1270.5 125 L 1277 125.5 L 1270.5 126 L 1270.5 125 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 601.5 126 L 608 126.5 L 601.5 127 L 601.5 126 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 1255.5 126 L 1263 126.5 L 1255.5 127 L 1255.5 126 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 616.5 127 L 623 127.5 L 616.5 128 L 616.5 127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 1240.5 127 L 1248 127.5 L 1240.5 128 L 1240.5 127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 1471.5 127 L 1472 131.5 L 1471 131.5 L 1471.5 127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 1518.5 127 L 1519 131.5 L 1518 131.5 L 1518.5 127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 631.5 128 L 639 128.5 L 631.5 129 L 631.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 1224.5 128 L 1232 128.5 L 1224.5 129 L 1224.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 647.5 129 L 656 129.5 L 647.5 130 L 647.5 129 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1208.5 129 L 1216 129.5 L 1208.5 130 L 1208.5 129 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 665.5 130 L 674 130.5 L 665.5 131 L 665.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1190.5 130 L 1199 130.5 L 1190.5 131 L 1190.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 683.5 131 L 693 131.5 L 683.5 132 L 683.5 131 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 1170.5 131 L 1180 131.5 L 1170.5 132 L 1170.5 131 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 703.5 132 L 714 132.5 L 703.5 133 L 703.5 132 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 1149.5 132 L 1160 132.5 L 1149.5 133 L 1149.5 132 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 354.5 133 L 355 137.5 L 354 137.5 L 354.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 401.5 133 L 402 137.5 L 401 137.5 L 401.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 725.5 133 L 737 133.5 L 725.5 134 L 725.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 1126.5 133 L 1138 133.5 L 1126.5 134 L 1126.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 750.5 134 L 764 134.5 L 750.5 135 L 750.5 134 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 1099.5 134 L 1113 134.5 L 1099.5 135 L 1099.5 134 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 779.5 135 L 796 135.5 L 779.5 136 L 779.5 135 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1067.5 135 L 1084 135.5 L 1067.5 136 L 1067.5 135 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 815.5 136 L 838 136.5 L 815.5 137 L 815.5 136 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 1025.5 136 L 1048 136.5 L 1025.5 137 L 1025.5 136 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 868.5 137 L 911 137.5 L 868.5 138 L 868.5 137 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 958.5 137 L 993 137.5 L 958 138 L 957.5 200 L 957 138.5 L 958.5 137 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 1472.5 137 L 1473 141.5 L 1472 141.5 L 1472.5 137 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 1519.5 137 L 1520 141.5 L 1519 141.5 L 1519.5 137 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 353.5 143 L 354 147.5 L 353 147.5 L 353.5 143 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 400.5 143 L 401 147.5 L 400 147.5 L 400.5 143 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 1473.5 147 L 1474 151.5 L 1473 151.5 L 1473.5 147 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 1520.5 147 L 1521 151.5 L 1520 151.5 L 1520.5 147 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 352.5 153 L 353 157.5 L 352 157.5 L 352.5 153 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 399.5 153 L 400 157.5 L 399 157.5 L 399.5 153 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 1474.5 157 L 1475 161.5 L 1474 161.5 L 1474.5 157 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 1521.5 157 L 1522 161.5 L 1521 161.5 L 1521.5 157 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 351.5 163 L 352 167.5 L 351 167.5 L 351.5 163 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 398.5 163 L 399 167.5 L 398 167.5 L 398.5 163 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 307.5 167 L 310 167.5 L 307.5 168 L 307.5 167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 325.5 167 L 330 167.5 L 325.5 168 L 325.5 167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 1475.5 167 L 1476 171.5 L 1475 171.5 L 1475.5 167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 1522.5 167 L 1523 169.5 L 1522 169.5 L 1522.5 167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 1544.5 167 L 1549 167.5 L 1544.5 168 L 1544.5 167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 1563.5 167 L 1566 167.5 L 1563.5 168 L 1563.5 167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 335.5 168 L 340 168.5 L 335.5 169 L 335.5 168 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 1534.5 168 L 1539 168.5 L 1534.5 169 L 1534.5 168 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 345.5 169 L 350 169.5 L 345.5 170 L 345.5 169 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1524.5 169 L 1529 169.5 L 1524.5 170 L 1524.5 169 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 1580.5 172 L 1581.5 174 L 1580.5 172 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 397.5 173 L 398.5 175 L 397.5 173 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 288.5 175 L 287.5 177 L 288.5 175 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 404.5 175 L 409 175.5 L 404.5 176 L 404.5 175 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 1464.5 175 L 1469 175.5 L 1464.5 176 L 1464.5 175 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 414.5 176 L 419 176.5 L 414.5 177 L 414.5 176 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 1454.5 176 L 1459 176.5 L 1454.5 177 L 1454.5 176 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 1586.5 176 L 1587.5 178 L 1586.5 176 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 285.5 177 L 278.5 185 L 285.5 177 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 424.5 177 L 429 177.5 L 424.5 178 L 424.5 177 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 1445.5 177 L 1449 177.5 L 1445.5 178 L 1445.5 177 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 1591.5 180 L 1592.5 182 L 1591.5 180 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 1425.5 184 L 1424.5 186 L 1425.5 184 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 449.5 185 L 450.5 187 L 449.5 185 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 1595.5 185 L 1596.5 187 L 1595.5 185 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1422.5 186 L 1420.5 189 L 1422.5 186 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 276.5 187 L 275.5 189 L 276.5 187 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 453.5 188 L 460.5 196 L 453.5 188 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 274.5 190 L 273.5 192 L 274.5 190 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 1413.5 195 L 1411.5 198 L 1413.5 195 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 462.5 198 L 463.5 200 L 462.5 198 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 1410.5 199 L 1409.5 201 L 1410.5 199 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 874.5 200 L 880 200.5 L 874.5 201 L 874.5 200 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 988.5 200 L 994 200.5 L 988.5 201 L 988.5 200 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 465.5 203 L 466.5 205 L 465.5 203 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 1605.5 206 L 1606 208.5 L 1605 208.5 L 1605.5 206 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 267.5 209 L 268 213.5 L 267 213.5 L 267.5 209 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 852.5 209 L 851.5 211 L 852.5 209 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 1017.5 210 L 1020.5 214 L 1017.5 210 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 849.5 211 L 843.5 218 L 849.5 211 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 316.5 213 L 320 213.5 L 316.5 214 L 316.5 213 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 1554.5 213 Q 1559.3 212.3 1560 215.5 L 1559.5 218 L 1557.5 214 Q 1553.5 214.8 1554.5 213 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 325.5 214 L 330 214.5 L 325.5 215 L 325.5 214 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 1544.5 214 L 1549 214.5 L 1544.5 215 L 1544.5 214 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 1606.5 214 L 1607 218.5 L 1606 218.5 L 1606.5 214 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 335.5 215 L 340 215.5 L 335.5 216 L 335.5 215 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 1534.5 215 L 1539 215.5 L 1534.5 216 L 1534.5 215 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 345.5 216 L 350 216.5 L 345.5 217 L 345.5 216 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 1023.5 216 L 1026.5 220 L 1023.5 216 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 1524.5 216 L 1529 216.5 L 1524.5 217 L 1524.5 216 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 355.5 217 L 360 217.5 L 355.5 218 L 355.5 217 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 1514.5 217 L 1519 217.5 L 1514.5 218 L 1514.5 217 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 365.5 218 L 370 218.5 L 365.5 219 L 365.5 218 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 1504.5 218 L 1509 218.5 L 1504.5 219 L 1504.5 218 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 266.5 219 L 267 223.5 L 266 223.5 L 266.5 219 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 313.5 219 L 314 223.5 L 313 223.5 L 313.5 219 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 375.5 219 L 380 219.5 L 375.5 220 L 375.5 219 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 1402.5 219 L 1403 222.5 L 1402 222.5 L 1402.5 219 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 1494.5 219 L 1499 219.5 L 1494.5 220 L 1494.5 219 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 385.5 220 L 390 220.5 L 385.5 221 L 385.5 220 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 841.5 220 L 840.5 222 L 841.5 220 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 1484.5 220 L 1489 220.5 L 1484.5 221 L 1484.5 220 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 395.5 221 L 400 221.5 L 395.5 222 L 395.5 221 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 1474.5 221 L 1479 221.5 L 1474.5 222 L 1474.5 221 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 405.5 222 L 410 222.5 L 405.5 223 L 405.5 222 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 471.5 222 L 472 230.5 L 471 230.5 L 471.5 222 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 1464.5 222 L 1469 222.5 L 1464.5 223 L 1464.5 222 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 415.5 223 L 420 223.5 L 415.5 224 L 415.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 839.5 223 L 838.5 225 L 839.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 1454.5 223 L 1459 223.5 L 1454.5 224 L 1454.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 1560.5 223 L 1561 227.5 L 1560 227.5 L 1560.5 223 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 423.5 224 Q 426.3 225.3 425 230.5 L 424 230.5 L 423.5 224 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 1450.5 224 L 1449.5 226 L 1450.5 224 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 1607.5 224 L 1608 228.5 L 1607 228.5 L 1607.5 224 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 265.5 229 L 266 233.5 L 265 233.5 L 265.5 229 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 312.5 229 L 313 233.5 L 312 233.5 L 312.5 229 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 1402.5 230 L 1403 234.5 L 1402 234.5 L 1402.5 230 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1449.5 230 L 1450 234.5 L 1449 234.5 L 1449.5 230 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 1561.5 233 L 1562 237.5 L 1561 237.5 L 1561.5 233 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 1608.5 234 L 1609 238.5 L 1608 238.5 L 1608.5 234 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 423.5 236 L 424 240.5 L 423 240.5 L 423.5 236 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 470.5 236 L 471 240.5 L 470 240.5 L 470.5 236 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 1035.5 238 L 1036 240.5 L 1035 240.5 L 1035.5 238 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 264.5 239 L 265 243.5 L 264 243.5 L 264.5 239 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 311.5 239 L 312 243.5 L 311 243.5 L 311.5 239 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 832.5 240 L 833 242.5 L 832 242.5 L 832.5 240 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 1403.5 240 L 1404 244.5 L 1403 244.5 L 1403.5 240 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 1450.5 240 L 1451 244.5 L 1450 244.5 L 1450.5 240 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 1562.5 243 L 1563 247.5 L 1562 247.5 L 1562.5 243 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 1036.5 244 L 1037 324.5 L 1038 325.5 L 1036 324.5 L 1036.5 244 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 1609.5 244 L 1610 248.5 L 1609 248.5 L 1609.5 244 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 422.5 246 L 423 250.5 L 422 250.5 L 422.5 246 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 469.5 246 L 470 250.5 L 469 250.5 L 469.5 246 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 988.5 247 L 989.5 249 L 988.5 247 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 263.5 249 L 264 253.5 L 263 253.5 L 263.5 249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 310.5 249 L 311 253.5 L 310 253.5 L 310.5 249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 878.5 249 L 879 312 L 990 312.5 L 879.5 313 L 878 311.5 L 878.5 249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 1404.5 250 L 1405 254.5 L 1404 254.5 L 1404.5 250 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 1451.5 250 L 1452 254.5 L 1451 254.5 L 1451.5 250 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1563.5 253 L 1564 257.5 L 1563 257.5 L 1563.5 253 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 1610.5 254 L 1611 258.5 L 1610 258.5 L 1610.5 254 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 421.5 256 L 422 260.5 L 421 260.5 L 421.5 256 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 468.5 256 L 469 260.5 L 468 260.5 L 468.5 256 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 262.5 259 L 263 263.5 L 262 263.5 L 262.5 259 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 309.5 259 L 310 263.5 L 309 263.5 L 309.5 259 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1405.5 260 L 1406 264.5 L 1405 264.5 L 1405.5 260 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1452.5 260 L 1453 264.5 L 1452 264.5 L 1452.5 260 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 1564.5 263 L 1565 267.5 L 1564 267.5 L 1564.5 263 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 1611.5 264 L 1612 267.5 L 1611 267.5 L 1611.5 264 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 420.5 266 L 421 270.5 L 420 270.5 L 420.5 266 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 467.5 266 L 468 270.5 L 467 270.5 L 467.5 266 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 261.5 269 L 262 273.5 L 261 273.5 L 261.5 269 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 308.5 269 L 309 273.5 L 308 273.5 L 308.5 269 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 1406.5 270 L 1407 274.5 L 1406 274.5 L 1406.5 270 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 1453.5 270 L 1454 274.5 L 1453 274.5 L 1453.5 270 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 1565.5 273 L 1566 279 L 1563 278.5 L 1565 278 L 1565.5 273 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1612.5 273 L 1613 277.5 L 1612 277.5 L 1612.5 273 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 419.5 276 L 420 280.5 L 419 280.5 L 419.5 276 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 466.5 276 L 467 280.5 L 466 280.5 L 466.5 276 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 260.5 279 L 261 283.5 L 260 283.5 L 260.5 279 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 315.5 279 L 320 279.5 L 315.5 280 L 315.5 279 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 1553.5 279 L 1558 279.5 L 1553.5 280 L 1553.5 279 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 325.5 280 L 330 280.5 L 325.5 281 L 325.5 280 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 1407.5 280 L 1408 284.5 L 1407 284.5 L 1407.5 280 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 1454.5 280 L 1455 284.5 L 1454 284.5 L 1454.5 280 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1543.5 280 L 1548 280.5 L 1543.5 281 L 1543.5 280 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 335.5 281 L 340 281.5 L 335.5 282 L 335.5 281 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 1533.5 281 L 1538 281.5 L 1533.5 282 L 1533.5 281 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 345.5 282 L 350 282.5 L 345.5 283 L 345.5 282 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1523.5 282 L 1528 282.5 L 1523.5 283 L 1523.5 282 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 355.5 283 L 360 283.5 L 355.5 284 L 355.5 283 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 1513.5 283 L 1518 283.5 L 1513.5 284 L 1513.5 283 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1613.5 283 L 1615 286.5 L 1613 285.5 L 1613.5 283 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 365.5 284 L 370 284.5 L 365.5 285 L 365.5 284 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 1503.5 284 L 1508 284.5 L 1503.5 285 L 1503.5 284 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 375.5 285 L 380 285.5 L 375.5 286 L 375.5 285 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 1493.5 285 L 1498 285.5 L 1493.5 286 L 1493.5 285 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 385.5 286 L 390 286.5 L 385.5 287 L 385.5 286 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 418.5 286 L 419 288.5 L 415.5 290 L 415.5 289 Q 419.5 290.1 418.5 286 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 465.5 286 L 466 290.5 L 465 290.5 L 465.5 286 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1483.5 286 L 1488 286.5 L 1483.5 287 L 1483.5 286 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 395.5 287 L 400 287.5 L 395.5 288 L 395.5 287 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 1473.5 287 L 1478 287.5 L 1473.5 288 L 1473.5 287 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 405.5 288 L 410 288.5 L 405.5 289 L 405.5 288 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 1463.5 288 L 1468 288.5 L 1463.5 289 L 1463.5 288 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 1455.5 289 L 1458 289.5 L 1455.5 290 L 1455.5 289 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1408.5 290 L 1409 294.5 L 1408 294.5 L 1408.5 290 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 1626.5 292 L 1627.5 294 L 1626.5 292 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 240.5 296 L 239.5 298 L 240.5 296 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 464.5 296 L 465 300.5 L 464 300.5 L 464.5 296 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 1634.5 297 L 1635.5 299 L 1634.5 297 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 237.5 298 L 236.5 300 L 237.5 298 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1637.5 299 L 1638.5 301 L 1637.5 299 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 1409.5 300 L 1410 304.5 L 1409 304.5 L 1409.5 300 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 1641.5 302 L 1642.5 304 L 1641.5 302 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 230.5 303 L 229.5 305 L 230.5 303 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1645.5 305 L 1646.5 307 L 1645.5 305 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 226.5 306 L 223.5 310 L 226.5 306 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1409.5 306 L 1408.5 308 L 1409.5 306 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 465.5 307 L 467.5 310 L 465.5 307 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 1649.5 308 L 1653.5 313 L 1649.5 308 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 1405.5 309 L 1403.5 312 L 1405.5 309 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 469.5 310 L 472.5 314 L 469.5 310 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 220.5 311 L 212.5 320 L 220.5 311 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 1400.5 313 L 1395.5 319 L 1400.5 313 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 1657.5 315 L 1668.5 327 L 1657.5 315 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 476.5 316 L 488.5 329 L 476.5 316 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 209.5 322 L 201.5 331 L 209.5 322 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 296.5 324 L 301 324.5 L 296.5 325 L 296.5 324 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 1573.5 324 L 1578 324.5 L 1573.5 325 L 1573.5 324 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 306.5 325 L 311 325.5 L 306.5 326 L 306.5 325 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 1563.5 325 L 1568 325.5 L 1563.5 326 L 1563.5 325 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 316.5 326 L 321 326.5 L 316.5 327 L 316.5 326 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 1387.5 326 L 1381.5 333 L 1387.5 326 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 1553.5 326 L 1558 326.5 L 1553.5 327 L 1553.5 326 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 326.5 327 L 331 327.5 L 326.5 328 L 326.5 327 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1543.5 327 L 1548 327.5 L 1543.5 328 L 1543.5 327 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 336.5 328 L 341 328.5 L 336.5 329 L 336.5 328 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 1533.5 328 L 1538 328.5 L 1533.5 329 L 1533.5 328 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 346.5 329 L 351 329.5 L 346.5 330 L 346.5 329 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1523.5 329 L 1528 329.5 L 1523.5 330 L 1523.5 329 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 356.5 330 L 361 330.5 L 356.5 331 L 356.5 330 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 1513.5 330 L 1518 330.5 L 1513.5 331 L 1513.5 330 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 1671.5 330 L 1674.5 334 L 1671.5 330 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 366.5 331 L 371 331.5 L 366.5 332 L 366.5 331 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 1503.5 331 L 1508 331.5 L 1503.5 332 L 1503.5 331 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 376.5 332 L 381 332.5 L 376.5 333 L 376.5 332 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 491.5 332 L 494.5 336 L 491.5 332 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 1048.5 332 L 1049.5 334 L 1048.5 332 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 1493.5 332 L 1498 332.5 L 1493.5 333 L 1493.5 332 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 199.5 333 L 196.5 337 L 199.5 333 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 385.5 333 L 390 333.5 L 385.5 334 L 385.5 333 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 818.5 333 L 817.5 335 L 818.5 333 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 1483.5 333 L 1488 333.5 L 1483.5 334 L 1483.5 333 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 395.5 334 L 400 334.5 L 395.5 335 L 395.5 334 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 1051.5 334 L 1053.5 337 L 1051.5 334 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 1473.5 334 L 1478 334.5 L 1473.5 335 L 1473.5 334 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 405.5 335 L 410 335.5 L 405.5 336 L 405.5 335 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 1379.5 335 L 1377.5 338 L 1379.5 335 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 1463.5 335 L 1468 335.5 L 1463.5 336 L 1463.5 335 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 415.5 336 L 420 336.5 L 415.5 337 L 415.5 336 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 814.5 336 L 812.5 339 L 814.5 336 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 1453.5 336 L 1458 336.5 L 1453.5 337 L 1453.5 336 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 1447.5 337 L 1446.5 339 L 1447.5 337 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1677.5 337 L 1679.5 340 L 1677.5 337 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 496.5 338 L 497.5 340 L 496.5 338 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 1056.5 338 L 1058.5 341 L 1056.5 338 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 194.5 339 L 192.5 342 L 194.5 339 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 429.5 339 L 430.5 341 L 429.5 339 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 1612.5 339 L 1613.5 341 L 1612.5 339 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 259.5 340 L 258.5 342 L 259.5 340 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 809.5 340 L 805.5 345 L 809.5 340 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 1375.5 340 L 1374.5 342 L 1375.5 340 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 1442.5 340 L 1441.5 342 L 1442.5 340 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 432.5 341 L 433.5 343 L 432.5 341 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 1615.5 341 L 1617.5 344 L 1615.5 341 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 1680.5 341 L 1682.5 344 L 1680.5 341 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 499.5 342 L 500.5 344 L 499.5 342 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 191.5 343 L 190.5 345 L 191.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 255.5 343 L 252.5 347 L 255.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 435.5 343 L 437.5 346 L 435.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 1062.5 343 L 1077.5 359 L 1062.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 1372.5 344 L 1371.5 346 L 1372.5 344 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 1435.5 345 L 1433.5 348 L 1435.5 345 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 1620.5 345 L 1637.5 363 L 1620.5 345 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 1683.5 345 L 1684.5 347 L 1683.5 345 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 188.5 347 L 187.5 349 L 188.5 347 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 440.5 347 L 443.5 351 L 440.5 347 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 1370.5 347 L 1369.5 349 L 1370.5 347 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 504.5 349 L 505.5 351 L 504.5 349 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 799.5 349 L 797.5 352 L 799.5 349 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 1686.5 349 L 1687.5 351 L 1686.5 349 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 247.5 350 L 241.5 357 L 247.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 1368.5 350 L 1367.5 352 L 1368.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 1429.5 350 L 1419.5 361 L 1429.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 1688.5 352 L 1689.5 354 L 1688.5 352 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 1366.5 353 L 1365.5 355 L 1366.5 353 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 1690.5 355 L 1691.5 357 L 1690.5 355 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 509.5 357 L 510.5 359 L 509.5 357 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 792.5 357 L 788.5 362 L 792.5 357 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 1363.5 358 L 1362.5 360 L 1363.5 358 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 1692.5 358 L 1693.5 360 L 1692.5 358 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 180.5 359 L 179.5 361 L 180.5 359 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 866.5 359 L 1002 359.5 L 866.5 360 L 866.5 359 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 453.5 360 L 457.5 365 L 453.5 360 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 237.5 361 L 234.5 365 L 237.5 361 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 1079.5 361 L 1082.5 365 L 1079.5 361 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 1695.5 363 L 1696.5 365 L 1695.5 363 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 513.5 364 L 514.5 366 L 513.5 364 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 786.5 364 L 784.5 367 L 786.5 364 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 1416.5 364 L 1414.5 367 L 1416.5 364 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 1639.5 365 L 1641.5 368 L 1639.5 365 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 232.5 367 L 230.5 370 L 232.5 367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 459.5 367 L 460.5 369 L 459.5 367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 851.5 367 L 850.5 369 L 851.5 367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 1084.5 367 L 1086.5 370 L 1084.5 367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 1018.5 368 L 1019.5 370 L 1018.5 368 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 1698.5 368 L 1699.5 370 L 1698.5 368 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 174.5 369 L 173.5 371 L 174.5 369 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 782.5 369 L 781.5 371 L 782.5 369 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 1412.5 369 L 1411.5 371 L 1412.5 369 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 1643.5 370 L 1644.5 372 L 1643.5 370 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 462.5 371 L 463.5 373 L 462.5 371 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 1022.5 371 L 1023.5 373 L 1022.5 371 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 1087.5 371 L 1088.5 373 L 1087.5 371 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 228.5 372 L 227.5 374 L 228.5 372 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 844.5 372 L 842.5 375 L 844.5 372 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 1410.5 372 L 1409.5 374 L 1410.5 372 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 779.5 373 L 778.5 375 L 779.5 373 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 464.5 374 L 465.5 376 L 464.5 374 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 1026.5 374 L 1029.5 378 L 1026.5 374 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 1646.5 374 L 1647.5 376 L 1646.5 374 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 226.5 375 L 225.5 377 L 226.5 375 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 1090.5 375 L 1091.5 377 L 1090.5 375 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 839.5 376 L 825.5 391 L 839.5 376 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 466.5 377 L 467.5 379 L 466.5 377 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 1648.5 377 L 1649.5 379 L 1648.5 377 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 1092.5 378 L 1093.5 380 L 1092.5 378 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 1406.5 378 L 1405.5 380 L 1406.5 378 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 1034.5 381 L 1037.5 385 L 1034.5 381 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 1094.5 381 L 1095.5 383 L 1094.5 381 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 1705.5 381 L 1706.5 383 L 1705.5 381 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 469.5 382 L 470.5 384 L 469.5 382 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 1403.5 383 L 1402.5 385 L 1403.5 383 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 1652.5 383 L 1653.5 385 L 1652.5 383 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 1096.5 384 L 1097.5 386 L 1096.5 384 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 1041.5 389 L 1045.5 394 L 1041.5 389 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 1099.5 389 L 1100.5 391 L 1099.5 389 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 823.5 393 L 821.5 396 L 823.5 393 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 1658.5 393 L 1659.5 395 L 1658.5 393 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 214.5 394 L 213.5 396 L 214.5 394 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 1047.5 396 L 1048.5 398 L 1047.5 396 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 819.5 398 L 818.5 400 L 819.5 398 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 1050.5 400 L 1051.5 402 L 1050.5 400 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 816.5 402 L 815.5 404 L 816.5 402 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 814.5 405 L 813.5 407 L 814.5 405 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 1056.5 409 L 1057.5 411 L 1056.5 409 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 809.5 413 L 808.5 415 L 809.5 413 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 804.5 422 L 803.5 424 L 804.5 422 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 538.5 430 L 539 432.5 L 538 432.5 L 538.5 430 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 1333.5 437 L 1334 439.5 L 1333 439.5 L 1333.5 437 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1381.5 438 L 1382 440.5 L 1381 440.5 L 1381.5 438 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 1332.5 442 L 1333 444.5 L 1332 444.5 L 1332.5 442 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 1379.5 447 L 1380 449.5 L 1379 449.5 L 1379.5 447 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 1331.5 448 L 1332 450.5 L 1331 450.5 L 1331.5 448 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 494.5 449 L 495 451.5 L 494 451.5 L 494.5 449 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 542.5 450 L 543 452.5 L 542 452.5 L 542.5 450 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 1378.5 452 L 1379 454.5 L 1378 454.5 L 1378.5 452 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 495.5 454 L 496 456.5 L 495 456.5 L 495.5 454 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 1330.5 454 L 1331 456.5 L 1330 456.5 L 1330.5 454 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 543.5 456 L 544 459.5 L 543 459.5 L 543.5 456 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 1377.5 457 L 1378 459.5 L 1377 459.5 L 1377.5 457 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 496.5 460 L 497 462.5 L 496 462.5 L 496.5 460 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 1329.5 460 L 1330 463.5 L 1329 463.5 L 1329.5 460 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 544.5 463 L 545 466.5 L 544 466.5 L 544.5 463 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 1376.5 463 L 1377 466.5 L 1376 466.5 L 1376.5 463 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 137.5 466 L 138 468.5 L 137 468.5 L 137.5 466 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 497.5 466 L 498 469.5 L 497 469.5 L 497.5 466 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 1328.5 468 L 1329 471.5 L 1328 471.5 L 1328.5 468 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 1736.5 468 L 1737 470.5 L 1736 470.5 L 1736.5 468 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 1375.5 470 L 1376 473.5 L 1375 473.5 L 1375.5 470 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 545.5 472 L 546 475.5 L 545 475.5 L 545.5 472 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 1132.5 472 L 1133 474.5 L 1132 474.5 L 1132.5 472 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 498.5 474 L 499 477.5 L 498 477.5 L 498.5 474 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 135.5 475 L 136 477.5 L 135 477.5 L 135.5 475 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 1327.5 477 L 1328 481.5 L 1327 481.5 L 1327.5 477 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 1690.5 477 L 1691 479.5 L 1690 479.5 L 1690.5 477 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 1374.5 478 L 1375 482.5 L 1374 482.5 L 1374.5 478 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 134.5 480 L 135 482.5 L 134 482.5 L 134.5 480 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 1134.5 481 L 1135 483.5 L 1134 483.5 L 1134.5 481 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 499.5 482 L 500 487.5 L 499 487.5 L 499.5 482 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 546.5 482 L 547 487.5 L 546 487.5 L 546.5 482 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 1739.5 482 L 1740 484.5 L 1739 484.5 L 1739.5 482 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 181.5 484 L 182 486.5 L 181 486.5 L 181.5 484 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 133.5 485 L 134 487.5 L 133 487.5 L 133.5 485 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 1135.5 486 L 1136 488.5 L 1135 488.5 L 1135.5 486 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 1692.5 486 L 1693 488.5 L 1692 488.5 L 1692.5 486 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 180.5 489 L 181 491.5 L 180 491.5 L 180.5 489 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 1326.5 489 L 1327 496.5 L 1326 496.5 L 1326.5 489 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 1373.5 489 L 1374 494.5 L 1373 494.5 L 1373.5 489 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 1136.5 491 L 1137 493.5 L 1136 493.5 L 1136.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 1693.5 491 L 1694 493.5 L 1693 493.5 L 1693.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 1741.5 493 L 1742 495.5 L 1741 495.5 L 1741.5 493 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 179.5 494 L 180 496.5 L 179 496.5 L 179.5 494 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 500.5 494 L 501 502.5 L 500 502.5 L 500.5 494 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 731.5 494 L 732 496.5 L 731 496.5 L 731.5 494 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 1089.5 495 L 1090 497.5 L 1089 497.5 L 1089.5 495 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 131.5 496 L 132 498.5 L 131 498.5 L 131.5 496 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 547.5 496 L 548 507.5 L 547 507.5 L 547.5 496 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 1694.5 496 L 1695 498.5 L 1694 498.5 L 1694.5 496 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 1137.5 497 L 1138 499.5 L 1137 499.5 L 1137.5 497 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 178.5 499 L 179 501.5 L 178 501.5 L 178.5 499 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 1742.5 499 L 1743 501.5 L 1742 501.5 L 1742.5 499 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 730.5 500 L 731 502.5 L 730 502.5 L 730.5 500 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 1090.5 500 L 1091 502.5 L 1090 502.5 L 1090.5 500 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 130.5 502 L 131 505.5 L 130 505.5 L 130.5 502 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 1695.5 502 L 1696 504.5 L 1695 504.5 L 1695.5 502 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 777.5 503 L 778 505.5 L 777 505.5 L 777.5 503 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 1138.5 503 L 1139 505.5 L 1138 505.5 L 1138.5 503 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 177.5 505 L 178 507.5 L 177 507.5 L 177.5 505 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 1372.5 505 L 1373 541.5 L 1372 541.5 L 1372.5 505 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 1743.5 505 L 1744 508.5 L 1743 508.5 L 1743.5 505 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 729.5 506 L 730 508.5 L 729 508.5 L 729.5 506 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 1091.5 506 L 1092 508.5 L 1091 508.5 L 1091.5 506 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 1696.5 507 L 1697 510.5 L 1696 510.5 L 1696.5 507 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 776.5 508 L 777 510.5 L 776 510.5 L 776.5 508 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 129.5 509 L 130 511.5 L 129 511.5 L 129.5 509 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 1139.5 509 L 1140 512.5 L 1139 512.5 L 1139.5 509 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 1325.5 510 L 1326 533.5 L 1325 533.5 L 1325.5 510 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 176.5 511 L 177 513.5 L 176 513.5 L 176.5 511 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 1092.5 512 L 1093 514.5 L 1092 514.5 L 1092.5 512 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 1744.5 512 L 1745 515.5 L 1744 515.5 L 1744.5 512 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 728.5 513 L 729 515.5 L 728 515.5 L 728.5 513 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 1697.5 514 L 1698 516.5 L 1697 516.5 L 1697.5 514 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 775.5 515 L 776 517.5 L 775 517.5 L 775.5 515 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 128.5 516 L 129 519.5 L 128 519.5 L 128.5 516 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 1140.5 516 L 1141 519.5 L 1140 519.5 L 1140.5 516 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 175.5 518 L 176 520.5 L 175 520.5 L 175.5 518 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 1093.5 518 L 1094 521.5 L 1093 521.5 L 1093.5 518 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 1745.5 519 L 1746 523.5 L 1745 523.5 L 1745.5 519 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 727.5 520 L 728 524.5 L 727 524.5 L 727.5 520 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 1698.5 521 L 1699 523.5 L 1698 523.5 L 1698.5 521 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 774.5 522 L 775 524.5 L 774 524.5 L 774.5 522 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 127.5 524 L 128 527.5 L 127 527.5 L 127.5 524 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 174.5 525 L 175 528.5 L 174 528.5 L 174.5 525 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 1141.5 525 L 1142 528.5 L 1141 528.5 L 1141.5 525 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 1094.5 526 L 1095 529.5 L 1094 529.5 L 1094.5 526 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 1699.5 528 L 1700 531.5 L 1699 531.5 L 1699.5 528 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 1746.5 528 L 1747 531.5 L 1746 531.5 L 1746.5 528 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 726.5 529 L 727 533.5 L 726 533.5 L 726.5 529 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 773.5 530 L 774 533.5 L 773 533.5 L 773.5 530 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 249.5 531 L 252 531.5 L 249.5 532 L 249.5 531 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 258.5 531 L 261 531.5 L 258.5 532 L 258.5 531 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 1461.5 531 L 1464 531.5 L 1461.5 532 L 1461.5 531 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 1470.5 531 L 1473 531.5 L 1470.5 532 L 1470.5 531 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 126.5 533 L 127 537.5 L 126 537.5 L 126.5 533 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 173.5 533 L 174 537.5 L 173 537.5 L 173.5 533 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 242.5 534 L 241.5 536 L 242.5 534 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1095.5 535 L 1096 539.5 L 1095 539.5 L 1095.5 535 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 1142.5 535 L 1143 539.5 L 1142 539.5 L 1142.5 535 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 1480.5 535 L 1481.5 537 L 1480.5 535 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 270.5 536 L 273.5 540 L 270.5 536 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 547.5 536 L 548 548.5 L 547 548.5 L 547.5 536 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 1451.5 536 L 1448.5 540 L 1451.5 536 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 1700.5 537 L 1701 541.5 L 1700 541.5 L 1700.5 537 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 1747.5 537 L 1748 542.5 L 1747 542.5 L 1747.5 537 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 772.5 539 L 773 544.5 L 772 544.5 L 772.5 539 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 1484.5 539 L 1485.5 541 L 1484.5 539 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 236.5 540 L 235.5 542 L 236.5 540 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 725.5 540 L 726 546.5 L 725 546.5 L 725.5 540 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 274.5 541 L 275.5 543 L 274.5 541 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 125.5 543 L 126 549.5 L 125 549.5 L 125.5 543 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 172.5 543 L 173 547.5 L 172 547.5 L 172.5 543 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 500.5 543 L 501 552.5 L 500 552.5 L 500.5 543 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 1096.5 546 L 1097 551.5 L 1096 551.5 L 1096.5 546 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 1143.5 547 L 1144 554.5 L 1143 554.5 L 1143.5 547 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 1701.5 547 L 1702 553.5 L 1701 553.5 L 1701.5 547 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 1326.5 548 L 1327 556.5 L 1326 556.5 L 1326.5 548 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 1489.5 548 L 1490 550.5 L 1489 550.5 L 1489.5 548 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 1443.5 550 L 1444 553.5 L 1443 553.5 L 1443.5 550 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 1748.5 550 L 1749 558.5 L 1748 558.5 L 1748.5 550 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 278.5 551 L 279 557.5 L 278 557.5 L 278.5 551 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 771.5 551 L 772 558.5 L 771 558.5 L 771.5 551 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 1373.5 552 L 1374 558.5 L 1373 558.5 L 1373.5 552 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 231.5 554 L 232 560.5 L 231 560.5 L 231.5 554 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 171.5 555 L 172 566.5 L 171 566.5 L 171.5 555 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 724.5 555 L 725 565.5 L 724 565.5 L 724.5 555 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 546.5 558 L 547 564.5 L 546 564.5 L 546.5 558 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 1489.5 559 L 1490 580.5 L 1489 580.5 L 1489.5 559 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 124.5 560 L 125 589.5 L 124 589.5 L 124.5 560 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 499.5 560 L 500 565.5 L 499 565.5 L 499.5 560 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 1097.5 561 L 1098 574.5 L 1097 574.5 L 1097.5 561 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 1442.5 562 L 1443 578.5 L 1442 578.5 L 1442.5 562 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 1327.5 564 L 1328 569.5 L 1327 569.5 L 1327.5 564 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 1702.5 564 L 1703 585.5 L 1702 585.5 L 1702.5 564 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 1374.5 565 L 1375 570.5 L 1374 570.5 L 1374.5 565 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 277.5 567 L 278 572.5 L 277 572.5 L 277.5 567 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 1144.5 567 L 1145 602.5 L 1144 602.5 L 1144.5 567 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 545.5 571 L 546 575.5 L 545 575.5 L 545.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 842.5 571 L 841.5 573 L 842.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 498.5 572 L 499 575.5 L 498 575.5 L 498.5 572 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 770.5 572 L 771 598.5 L 770 598.5 L 770.5 572 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 866.5 572 L 867.5 574 L 866.5 572 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 839.5 573 L 835.5 578 L 839.5 573 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 1328.5 576 L 1329 580.5 L 1328 580.5 L 1328.5 576 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 1375.5 576 L 1376 579.5 L 1375 579.5 L 1375.5 576 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 872.5 578 L 873.5 580 L 872.5 578 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 231.5 580 L 232 586.5 L 231 586.5 L 231.5 580 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 497.5 581 L 498 584.5 L 497 584.5 L 497.5 581 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 544.5 581 L 545 585.5 L 544 585.5 L 544.5 581 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 278.5 582 L 279 585.5 L 278 585.5 L 278.5 582 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 171.5 583 L 172 594.5 L 171 594.5 L 171.5 583 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 1376.5 584 L 1377 587.5 L 1376 587.5 L 1376.5 584 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 1329.5 585 L 1330 588.5 L 1329 588.5 L 1329.5 585 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 1490.5 586 L 1491 588.5 L 1490 588.5 L 1490.5 586 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 1443.5 587 L 1444 590.5 L 1443 590.5 L 1443.5 587 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 496.5 588 L 497 591.5 L 496 591.5 L 496.5 588 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 830.5 588 L 831 603.5 L 830 603.5 L 830.5 588 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 543.5 590 L 544 592.5 L 543 592.5 L 543.5 590 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 1377.5 591 L 1378 593.5 L 1377 593.5 L 1377.5 591 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 1748.5 591 L 1749 600.5 L 1748 600.5 L 1748.5 591 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 232.5 592 L 233 595.5 L 232 595.5 L 232.5 592 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 1491.5 592 L 1492 594.5 L 1491 594.5 L 1491.5 592 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 1330.5 593 L 1331 595.5 L 1330 595.5 L 1330.5 593 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 495.5 595 L 496 597.5 L 495 597.5 L 495.5 595 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 1444.5 595 L 1445 598.5 L 1444 598.5 L 1444.5 595 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 1097.5 596 L 1098 607.5 L 1097 607.5 L 1097.5 596 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 542.5 597 L 543 599.5 L 542 599.5 L 542.5 597 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 1378.5 597 L 1379 599.5 L 1378 599.5 L 1378.5 597 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 1701.5 597 L 1702 602.5 L 1701 602.5 L 1701.5 597 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 877.5 598 L 878 604.5 L 877 604.5 L 877.5 598 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 233.5 599 L 234 601.5 L 233 601.5 L 233.5 599 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 125.5 600 L 126 606.5 L 125 606.5 L 125.5 600 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 1331.5 600 L 1332 602.5 L 1331 602.5 L 1331.5 600 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_823"
          d="M 172.5 602 L 173 607.5 L 172 607.5 L 172.5 602 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_824"
          d="M 541.5 603 L 542 605.5 L 541 605.5 L 541.5 603 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_825"
          d="M 1379.5 603 L 1380 605.5 L 1379 605.5 L 1379.5 603 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_826"
          d="M 234.5 604 L 235 606.5 L 234 606.5 L 234.5 604 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_827"
          d="M 724.5 604 L 725 612.5 L 724 612.5 L 724.5 604 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_828"
          d="M 1332.5 606 L 1333 608.5 L 1332 608.5 L 1332.5 606 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_829"
          d="M 1747.5 607 L 1748 612.5 L 1747 612.5 L 1747.5 607 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_830"
          d="M 540.5 609 L 541 611.5 L 540 611.5 L 540.5 609 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_831"
          d="M 771.5 609 L 772 615.5 L 771 615.5 L 771.5 609 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_832"
          d="M 1700.5 609 L 1701 612.5 L 1700 612.5 L 1700.5 609 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_833"
          d="M 831.5 610 L 832 614.5 L 831 614.5 L 831.5 610 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_834"
          d="M 878.5 610 L 879 612.5 L 878 612.5 L 878.5 610 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_835"
          d="M 1333.5 611 L 1334 613.5 L 1333 613.5 L 1333.5 611 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_836"
          d="M 126.5 612 L 127 616.5 L 126 616.5 L 126.5 612 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_837"
          d="M 173.5 612 L 174 615.5 L 173 615.5 L 173.5 612 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_838"
          d="M 1143.5 613 L 1144 618.5 L 1143 618.5 L 1143.5 613 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_839"
          d="M 539.5 614 L 540 616.5 L 539 616.5 L 539.5 614 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_840"
          d="M 1096.5 615 L 1097 619.5 L 1096 619.5 L 1096.5 615 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_841"
          d="M 1699.5 617 L 1700 620.5 L 1699 620.5 L 1699.5 617 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_842"
          d="M 1746.5 617 L 1747 621.5 L 1746 621.5 L 1746.5 617 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_843"
          d="M 538.5 619 L 539 621.5 L 538 621.5 L 538.5 619 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_844"
          d="M 832.5 619 L 833 621.5 L 832 621.5 L 832.5 619 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_845"
          d="M 174.5 620 L 175 623.5 L 174 623.5 L 174.5 620 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_846"
          d="M 725.5 620 L 726 624.5 L 725 624.5 L 725.5 620 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_847"
          d="M 127.5 621 L 128 624.5 L 127 624.5 L 127.5 621 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_848"
          d="M 772.5 621 L 773 625.5 L 772 625.5 L 772.5 621 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_849"
          d="M 1335.5 621 L 1336 623.5 L 1335 623.5 L 1335.5 621 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_850"
          d="M 1502.5 624 L 1503.5 626 L 1502.5 624 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_851"
          d="M 1698.5 624 L 1699 626.5 L 1698 626.5 L 1698.5 624 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_852"
          d="M 291.5 625 L 292.5 627 L 291.5 625 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_853"
          d="M 833.5 625 L 834 627.5 L 833 627.5 L 833.5 625 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_854"
          d="M 1095.5 625 L 1096 628.5 L 1095 628.5 L 1095.5 625 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_855"
          d="M 1142.5 625 L 1143 629.5 L 1142 629.5 L 1142.5 625 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_856"
          d="M 1745.5 625 L 1746 628.5 L 1745 628.5 L 1745.5 625 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_857"
          d="M 175.5 627 L 176 629.5 L 175 629.5 L 175.5 627 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_858"
          d="M 293.5 628 L 294.5 630 L 293.5 628 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_859"
          d="M 128.5 629 L 129 631.5 L 128 631.5 L 128.5 629 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_860"
          d="M 726.5 630 L 727 633.5 L 726 633.5 L 726.5 630 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_861"
          d="M 773.5 630 L 774 633.5 L 773 633.5 L 773.5 630 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_862"
          d="M 1506.5 630 L 1507.5 632 L 1506.5 630 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_863"
          d="M 1697.5 630 L 1698 632.5 L 1697 632.5 L 1697.5 630 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_864"
          d="M 295.5 631 L 297.5 634 L 295.5 631 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_865"
          d="M 1744.5 632 L 1745 634.5 L 1744 634.5 L 1744.5 632 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_866"
          d="M 1094.5 633 L 1095 636.5 L 1094 636.5 L 1094.5 633 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_867"
          d="M 1141.5 634 L 1142 637.5 L 1141 637.5 L 1141.5 634 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_868"
          d="M 1509.5 634 L 1517.5 643 L 1509.5 634 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_869"
          d="M 129.5 635 L 130 637.5 L 129 637.5 L 129.5 635 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_870"
          d="M 299.5 636 L 303.5 641 L 299.5 636 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_871"
          d="M 774.5 637 L 775 640.5 L 774 640.5 L 774.5 637 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_872"
          d="M 727.5 638 L 728 641.5 L 727 641.5 L 727.5 638 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_873"
          d="M 1743.5 638 L 1744 640.5 L 1743 640.5 L 1743.5 638 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_874"
          d="M 1093.5 640 L 1094 642.5 L 1093 642.5 L 1093.5 640 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_875"
          d="M 130.5 641 L 131 643.5 L 130 643.5 L 130.5 641 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_876"
          d="M 306.5 642 L 307.5 644 L 306.5 642 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_877"
          d="M 1140.5 642 L 1141 644.5 L 1140 644.5 L 1140.5 642 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_878"
          d="M 775.5 644 L 776 646.5 L 775 646.5 L 775.5 644 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_879"
          d="M 728.5 645 L 729 647.5 L 728 647.5 L 728.5 645 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_880"
          d="M 1522.5 645 L 1523.5 647 L 1522.5 645 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_881"
          d="M 131.5 646 L 132 648.5 L 131 648.5 L 131.5 646 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_882"
          d="M 1092.5 646 L 1093 648.5 L 1092 648.5 L 1092.5 646 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_883"
          d="M 1139.5 648 L 1140 650.5 L 1139 650.5 L 1139.5 648 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_884"
          d="M 776.5 649 L 777 651.5 L 776 651.5 L 776.5 649 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_885"
          d="M 322.5 650 L 325 650.5 L 322.5 651 L 322.5 650 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_886"
          d="M 328.5 651 L 331 651.5 L 328.5 652 L 328.5 651 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_887"
          d="M 729.5 651 L 730 653.5 L 729 653.5 L 729.5 651 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_888"
          d="M 1091.5 651 L 1092 653.5 L 1091 653.5 L 1091.5 651 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_889"
          d="M 892.5 652 L 893.5 654 L 892.5 652 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_890"
          d="M 1464.5 652 L 1465.5 654 L 1464.5 652 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_891"
          d="M 777.5 654 L 778 656.5 L 777 656.5 L 777.5 654 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_892"
          d="M 1138.5 654 L 1139 656.5 L 1138 656.5 L 1138.5 654 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_893"
          d="M 1548.5 654 L 1550.5 657 L 1548.5 654 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_894"
          d="M 1466.5 655 L 1467.5 657 L 1466.5 655 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_895"
          d="M 339.5 656 L 341.5 659 L 339.5 656 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_896"
          d="M 1090.5 656 L 1091 658.5 L 1090 658.5 L 1090.5 656 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_897"
          d="M 730.5 657 L 731 659.5 L 730 659.5 L 730.5 657 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_898"
          d="M 896.5 658 L 897.5 660 L 896.5 658 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_899"
          d="M 1468.5 658 L 1470.5 661 L 1468.5 658 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_900"
          d="M 1137.5 659 L 1138 661.5 L 1137 661.5 L 1137.5 659 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_901"
          d="M 1553.5 659 L 1554.5 661 L 1553.5 659 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_902"
          d="M 258.5 660 L 260.5 663 L 258.5 660 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_903"
          d="M 343.5 661 L 344.5 663 L 343.5 661 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_904"
          d="M 731.5 662 L 732 664.5 L 731 664.5 L 731.5 662 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_905"
          d="M 899.5 662 L 908.5 672 L 899.5 662 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_906"
          d="M 1471.5 662 L 1474.5 666 L 1471.5 662 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_907"
          d="M 779.5 663 L 780 665.5 L 779 665.5 L 779.5 663 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_908"
          d="M 1136.5 664 L 1137 666.5 L 1136 666.5 L 1136.5 664 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_909"
          d="M 262.5 665 L 274.5 678 L 262.5 665 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_910"
          d="M 1558.5 668 L 1559 670.5 L 1558 670.5 L 1558.5 668 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_911"
          d="M 848.5 670 L 849.5 672 L 848.5 670 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_912"
          d="M 1478.5 670 L 1481.5 674 L 1478.5 670 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_913"
          d="M 733.5 671 L 734 673.5 L 733 673.5 L 733.5 671 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_914"
          d="M 347.5 672 L 348 676.5 L 347 676.5 L 347.5 672 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_915"
          d="M 911.5 673 L 912.5 675 L 911.5 673 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_916"
          d="M 1485.5 676 L 1488.5 680 L 1485.5 676 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_917"
          d="M 852.5 677 L 853.5 679 L 852.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_918"
          d="M 1558.5 677 L 1559 679.5 L 1558 679.5 L 1558.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_919"
          d="M 277.5 679 L 278.5 681 L 277.5 679 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_920"
          d="M 854.5 680 L 855.5 682 L 854.5 680 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_921"
          d="M 1490.5 680 L 1491.5 682 L 1490.5 680 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_922"
          d="M 932.5 681 L 939 681.5 L 932.5 682 L 932.5 681 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_923"
          d="M 281.5 682 L 282.5 684 L 281.5 682 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_924"
          d="M 856.5 683 L 857.5 685 L 856.5 683 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_925"
          d="M 946.5 684 L 947.5 686 L 946.5 684 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_926"
          d="M 858.5 686 L 860.5 689 L 858.5 686 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_927"
          d="M 1499.5 686 L 1500.5 688 L 1499.5 686 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_928"
          d="M 343.5 687 L 341.5 690 L 343.5 687 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_929"
          d="M 950.5 687 L 951.5 689 L 950.5 687 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_930"
          d="M 1553.5 689 L 1550.5 693 L 1553.5 689 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_931"
          d="M 861.5 690 L 864.5 694 L 861.5 690 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_932"
          d="M 339.5 691 L 337.5 694 L 339.5 691 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_933"
          d="M 1520.5 695 L 1523 695.5 L 1520.5 696 L 1520.5 695 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_934"
          d="M 313.5 696 L 316 696.5 L 313.5 697 L 313.5 696 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_935"
          d="M 1525.5 696 L 1528 696.5 L 1525.5 697 L 1525.5 696 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_936"
          d="M 319.5 697 L 328 697.5 L 319.5 698 L 319.5 697 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_937"
          d="M 867.5 697 L 873.5 704 L 867.5 697 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_938"
          d="M 1531.5 697 L 1540 697.5 L 1531.5 698 L 1531.5 697 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_939"
          d="M 1413.5 698 L 1414.5 700 L 1413.5 698 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_940"
          d="M 459.5 699 L 458.5 701 L 459.5 699 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_941"
          d="M 957.5 701 L 958 708.5 L 957 708.5 L 957.5 701 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_942"
          d="M 1416.5 703 L 1417.5 705 L 1416.5 703 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_943"
          d="M 456.5 704 L 455.5 706 L 456.5 704 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_944"
          d="M 877.5 706 L 879.5 709 L 877.5 706 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_945"
          d="M 1419.5 708 L 1420.5 710 L 1419.5 708 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_946"
          d="M 882.5 710 L 883.5 712 L 882.5 710 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_947"
          d="M 1421.5 711 L 1422.5 713 L 1421.5 711 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_948"
          d="M 451.5 712 L 450.5 714 L 451.5 712 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_949"
          d="M 885.5 712 L 886.5 714 L 885.5 712 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_950"
          d="M 888.5 714 L 889.5 716 L 888.5 714 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_951"
          d="M 1423.5 714 L 1424.5 716 L 1423.5 714 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_952"
          d="M 205.5 715 L 206.5 717 L 205.5 715 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_953"
          d="M 449.5 715 L 448.5 717 L 449.5 715 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_954"
          d="M 1667.5 716 L 1666.5 718 L 1667.5 716 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_955"
          d="M 1425.5 717 L 1426.5 719 L 1425.5 717 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_956"
          d="M 446.5 719 L 445.5 721 L 446.5 719 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_957"
          d="M 952.5 719 L 948.5 724 L 952.5 719 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_958"
          d="M 208.5 720 L 209.5 722 L 208.5 720 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_959"
          d="M 1428.5 721 L 1429.5 723 L 1428.5 721 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_960"
          d="M 1664.5 721 L 1663.5 723 L 1664.5 721 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_961"
          d="M 444.5 722 L 443.5 724 L 444.5 722 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_962"
          d="M 1430.5 724 L 1432.5 727 L 1430.5 724 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_963"
          d="M 498.5 725 L 497.5 727 L 498.5 725 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_964"
          d="M 441.5 726 L 439.5 729 L 441.5 726 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_965"
          d="M 923.5 727 L 927 727.5 L 923.5 728 L 923.5 727 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_966"
          d="M 213.5 728 L 214.5 730 L 213.5 728 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_967"
          d="M 1377.5 729 L 1378.5 731 L 1377.5 729 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_968"
          d="M 1434.5 729 L 1435.5 731 L 1434.5 729 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_969"
          d="M 495.5 730 L 494.5 732 L 495.5 730 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_970"
          d="M 437.5 731 L 435.5 734 L 437.5 731 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_971"
          d="M 1656.5 733 L 1655.5 735 L 1656.5 733 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_972"
          d="M 1438.5 734 L 1441.5 738 L 1438.5 734 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_973"
          d="M 218.5 735 L 219.5 737 L 218.5 735 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_974"
          d="M 433.5 736 L 428.5 742 L 433.5 736 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_975"
          d="M 1382.5 737 L 1383.5 739 L 1382.5 737 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_976"
          d="M 1653.5 737 L 1652.5 739 L 1653.5 737 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_977"
          d="M 221.5 739 L 223.5 742 L 221.5 739 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_978"
          d="M 1384.5 740 L 1385.5 742 L 1384.5 740 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_979"
          d="M 1444.5 741 L 1458.5 756 L 1444.5 741 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_980"
          d="M 1650.5 741 L 1648.5 744 L 1650.5 741 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_981"
          d="M 1706.5 742 L 1705.5 744 L 1706.5 742 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_982"
          d="M 1057.5 743 L 1056.5 745 L 1057.5 743 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_983"
          d="M 1386.5 743 L 1387.5 745 L 1386.5 743 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_984"
          d="M 225.5 744 L 228.5 748 L 225.5 744 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_985"
          d="M 811.5 744 L 812.5 746 L 811.5 744 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_986"
          d="M 485.5 745 L 484.5 747 L 485.5 745 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_987"
          d="M 169.5 746 L 170.5 748 L 169.5 746 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_988"
          d="M 1646.5 746 L 1629.5 764 L 1646.5 746 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_989"
          d="M 1389.5 747 L 1390.5 749 L 1389.5 747 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_990"
          d="M 1703.5 747 L 1702.5 749 L 1703.5 747 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_991"
          d="M 483.5 748 L 482.5 750 L 483.5 748 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_992"
          d="M 1391.5 750 L 1392.5 752 L 1391.5 750 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_993"
          d="M 1052.5 751 L 1051.5 753 L 1052.5 751 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_994"
          d="M 232.5 752 L 239.5 760 L 232.5 752 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_995"
          d="M 480.5 752 L 479.5 754 L 480.5 752 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_996"
          d="M 1050.5 754 L 1049.5 756 L 1050.5 754 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_997"
          d="M 1394.5 754 L 1396.5 757 L 1394.5 754 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_998"
          d="M 414.5 755 L 410.5 760 L 414.5 755 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_999"
          d="M 477.5 756 L 475.5 759 L 477.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1000"
          d="M 819.5 756 L 820.5 758 L 819.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1001"
          d="M 1697.5 756 L 1696.5 758 L 1697.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1002"
          d="M 1047.5 758 L 1046.5 760 L 1047.5 758 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1003"
          d="M 1462.5 758 L 1465.5 762 L 1462.5 758 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1004"
          d="M 821.5 759 L 822.5 761 L 821.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1005"
          d="M 1398.5 759 L 1400.5 762 L 1398.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1006"
          d="M 1695.5 759 L 1694.5 761 L 1695.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1007"
          d="M 179.5 761 L 180.5 763 L 179.5 761 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1008"
          d="M 407.5 761 L 405.5 764 L 407.5 761 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1009"
          d="M 473.5 761 L 471.5 764 L 473.5 761 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1010"
          d="M 1045.5 761 L 1043.5 764 L 1045.5 761 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1011"
          d="M 243.5 762 L 246.5 766 L 243.5 762 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1012"
          d="M 824.5 763 L 826.5 766 L 824.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1013"
          d="M 1099.5 763 L 1098.5 765 L 1099.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1014"
          d="M 1468.5 763 L 1470.5 766 L 1468.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1015"
          d="M 1692.5 763 L 1691.5 765 L 1692.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1016"
          d="M 1402.5 764 L 1405.5 768 L 1402.5 764 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1017"
          d="M 182.5 765 L 183.5 767 L 182.5 765 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1018"
          d="M 402.5 765 L 401.5 767 L 402.5 765 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1019"
          d="M 1042.5 765 L 1040.5 768 L 1042.5 765 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1020"
          d="M 1625.5 766 L 1623.5 769 L 1625.5 766 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1021"
          d="M 1690.5 766 L 1688.5 769 L 1690.5 766 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1022"
          d="M 249.5 767 L 251.5 770 L 249.5 767 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1023"
          d="M 468.5 767 L 464.5 772 L 468.5 767 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1024"
          d="M 827.5 767 L 830.5 771 L 827.5 767 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1025"
          d="M 1473.5 767 L 1474.5 769 L 1473.5 767 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1026"
          d="M 398.5 768 L 397.5 770 L 398.5 768 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1027"
          d="M 185.5 769 L 187.5 772 L 185.5 769 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1028"
          d="M 1476.5 769 L 1477.5 771 L 1476.5 769 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1029"
          d="M 1621.5 769 L 1619.5 772 L 1621.5 769 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1030"
          d="M 395.5 770 L 394.5 772 L 395.5 770 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1031"
          d="M 254.5 771 L 255.5 773 L 254.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1032"
          d="M 1037.5 771 L 1034.5 775 L 1037.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1033"
          d="M 1094.5 771 L 1093.5 773 L 1094.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1034"
          d="M 1408.5 771 L 1428.5 792 L 1408.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1035"
          d="M 1479.5 771 L 1480.5 773 L 1479.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1036"
          d="M 1686.5 771 L 1684.5 774 L 1686.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1037"
          d="M 392.5 772 L 391.5 774 L 392.5 772 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1038"
          d="M 774.5 772 L 775.5 774 L 774.5 772 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1039"
          d="M 1617.5 772 L 1616.5 774 L 1617.5 772 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1040"
          d="M 257.5 773 L 258.5 775 L 257.5 773 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1041"
          d="M 832.5 773 L 850.5 792 L 832.5 773 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1042"
          d="M 1482.5 773 L 1483.5 775 L 1482.5 773 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1043"
          d="M 189.5 774 L 192.5 778 L 189.5 774 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1044"
          d="M 1614.5 774 L 1613.5 776 L 1614.5 774 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1045"
          d="M 776.5 775 L 777.5 777 L 776.5 775 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1046"
          d="M 460.5 776 L 449.5 788 L 460.5 776 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1047"
          d="M 1682.5 776 L 1677.5 782 L 1682.5 776 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1048"
          d="M 778.5 778 L 779.5 780 L 778.5 778 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1049"
          d="M 1030.5 779 L 1023.5 787 L 1030.5 779 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1050"
          d="M 195.5 781 L 210.5 797 L 195.5 781 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1051"
          d="M 780.5 781 L 781.5 783 L 780.5 781 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1052"
          d="M 1086.5 783 L 1085.5 785 L 1086.5 783 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1053"
          d="M 783.5 785 L 784.5 787 L 783.5 785 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1054"
          d="M 1083.5 787 L 1082.5 789 L 1083.5 787 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1055"
          d="M 1672.5 787 L 1668.5 792 L 1672.5 787 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1056"
          d="M 785.5 788 L 786.5 790 L 785.5 788 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1057"
          d="M 1018.5 790 L 1015.5 794 L 1018.5 790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1058"
          d="M 1081.5 790 L 1079.5 793 L 1081.5 790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1059"
          d="M 444.5 791 L 440.5 796 L 444.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1060"
          d="M 1574.5 791 L 1577 791.5 L 1574.5 792 L 1574.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1061"
          d="M 788.5 792 L 790.5 795 L 788.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1062"
          d="M 1528.5 792 L 1531 792.5 L 1528.5 793 L 1528.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1063"
          d="M 1569.5 792 L 1572 792.5 L 1569.5 793 L 1569.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1064"
          d="M 307.5 793 L 311 793.5 L 307.5 794 L 307.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1065"
          d="M 336.5 793 L 339 793.5 L 336.5 794 L 336.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1066"
          d="M 1534.5 793 L 1538 793.5 L 1534.5 794 L 1534.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1067"
          d="M 1562.5 793 L 1566 793.5 L 1562.5 794 L 1562.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1068"
          d="M 317.5 794 L 330 794.5 L 317.5 795 L 317.5 794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1069"
          d="M 854.5 794 L 856.5 797 L 854.5 794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1070"
          d="M 1432.5 794 L 1435.5 798 L 1432.5 794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1071"
          d="M 1544.5 794 L 1556 794.5 L 1544.5 795 L 1544.5 794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1072"
          d="M 1012.5 795 L 1010.5 798 L 1012.5 795 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1073"
          d="M 1077.5 795 L 1075.5 798 L 1077.5 795 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1074"
          d="M 1663.5 795 L 1658.5 801 L 1663.5 795 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1075"
          d="M 437.5 797 L 435.5 800 L 437.5 797 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1076"
          d="M 792.5 797 L 794.5 800 L 792.5 797 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1077"
          d="M 859.5 798 L 860.5 800 L 859.5 798 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1078"
          d="M 214.5 799 L 217.5 803 L 214.5 799 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1079"
          d="M 1007.5 799 L 1006.5 801 L 1007.5 799 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1080"
          d="M 1438.5 799 L 1440.5 802 L 1438.5 799 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1081"
          d="M 862.5 800 L 863.5 802 L 862.5 800 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1082"
          d="M 1073.5 800 L 1070.5 804 L 1073.5 800 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1083"
          d="M 432.5 801 L 431.5 803 L 432.5 801 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1084"
          d="M 1004.5 801 L 1003.5 803 L 1004.5 801 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1085"
          d="M 1655.5 802 L 1653.5 805 L 1655.5 802 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1086"
          d="M 797.5 803 L 802.5 809 L 797.5 803 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1087"
          d="M 1443.5 803 L 1444.5 805 L 1443.5 803 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1088"
          d="M 220.5 804 L 221.5 806 L 220.5 804 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1089"
          d="M 428.5 804 L 427.5 806 L 428.5 804 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1090"
          d="M 998.5 805 L 997.5 807 L 998.5 805 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1091"
          d="M 1650.5 806 L 1649.5 808 L 1650.5 806 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1092"
          d="M 224.5 807 L 225.5 809 L 224.5 807 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1093"
          d="M 424.5 807 L 423.5 809 L 424.5 807 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1094"
          d="M 1067.5 807 L 1050.5 825 L 1067.5 807 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1095"
          d="M 1450.5 808 L 1451.5 810 L 1450.5 808 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1096"
          d="M 421.5 809 L 420.5 811 L 421.5 809 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1097"
          d="M 1646.5 809 L 1645.5 811 L 1646.5 809 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1098"
          d="M 228.5 810 L 229.5 812 L 228.5 810 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1099"
          d="M 1453.5 810 L 1454.5 812 L 1453.5 810 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1100"
          d="M 418.5 811 L 417.5 813 L 418.5 811 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1101"
          d="M 1643.5 811 L 1642.5 813 L 1643.5 811 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1102"
          d="M 231.5 812 L 232.5 814 L 231.5 812 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1103"
          d="M 1640.5 813 L 1639.5 815 L 1640.5 813 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1104"
          d="M 234.5 814 L 235.5 816 L 234.5 814 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1105"
          d="M 807.5 814 L 811.5 819 L 807.5 814 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1106"
          d="M 1461.5 815 L 1462.5 817 L 1461.5 815 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1107"
          d="M 1637.5 815 L 1636.5 817 L 1637.5 815 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1108"
          d="M 239.5 817 L 240.5 819 L 239.5 817 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1109"
          d="M 1632.5 818 L 1631.5 820 L 1632.5 818 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1110"
          d="M 1468.5 819 L 1469.5 821 L 1468.5 819 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1111"
          d="M 817.5 823 L 821.5 828 L 817.5 823 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1112"
          d="M 915.5 823 L 918 823.5 L 915.5 824 L 915.5 823 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1113"
          d="M 950.5 823 L 953 823.5 L 950.5 824 L 950.5 823 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1114"
          d="M 922.5 824 L 929 824.5 L 922.5 825 L 922.5 824 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1115"
          d="M 940.5 824 L 946 824.5 L 940.5 825 L 940.5 824 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1116"
          d="M 1046.5 827 L 1043.5 831 L 1046.5 827 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1117"
          d="M 825.5 830 L 827.5 833 L 825.5 830 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1118"
          d="M 1040.5 832 L 1038.5 835 L 1040.5 832 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1119"
          d="M 830.5 834 L 831.5 836 L 830.5 834 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1120"
          d="M 1036.5 835 L 1034.5 838 L 1036.5 835 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1121"
          d="M 288.5 837 L 291 837.5 L 288.5 838 L 288.5 837 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1122"
          d="M 356.5 837 L 359 837.5 L 356.5 838 L 356.5 837 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1123"
          d="M 834.5 837 L 835.5 839 L 834.5 837 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1124"
          d="M 293.5 838 L 296 838.5 L 293.5 839 L 293.5 838 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1125"
          d="M 351.5 838 L 354 838.5 L 351.5 839 L 351.5 838 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1126"
          d="M 1032.5 838 L 1031.5 840 L 1032.5 838 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1127"
          d="M 1578.5 838 L 1581 838.5 L 1578.5 839 L 1578.5 838 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1128"
          d="M 299.5 839 L 303 839.5 L 299.5 840 L 299.5 839 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1129"
          d="M 344.5 839 L 348 839.5 L 344.5 840 L 344.5 839 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1130"
          d="M 1526.5 839 L 1529 839.5 L 1526.5 840 L 1526.5 839 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1131"
          d="M 1571.5 839 L 1575 839.5 L 1571.5 840 L 1571.5 839 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1132"
          d="M 307.5 840 L 313 840.5 L 307.5 841 L 307.5 840 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1133"
          d="M 334.5 840 L 340 840.5 L 334.5 841 L 334.5 840 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1134"
          d="M 1533.5 840 L 1539 840.5 L 1533.5 841 L 1533.5 840 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1135"
          d="M 1561.5 840 L 1567 840.5 L 1561.5 841 L 1561.5 840 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1136"
          d="M 1020.5 846 L 1019.5 848 L 1020.5 846 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1137"
          d="M 1013.5 850 L 1012.5 852 L 1013.5 850 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1138"
          d="M 964.5 868 L 967 868.5 L 964.5 869 L 964.5 868 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1139"
          d="M 907.5 869 L 910 869.5 L 907.5 870 L 907.5 869 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1140"
          d="M 959.5 869 L 962 869.5 L 959.5 870 L 959.5 869 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1141"
          d="M 913.5 870 L 918 870.5 L 913.5 871 L 913.5 870 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1142"
          d="M 951.5 870 L 955 870.5 L 951.5 871 L 951.5 870 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1143"
          d="M 924.5 871 L 945 871.5 L 924.5 872 L 924.5 871 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1144"
          d="M 1838.5 996 L 1841 996.5 L 1838.5 997 L 1838.5 996 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1145"
          d="M 18.5 997 L 21 997.5 L 18.5 998 L 18.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1146"
          d="M 1833.5 997 L 1836 997.5 L 1833.5 998 L 1833.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1147"
          d="M 1828.5 998 L 1831 998.5 L 1828.5 999 L 1828.5 998 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1148"
          d="M 11.5 1000 L 10.5 1002 L 11.5 1000 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1149"
          d="M 42.5 1000 L 45 1000.5 L 42.5 1001 L 42.5 1000 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1150"
          d="M 1858.5 1000 L 1862.5 1005 L 1858.5 1000 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1151"
          d="M 47.5 1001 L 50 1001.5 L 47.5 1002 L 47.5 1001 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1152"
          d="M 52.5 1002 L 55 1002.5 L 52.5 1003 L 52.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1153"
          d="M 57.5 1003 L 60 1003.5 L 57.5 1004 L 57.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1154"
          d="M 62.5 1004 L 65 1004.5 L 62.5 1005 L 62.5 1004 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1155"
          d="M 67.5 1005 L 70 1005.5 L 67.5 1006 L 67.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1156"
          d="M 5.5 1006 L 4.5 1008 L 5.5 1006 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1157"
          d="M 1788.5 1006 L 1791 1006.5 L 1788.5 1007 L 1788.5 1006 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1158"
          d="M 1783.5 1007 L 1786 1007.5 L 1783.5 1008 L 1783.5 1007 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1159"
          d="M 83.5 1008 L 86 1008.5 L 83.5 1009 L 83.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1160"
          d="M 1778.5 1008 L 1781 1008.5 L 1778.5 1009 L 1778.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1161"
          d="M 88.5 1009 L 91 1009.5 L 88.5 1010 L 88.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1162"
          d="M 93.5 1010 L 96 1010.5 L 93.5 1011 L 93.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1163"
          d="M 1762.5 1011 L 1765 1011.5 L 1762.5 1012 L 1762.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1164"
          d="M 104.5 1012 L 107 1012.5 L 104.5 1013 L 104.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1165"
          d="M 1757.5 1012 L 1760 1012.5 L 1757.5 1013 L 1757.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1166"
          d="M 109.5 1013 L 112 1013.5 L 109.5 1014 L 109.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1167"
          d="M 1746.5 1014 L 1749 1014.5 L 1746.5 1015 L 1746.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1168"
          d="M 120.5 1015 L 123 1015.5 L 120.5 1016 L 120.5 1015 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1169"
          d="M 1867.5 1015 L 1868 1023.5 L 1867 1023.5 L 1867.5 1015 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1170"
          d="M 1735.5 1016 L 1738 1016.5 L 1735.5 1017 L 1735.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1171"
          d="M 131.5 1017 L 134 1017.5 L 131.5 1018 L 131.5 1017 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1172"
          d="M 137.5 1018 L 140 1018.5 L 137.5 1019 L 137.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1173"
          d="M 1724.5 1018 L 1727 1018.5 L 1724.5 1019 L 1724.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1174"
          d="M 142.5 1019 L 145 1019.5 L 142.5 1020 L 142.5 1019 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1175"
          d="M 1718.5 1019 L 1721 1019.5 L 1718.5 1020 L 1718.5 1019 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1176"
          d="M 148.5 1020 L 151 1020.5 L 148.5 1021 L 148.5 1020 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1177"
          d="M 1713.5 1020 L 1716 1020.5 L 1713.5 1021 L 1713.5 1020 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1178"
          d="M 154.5 1021 L 157 1021.5 L 154.5 1022 L 154.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1179"
          d="M 1707.5 1021 L 1710 1021.5 L 1707.5 1022 L 1707.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1180"
          d="M 159.5 1022 L 162 1022.5 L 159.5 1023 L 159.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1181"
          d="M 1701.5 1022 L 1704 1022.5 L 1701.5 1023 L 1701.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1182"
          d="M 165.5 1023 L 168 1023.5 L 165.5 1024 L 165.5 1023 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1183"
          d="M 1695.5 1023 L 1698 1023.5 L 1695.5 1024 L 1695.5 1023 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1184"
          d="M 171.5 1024 L 174 1024.5 L 171.5 1025 L 171.5 1024 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1185"
          d="M 177.5 1025 L 180 1025.5 L 177.5 1026 L 177.5 1025 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1186"
          d="M 1684.5 1025 L 1687 1025.5 L 1684.5 1026 L 1684.5 1025 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1187"
          d="M 183.5 1026 L 186 1026.5 L 183.5 1027 L 183.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1188"
          d="M 1678.5 1026 L 1681 1026.5 L 1678.5 1027 L 1678.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1189"
          d="M 189.5 1027 L 192 1027.5 L 189.5 1028 L 189.5 1027 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1190"
          d="M 1672.5 1027 L 1675 1027.5 L 1672.5 1028 L 1672.5 1027 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1191"
          d="M 195.5 1028 L 198 1028.5 L 195.5 1029 L 195.5 1028 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1192"
          d="M 1665.5 1028 L 1669 1028.5 L 1665.5 1029 L 1665.5 1028 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1193"
          d="M 201.5 1029 L 204 1029.5 L 201.5 1030 L 201.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1194"
          d="M 1659.5 1029 L 1662 1029.5 L 1659.5 1030 L 1659.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1195"
          d="M 207.5 1030 L 210 1030.5 L 207.5 1031 L 207.5 1030 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1196"
          d="M 1653.5 1030 L 1656 1030.5 L 1653.5 1031 L 1653.5 1030 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1197"
          d="M 214.5 1031 L 217 1031.5 L 214.5 1032 L 214.5 1031 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1198"
          d="M 1647.5 1031 L 1650 1031.5 L 1647.5 1032 L 1647.5 1031 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1199"
          d="M 1864.5 1031 L 1863.5 1033 L 1864.5 1031 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1200"
          d="M 220.5 1032 L 223 1032.5 L 220.5 1033 L 220.5 1032 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1201"
          d="M 1641.5 1032 L 1644 1032.5 L 1641.5 1033 L 1641.5 1032 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1202"
          d="M 226.5 1033 L 229 1033.5 L 226.5 1034 L 226.5 1033 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1203"
          d="M 1634.5 1033 L 1637 1033.5 L 1634.5 1034 L 1634.5 1033 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1204"
          d="M 5.5 1034 L 10.5 1040 L 5.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1205"
          d="M 233.5 1034 L 236 1034.5 L 233.5 1035 L 233.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1206"
          d="M 1628.5 1034 L 1631 1034.5 L 1628.5 1035 L 1628.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1207"
          d="M 1862.5 1034 L 1859.5 1038 L 1862.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1208"
          d="M 239.5 1035 L 242 1035.5 L 239.5 1036 L 239.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1209"
          d="M 1621.5 1035 L 1624 1035.5 L 1621.5 1036 L 1621.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1210"
          d="M 246.5 1036 L 249 1036.5 L 246.5 1037 L 246.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1211"
          d="M 1615.5 1036 L 1618 1036.5 L 1615.5 1037 L 1615.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1212"
          d="M 252.5 1037 L 256 1037.5 L 252.5 1038 L 252.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1213"
          d="M 1608.5 1037 L 1611 1037.5 L 1608.5 1038 L 1608.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1214"
          d="M 259.5 1038 L 262 1038.5 L 259.5 1039 L 259.5 1038 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1215"
          d="M 1601.5 1038 L 1605 1038.5 L 1601.5 1039 L 1601.5 1038 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1216"
          d="M 1857.5 1038 L 1856.5 1040 L 1857.5 1038 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1217"
          d="M 266.5 1039 L 269 1039.5 L 266.5 1040 L 266.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1218"
          d="M 1594.5 1039 L 1598 1039.5 L 1594.5 1040 L 1594.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1219"
          d="M 273.5 1040 L 276 1040.5 L 273.5 1041 L 273.5 1040 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1220"
          d="M 1588.5 1040 L 1591 1040.5 L 1588.5 1041 L 1588.5 1040 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1221"
          d="M 280.5 1041 L 283 1041.5 L 280.5 1042 L 280.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1222"
          d="M 1581.5 1041 L 1584 1041.5 L 1581.5 1042 L 1581.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1223"
          d="M 287.5 1042 L 290 1042.5 L 287.5 1043 L 287.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1224"
          d="M 1573.5 1042 L 1577 1042.5 L 1573.5 1043 L 1573.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1225"
          d="M 19.5 1043 L 22 1043.5 L 19.5 1044 L 19.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1226"
          d="M 294.5 1043 L 297 1043.5 L 294.5 1044 L 294.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1227"
          d="M 1566.5 1043 L 1570 1043.5 L 1566.5 1044 L 1566.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1228"
          d="M 24.5 1044 L 27 1044.5 L 24.5 1045 L 24.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1229"
          d="M 301.5 1044 L 304 1044.5 L 301.5 1045 L 301.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1230"
          d="M 1559.5 1044 L 1563 1044.5 L 1559.5 1045 L 1559.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1231"
          d="M 1837.5 1044 L 1840 1044.5 L 1837.5 1045 L 1837.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1232"
          d="M 29.5 1045 L 32 1045.5 L 29.5 1046 L 29.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1233"
          d="M 308.5 1045 L 312 1045.5 L 308.5 1046 L 308.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1234"
          d="M 1552.5 1045 L 1555 1045.5 L 1552.5 1046 L 1552.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1235"
          d="M 1832.5 1045 L 1835 1045.5 L 1832.5 1046 L 1832.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1236"
          d="M 315.5 1046 L 319 1046.5 L 315.5 1047 L 315.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1237"
          d="M 1544.5 1046 L 1548 1046.5 L 1544.5 1047 L 1544.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1238"
          d="M 1827.5 1046 L 1830 1046.5 L 1827.5 1047 L 1827.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1239"
          d="M 323.5 1047 L 327 1047.5 L 323.5 1048 L 323.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1240"
          d="M 1537.5 1047 L 1541 1047.5 L 1537.5 1048 L 1537.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1241"
          d="M 1822.5 1047 L 1825 1047.5 L 1822.5 1048 L 1822.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1242"
          d="M 330.5 1048 L 334 1048.5 L 330.5 1049 L 330.5 1048 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1243"
          d="M 1529.5 1048 L 1533 1048.5 L 1529.5 1049 L 1529.5 1048 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1244"
          d="M 1817.5 1048 L 1820 1048.5 L 1817.5 1049 L 1817.5 1048 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1245"
          d="M 338.5 1049 L 342 1049.5 L 338.5 1050 L 338.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1246"
          d="M 1522.5 1049 L 1525 1049.5 L 1522.5 1050 L 1522.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1247"
          d="M 1812.5 1049 L 1815 1049.5 L 1812.5 1050 L 1812.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1248"
          d="M 346.5 1050 L 350 1050.5 L 346.5 1051 L 346.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1249"
          d="M 1514.5 1050 L 1518 1050.5 L 1514.5 1051 L 1514.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1250"
          d="M 1807.5 1050 L 1810 1050.5 L 1807.5 1051 L 1807.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1251"
          d="M 59.5 1051 L 62 1051.5 L 59.5 1052 L 59.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1252"
          d="M 354.5 1051 L 358 1051.5 L 354.5 1052 L 354.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1253"
          d="M 1506.5 1051 L 1510 1051.5 L 1506.5 1052 L 1506.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1254"
          d="M 1802.5 1051 L 1805 1051.5 L 1802.5 1052 L 1802.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1255"
          d="M 64.5 1052 L 67 1052.5 L 64.5 1053 L 64.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1256"
          d="M 362.5 1052 L 366 1052.5 L 362.5 1053 L 362.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1257"
          d="M 1498.5 1052 L 1502 1052.5 L 1498.5 1053 L 1498.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1258"
          d="M 1797.5 1052 L 1800 1052.5 L 1797.5 1053 L 1797.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1259"
          d="M 69.5 1053 L 72 1053.5 L 69.5 1054 L 69.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1260"
          d="M 370.5 1053 L 374 1053.5 L 370.5 1054 L 370.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1261"
          d="M 1490.5 1053 L 1494 1053.5 L 1490.5 1054 L 1490.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1262"
          d="M 1792.5 1053 L 1795 1053.5 L 1792.5 1054 L 1792.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1263"
          d="M 74.5 1054 L 77 1054.5 L 74.5 1055 L 74.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1264"
          d="M 378.5 1054 L 382 1054.5 L 378.5 1055 L 378.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1265"
          d="M 1481.5 1054 L 1485 1054.5 L 1481.5 1055 L 1481.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1266"
          d="M 387.5 1055 L 391 1055.5 L 387.5 1056 L 387.5 1055 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1267"
          d="M 1473.5 1055 L 1477 1055.5 L 1473.5 1056 L 1473.5 1055 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1268"
          d="M 85.5 1056 L 88 1056.5 L 85.5 1057 L 85.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1269"
          d="M 395.5 1056 L 399 1056.5 L 395.5 1057 L 395.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1270"
          d="M 1464.5 1056 L 1469 1056.5 L 1464.5 1057 L 1464.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1271"
          d="M 1776.5 1056 L 1779 1056.5 L 1776.5 1057 L 1776.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1272"
          d="M 90.5 1057 L 93 1057.5 L 90.5 1058 L 90.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1273"
          d="M 404.5 1057 L 408 1057.5 L 404.5 1058 L 404.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1274"
          d="M 1455.5 1057 L 1460 1057.5 L 1455.5 1058 L 1455.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1275"
          d="M 1771.5 1057 L 1774 1057.5 L 1771.5 1058 L 1771.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1276"
          d="M 413.5 1058 L 417 1058.5 L 413.5 1059 L 413.5 1058 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1277"
          d="M 1447.5 1058 L 1451 1058.5 L 1447.5 1059 L 1447.5 1058 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1278"
          d="M 101.5 1059 L 104 1059.5 L 101.5 1060 L 101.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1279"
          d="M 422.5 1059 L 426 1059.5 L 422.5 1060 L 422.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1280"
          d="M 1437.5 1059 L 1442 1059.5 L 1437.5 1060 L 1437.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1281"
          d="M 1760.5 1059 L 1763 1059.5 L 1760.5 1060 L 1760.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1282"
          d="M 106.5 1060 L 109 1060.5 L 106.5 1061 L 106.5 1060 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1283"
          d="M 431.5 1060 L 435 1060.5 L 431.5 1061 L 431.5 1060 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1284"
          d="M 1428.5 1060 L 1433 1060.5 L 1428.5 1061 L 1428.5 1060 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1285"
          d="M 112.5 1061 L 115 1061.5 L 112.5 1062 L 112.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1286"
          d="M 440.5 1061 L 445 1061.5 L 440.5 1062 L 440.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1287"
          d="M 1419.5 1061 L 1424 1061.5 L 1419.5 1062 L 1419.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1288"
          d="M 1749.5 1061 L 1752 1061.5 L 1749.5 1062 L 1749.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1289"
          d="M 117.5 1062 L 120 1062.5 L 117.5 1063 L 117.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1290"
          d="M 450.5 1062 L 454 1062.5 L 450.5 1063 L 450.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1291"
          d="M 1409.5 1062 L 1414 1062.5 L 1409.5 1063 L 1409.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1292"
          d="M 1744.5 1062 L 1747 1062.5 L 1744.5 1063 L 1744.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1293"
          d="M 123.5 1063 L 126 1063.5 L 123.5 1064 L 123.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1294"
          d="M 459.5 1063 L 464 1063.5 L 459.5 1064 L 459.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1295"
          d="M 1399.5 1063 L 1404 1063.5 L 1399.5 1064 L 1399.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1296"
          d="M 1738.5 1063 L 1741 1063.5 L 1738.5 1064 L 1738.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1297"
          d="M 128.5 1064 L 131 1064.5 L 128.5 1065 L 128.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1298"
          d="M 469.5 1064 L 474 1064.5 L 469.5 1065 L 469.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1299"
          d="M 1389.5 1064 L 1394 1064.5 L 1389.5 1065 L 1389.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1300"
          d="M 134.5 1065 L 137 1065.5 L 134.5 1066 L 134.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1301"
          d="M 480.5 1065 L 485 1065.5 L 480.5 1066 L 480.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1302"
          d="M 1379.5 1065 L 1384 1065.5 L 1379.5 1066 L 1379.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1303"
          d="M 1727.5 1065 L 1730 1065.5 L 1727.5 1066 L 1727.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1304"
          d="M 140.5 1066 L 143 1066.5 L 140.5 1067 L 140.5 1066 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1305"
          d="M 490.5 1066 L 495 1066.5 L 490.5 1067 L 490.5 1066 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1306"
          d="M 1368.5 1066 L 1374 1066.5 L 1368.5 1067 L 1368.5 1066 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1307"
          d="M 1721.5 1066 L 1724 1066.5 L 1721.5 1067 L 1721.5 1066 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1308"
          d="M 145.5 1067 L 148 1067.5 L 145.5 1068 L 145.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1309"
          d="M 501.5 1067 L 506 1067.5 L 501.5 1068 L 501.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1310"
          d="M 1358.5 1067 L 1363 1067.5 L 1358.5 1068 L 1358.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1311"
          d="M 151.5 1068 L 154 1068.5 L 151.5 1069 L 151.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1312"
          d="M 512.5 1068 L 517 1068.5 L 512.5 1069 L 512.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1313"
          d="M 1346.5 1068 L 1352 1068.5 L 1346.5 1069 L 1346.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1314"
          d="M 1710.5 1068 L 1713 1068.5 L 1710.5 1069 L 1710.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1315"
          d="M 157.5 1069 L 160 1069.5 L 157.5 1070 L 157.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1316"
          d="M 523.5 1069 L 529 1069.5 L 523.5 1070 L 523.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1317"
          d="M 1335.5 1069 L 1341 1069.5 L 1335.5 1070 L 1335.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1318"
          d="M 1704.5 1069 L 1707 1069.5 L 1704.5 1070 L 1704.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1319"
          d="M 163.5 1070 L 166 1070.5 L 163.5 1071 L 163.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1320"
          d="M 535.5 1070 L 541 1070.5 L 535.5 1071 L 535.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1321"
          d="M 1323.5 1070 L 1329 1070.5 L 1323.5 1071 L 1323.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1322"
          d="M 1698.5 1070 L 1701 1070.5 L 1698.5 1071 L 1698.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1323"
          d="M 169.5 1071 L 172 1071.5 L 169.5 1072 L 169.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1324"
          d="M 547.5 1071 L 553 1071.5 L 547.5 1072 L 547.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1325"
          d="M 1311.5 1071 L 1317 1071.5 L 1311.5 1072 L 1311.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1326"
          d="M 1692.5 1071 L 1695 1071.5 L 1692.5 1072 L 1692.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1327"
          d="M 175.5 1072 L 178 1072.5 L 175.5 1073 L 175.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1328"
          d="M 559.5 1072 L 565 1072.5 L 559.5 1073 L 559.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1329"
          d="M 1298.5 1072 L 1305 1072.5 L 1298.5 1073 L 1298.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1330"
          d="M 1686.5 1072 L 1689 1072.5 L 1686.5 1073 L 1686.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1331"
          d="M 181.5 1073 L 184 1073.5 L 181.5 1074 L 181.5 1073 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1332"
          d="M 572.5 1073 L 578 1073.5 L 572.5 1074 L 572.5 1073 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1333"
          d="M 1285.5 1073 L 1292 1073.5 L 1285.5 1074 L 1285.5 1073 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1334"
          d="M 1680.5 1073 L 1683 1073.5 L 1680.5 1074 L 1680.5 1073 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1335"
          d="M 187.5 1074 L 190 1074.5 L 187.5 1075 L 187.5 1074 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1336"
          d="M 585.5 1074 L 592 1074.5 L 585.5 1075 L 585.5 1074 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1337"
          d="M 1272.5 1074 L 1278 1074.5 L 1272.5 1075 L 1272.5 1074 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1338"
          d="M 1674.5 1074 L 1677 1074.5 L 1674.5 1075 L 1674.5 1074 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1339"
          d="M 193.5 1075 L 196 1075.5 L 193.5 1076 L 193.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1340"
          d="M 599.5 1075 L 606 1075.5 L 599.5 1076 L 599.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1341"
          d="M 1257.5 1075 L 1265 1075.5 L 1257.5 1076 L 1257.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1342"
          d="M 1668.5 1075 L 1671 1075.5 L 1668.5 1076 L 1668.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1343"
          d="M 199.5 1076 L 202 1076.5 L 199.5 1077 L 199.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1344"
          d="M 614.5 1076 L 621 1076.5 L 614.5 1077 L 614.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1345"
          d="M 1242.5 1076 L 1250 1076.5 L 1242.5 1077 L 1242.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1346"
          d="M 1662.5 1076 L 1665 1076.5 L 1662.5 1077 L 1662.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1347"
          d="M 205.5 1077 L 209 1077.5 L 205.5 1078 L 205.5 1077 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1348"
          d="M 629.5 1077 L 637 1077.5 L 629.5 1078 L 629.5 1077 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1349"
          d="M 1227.5 1077 L 1235 1077.5 L 1227.5 1078 L 1227.5 1077 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1350"
          d="M 1655.5 1077 L 1659 1077.5 L 1655.5 1078 L 1655.5 1077 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1351"
          d="M 212.5 1078 L 215 1078.5 L 212.5 1079 L 212.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1352"
          d="M 645.5 1078 L 653 1078.5 L 645.5 1079 L 645.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1353"
          d="M 1210.5 1078 L 1219 1078.5 L 1210.5 1079 L 1210.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1354"
          d="M 1649.5 1078 L 1652 1078.5 L 1649.5 1079 L 1649.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1355"
          d="M 218.5 1079 L 221 1079.5 L 218.5 1080 L 218.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1356"
          d="M 662.5 1079 L 671 1079.5 L 662.5 1080 L 662.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1357"
          d="M 1193.5 1079 L 1202 1079.5 L 1193.5 1080 L 1193.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1358"
          d="M 1643.5 1079 L 1646 1079.5 L 1643.5 1080 L 1643.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1359"
          d="M 225.5 1080 L 228 1080.5 L 225.5 1081 L 225.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1360"
          d="M 680.5 1080 L 690 1080.5 L 680.5 1081 L 680.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1361"
          d="M 1174.5 1080 L 1183 1080.5 L 1174.5 1081 L 1174.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1362"
          d="M 1636.5 1080 L 1639 1080.5 L 1636.5 1081 L 1636.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1363"
          d="M 231.5 1081 L 234 1081.5 L 231.5 1082 L 231.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1364"
          d="M 700.5 1081 L 711 1081.5 L 700.5 1082 L 700.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1365"
          d="M 1153.5 1081 L 1164 1081.5 L 1153.5 1082 L 1153.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1366"
          d="M 1630.5 1081 L 1633 1081.5 L 1630.5 1082 L 1630.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1367"
          d="M 238.5 1082 L 241 1082.5 L 238.5 1083 L 238.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1368"
          d="M 722.5 1082 L 733 1082.5 L 722.5 1083 L 722.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1369"
          d="M 1130.5 1082 L 1142 1082.5 L 1130.5 1083 L 1130.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1370"
          d="M 1623.5 1082 L 1626 1082.5 L 1623.5 1083 L 1623.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1371"
          d="M 244.5 1083 L 248 1083.5 L 244.5 1084 L 244.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1372"
          d="M 746.5 1083 L 759 1083.5 L 746.5 1084 L 746.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1373"
          d="M 1104.5 1083 L 1118 1083.5 L 1104.5 1084 L 1104.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1374"
          d="M 1616.5 1083 L 1620 1083.5 L 1616.5 1084 L 1616.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1375"
          d="M 251.5 1084 L 254 1084.5 L 251.5 1085 L 251.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1376"
          d="M 774.5 1084 L 790 1084.5 L 774.5 1085 L 774.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1377"
          d="M 1074.5 1084 L 1090 1084.5 L 1074.5 1085 L 1074.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1378"
          d="M 1610.5 1084 L 1613 1084.5 L 1610.5 1085 L 1610.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1379"
          d="M 258.5 1085 L 261 1085.5 L 258.5 1086 L 258.5 1085 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1380"
          d="M 808.5 1085 L 829 1085.5 L 808.5 1086 L 808.5 1085 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1381"
          d="M 1035.5 1085 L 1056 1085.5 L 1035.5 1086 L 1035.5 1085 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1382"
          d="M 1603.5 1085 L 1606 1085.5 L 1603.5 1086 L 1603.5 1085 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1383"
          d="M 265.5 1086 L 268 1086.5 L 265.5 1087 L 265.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1384"
          d="M 856.5 1086 L 901 1086.5 L 856.5 1087 L 856.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1385"
          d="M 962.5 1086 L 1008 1086.5 L 962.5 1087 L 962.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1386"
          d="M 1596.5 1086 L 1599 1086.5 L 1596.5 1087 L 1596.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1387"
          d="M 271.5 1087 L 275 1087.5 L 271.5 1088 L 271.5 1087 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1388"
          d="M 1589.5 1087 L 1593 1087.5 L 1589.5 1088 L 1589.5 1087 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1389"
          d="M 278.5 1088 L 282 1088.5 L 278.5 1089 L 278.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1390"
          d="M 1582.5 1088 L 1586 1088.5 L 1582.5 1089 L 1582.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1391"
          d="M 286.5 1089 L 289 1089.5 L 286.5 1090 L 286.5 1089 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1392"
          d="M 1575.5 1089 L 1578 1089.5 L 1575.5 1090 L 1575.5 1089 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1393"
          d="M 293.5 1090 L 296 1090.5 L 293.5 1091 L 293.5 1090 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1394"
          d="M 1568.5 1090 L 1571 1090.5 L 1568.5 1091 L 1568.5 1090 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1395"
          d="M 300.5 1091 L 304 1091.5 L 300.5 1092 L 300.5 1091 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1396"
          d="M 1560.5 1091 L 1564 1091.5 L 1560.5 1092 L 1560.5 1091 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1397"
          d="M 307.5 1092 L 311 1092.5 L 307.5 1093 L 307.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1398"
          d="M 1553.5 1092 L 1557 1092.5 L 1553.5 1093 L 1553.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1399"
          d="M 315.5 1093 L 319 1093.5 L 315.5 1094 L 315.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1400"
          d="M 1545.5 1093 L 1549 1093.5 L 1545.5 1094 L 1545.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1401"
          d="M 322.5 1094 L 326 1094.5 L 322.5 1095 L 322.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1402"
          d="M 1538.5 1094 L 1542 1094.5 L 1538.5 1095 L 1538.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1403"
          d="M 330.5 1095 L 334 1095.5 L 330.5 1096 L 330.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1404"
          d="M 1530.5 1095 L 1534 1095.5 L 1530.5 1096 L 1530.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1405"
          d="M 338.5 1096 L 342 1096.5 L 338.5 1097 L 338.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1406"
          d="M 1522.5 1096 L 1526 1096.5 L 1522.5 1097 L 1522.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1407"
          d="M 346.5 1097 L 350 1097.5 L 346.5 1098 L 346.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1408"
          d="M 1514.5 1097 L 1518 1097.5 L 1514.5 1098 L 1514.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1409"
          d="M 354.5 1098 L 358 1098.5 L 354.5 1099 L 354.5 1098 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1410"
          d="M 1506.5 1098 L 1510 1098.5 L 1506.5 1099 L 1506.5 1098 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1411"
          d="M 362.5 1099 L 366 1099.5 L 362.5 1100 L 362.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1412"
          d="M 1498.5 1099 L 1502 1099.5 L 1498.5 1100 L 1498.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1413"
          d="M 370.5 1100 L 374 1100.5 L 370.5 1101 L 370.5 1100 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1414"
          d="M 1490.5 1100 L 1494 1100.5 L 1490.5 1101 L 1490.5 1100 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1415"
          d="M 378.5 1101 L 383 1101.5 L 378.5 1102 L 378.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1416"
          d="M 1482.5 1101 L 1486 1101.5 L 1482.5 1102 L 1482.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1417"
          d="M 387.5 1102 L 391 1102.5 L 387.5 1103 L 387.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1418"
          d="M 1473.5 1102 L 1477 1102.5 L 1473.5 1103 L 1473.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1419"
          d="M 396.5 1103 L 400 1103.5 L 396.5 1104 L 396.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1420"
          d="M 1464.5 1103 L 1469 1103.5 L 1464.5 1104 L 1464.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1421"
          d="M 404.5 1104 L 409 1104.5 L 404.5 1105 L 404.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1422"
          d="M 1455.5 1104 L 1460 1104.5 L 1455.5 1105 L 1455.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1423"
          d="M 413.5 1105 L 418 1105.5 L 413.5 1106 L 413.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1424"
          d="M 1446.5 1105 L 1451 1105.5 L 1446.5 1106 L 1446.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1425"
          d="M 423.5 1106 L 427 1106.5 L 423.5 1107 L 423.5 1106 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1426"
          d="M 1437.5 1106 L 1442 1106.5 L 1437.5 1107 L 1437.5 1106 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1427"
          d="M 432.5 1107 L 437 1107.5 L 432.5 1108 L 432.5 1107 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1428"
          d="M 1428.5 1107 L 1433 1107.5 L 1428.5 1108 L 1428.5 1107 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1429"
          d="M 441.5 1108 L 446 1108.5 L 441.5 1109 L 441.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1430"
          d="M 1418.5 1108 L 1423 1108.5 L 1418.5 1109 L 1418.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1431"
          d="M 451.5 1109 L 456 1109.5 L 451.5 1110 L 451.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1432"
          d="M 1408.5 1109 L 1413 1109.5 L 1408.5 1110 L 1408.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1433"
          d="M 461.5 1110 L 466 1110.5 L 461.5 1111 L 461.5 1110 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1434"
          d="M 1398.5 1110 L 1403 1110.5 L 1398.5 1111 L 1398.5 1110 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1435"
          d="M 471.5 1111 L 476 1111.5 L 471.5 1112 L 471.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1436"
          d="M 1388.5 1111 L 1393 1111.5 L 1388.5 1112 L 1388.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1437"
          d="M 482.5 1112 L 487 1112.5 L 482.5 1113 L 482.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1438"
          d="M 1378.5 1112 L 1383 1112.5 L 1378.5 1113 L 1378.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1439"
          d="M 492.5 1113 L 498 1113.5 L 492.5 1114 L 492.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1440"
          d="M 1367.5 1113 L 1372 1113.5 L 1367.5 1114 L 1367.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1441"
          d="M 503.5 1114 L 509 1114.5 L 503.5 1115 L 503.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1442"
          d="M 1356.5 1114 L 1362 1114.5 L 1356.5 1115 L 1356.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1443"
          d="M 514.5 1115 L 520 1115.5 L 514.5 1116 L 514.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1444"
          d="M 1345.5 1115 L 1350 1115.5 L 1345.5 1116 L 1345.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1445"
          d="M 526.5 1116 L 532 1116.5 L 526.5 1117 L 526.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1446"
          d="M 1333.5 1116 L 1339 1116.5 L 1333.5 1117 L 1333.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1447"
          d="M 538.5 1117 L 544 1117.5 L 538.5 1118 L 538.5 1117 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1448"
          d="M 1321.5 1117 L 1327 1117.5 L 1321.5 1118 L 1321.5 1117 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1449"
          d="M 550.5 1118 L 556 1118.5 L 550.5 1119 L 550.5 1118 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1450"
          d="M 1309.5 1118 L 1315 1118.5 L 1309.5 1119 L 1309.5 1118 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1451"
          d="M 563.5 1119 L 569 1119.5 L 563.5 1120 L 563.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1452"
          d="M 1296.5 1119 L 1302 1119.5 L 1296.5 1120 L 1296.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1453"
          d="M 576.5 1120 L 583 1120.5 L 576.5 1121 L 576.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1454"
          d="M 1282.5 1120 L 1289 1120.5 L 1282.5 1121 L 1282.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1455"
          d="M 590.5 1121 L 593 1121.5 L 590.5 1122 L 590.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1456"
          d="M 1280.5 1123 L 1281 1127.5 L 1280 1127.5 L 1280.5 1123 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1457"
          d="M 640.5 1124 L 647 1124.5 L 640.5 1125 L 640.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1458"
          d="M 1217.5 1124 L 1226 1124.5 L 1217.5 1125 L 1217.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1459"
          d="M 1233.5 1124 L 1234 1127.5 L 1233 1127.5 L 1233.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1460"
          d="M 655.5 1125 L 664 1125.5 L 655.5 1126 L 655.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1461"
          d="M 1200.5 1125 L 1209 1125.5 L 1200.5 1126 L 1200.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1462"
          d="M 639.5 1126 L 640 1130.5 L 639 1130.5 L 639.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1463"
          d="M 673.5 1126 L 682 1126.5 L 673.5 1127 L 673.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1464"
          d="M 1182.5 1126 L 1191 1126.5 L 1182.5 1127 L 1182.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1465"
          d="M 592.5 1127 L 593 1131.5 L 592 1131.5 L 592.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1466"
          d="M 692.5 1127 L 702 1127.5 L 692.5 1128 L 692.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1467"
          d="M 1162.5 1127 L 1172 1127.5 L 1162.5 1128 L 1162.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1468"
          d="M 712.5 1128 L 723 1128.5 L 712.5 1129 L 712.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1469"
          d="M 1141.5 1128 L 1152 1128.5 L 1141.5 1129 L 1141.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1470"
          d="M 735.5 1129 L 747 1129.5 L 735.5 1130 L 735.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1471"
          d="M 1117.5 1129 L 1129 1129.5 L 1117.5 1130 L 1117.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1472"
          d="M 760.5 1130 L 774 1130.5 L 760.5 1131 L 760.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1473"
          d="M 1090.5 1130 L 1104 1130.5 L 1090.5 1131 L 1090.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1474"
          d="M 789.5 1131 L 806 1131.5 L 789.5 1132 L 789.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1475"
          d="M 1058.5 1131 L 1075 1131.5 L 1058.5 1132 L 1058.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1476"
          d="M 826.5 1132 L 850 1132.5 L 826.5 1133 L 826.5 1132 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1477"
          d="M 1014.5 1132 L 1038 1132.5 L 1014.5 1133 L 1014.5 1132 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1478"
          d="M 885.5 1133 L 979 1133.5 L 885.5 1134 L 885.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1479"
          d="M 1234.5 1133 L 1235 1137.5 L 1234 1137.5 L 1234.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1480"
          d="M 1281.5 1133 L 1282 1137.5 L 1281 1137.5 L 1281.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1481"
          d="M 638.5 1136 L 639 1140.5 L 638 1140.5 L 638.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1482"
          d="M 591.5 1137 L 592 1141.5 L 591 1141.5 L 591.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1483"
          d="M 1235.5 1143 L 1236 1147.5 L 1235 1147.5 L 1235.5 1143 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1484"
          d="M 1282.5 1143 L 1283 1147.5 L 1282 1147.5 L 1282.5 1143 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1485"
          d="M 637.5 1146 L 638 1150.5 L 637 1150.5 L 637.5 1146 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1486"
          d="M 590.5 1147 L 591 1151.5 L 590 1151.5 L 590.5 1147 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1487"
          d="M 1236.5 1153 L 1237 1157.5 L 1236 1157.5 L 1236.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1488"
          d="M 1283.5 1153 L 1284 1157.5 L 1283 1157.5 L 1283.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1489"
          d="M 636.5 1156 L 637 1160.5 L 636 1160.5 L 636.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1490"
          d="M 589.5 1157 L 590 1161.5 L 589 1161.5 L 589.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1491"
          d="M 1237.5 1163 L 1238 1167.5 L 1237 1167.5 L 1237.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1492"
          d="M 1284.5 1163 L 1285 1167.5 L 1284 1167.5 L 1284.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1493"
          d="M 635.5 1166 L 636 1170.5 L 635 1170.5 L 635.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1494"
          d="M 588.5 1167 L 589 1171.5 L 588 1171.5 L 588.5 1167 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1495"
          d="M 1238.5 1173 L 1239 1177.5 L 1238 1177.5 L 1238.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1496"
          d="M 1285.5 1173 L 1286 1177.5 L 1285 1177.5 L 1285.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1497"
          d="M 634.5 1176 L 635 1180.5 L 634 1180.5 L 634.5 1176 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1498"
          d="M 587.5 1177 L 588 1181.5 L 587 1181.5 L 587.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1499"
          d="M 1239.5 1183 L 1240 1187.5 L 1239 1187.5 L 1239.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1500"
          d="M 1286.5 1183 L 1287 1187.5 L 1286 1187.5 L 1286.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1501"
          d="M 633.5 1186 L 634 1190.5 L 633 1190.5 L 633.5 1186 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1502"
          d="M 586.5 1187 L 587 1191.5 L 586 1191.5 L 586.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1503"
          d="M 546.5 1190 L 559 1190.5 L 546.5 1191 L 546.5 1190 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1504"
          d="M 564.5 1191 L 569 1191.5 L 564.5 1192 L 564.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1505"
          d="M 574.5 1192 L 579 1192.5 L 574.5 1193 L 574.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1506"
          d="M 1240.5 1193 L 1241 1197.5 L 1240 1197.5 L 1240.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1507"
          d="M 1287.5 1193 L 1288 1195.5 L 1287 1195.5 L 1287.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1508"
          d="M 1311.5 1193 L 1316 1193.5 L 1311.5 1194 L 1311.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1509"
          d="M 1327.5 1193 L 1331 1193.5 L 1327.5 1194 L 1327.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1510"
          d="M 1301.5 1194 L 1306 1194.5 L 1301.5 1195 L 1301.5 1194 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1511"
          d="M 1291.5 1195 L 1296 1195.5 L 1291.5 1196 L 1291.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1512"
          d="M 634.5 1198 L 639 1198.5 L 634.5 1199 L 634.5 1198 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1513"
          d="M 644.5 1199 L 649 1199.5 L 644.5 1200 L 644.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1514"
          d="M 521.5 1200 L 519.5 1203 L 521.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1515"
          d="M 654.5 1200 L 659 1200.5 L 654.5 1201 L 654.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1516"
          d="M 1348.5 1200 L 1349.5 1202 L 1348.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1517"
          d="M 664.5 1201 L 667 1201.5 L 664.5 1202 L 664.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1518"
          d="M 1231.5 1201 L 1236 1201.5 L 1231.5 1202 L 1231.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1519"
          d="M 1221.5 1202 L 1226 1202.5 L 1221.5 1203 L 1221.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1520"
          d="M 1351.5 1202 L 1353.5 1205 L 1351.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1521"
          d="M 1211.5 1203 L 1216 1203.5 L 1211.5 1204 L 1211.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1522"
          d="M 680.5 1206 L 681.5 1208 L 680.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1523"
          d="M 513.5 1208 L 511.5 1211 L 513.5 1208 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1524"
          d="M 1192.5 1209 L 1191.5 1211 L 1192.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1525"
          d="M 686.5 1210 L 687.5 1212 L 686.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1526"
          d="M 1359.5 1210 L 1361.5 1213 L 1359.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1527"
          d="M 510.5 1212 L 509.5 1214 L 510.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1528"
          d="M 1186.5 1213 L 1184.5 1216 L 1186.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1529"
          d="M 691.5 1214 L 692.5 1216 L 691.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1530"
          d="M 695.5 1219 L 696.5 1221 L 695.5 1219 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1531"
          d="M 1179.5 1220 L 1177.5 1223 L 1179.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1532"
          d="M 1175.5 1225 L 1174.5 1227 L 1175.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1533"
          d="M 1370.5 1232 L 1371 1234.5 L 1370 1234.5 L 1370.5 1232 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1534"
          d="M 502.5 1233 L 503 1237.5 L 502 1237.5 L 502.5 1233 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1535"
          d="M 550.5 1237 L 549.5 1239 L 550.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1536"
          d="M 554.5 1237 L 559 1237.5 L 554.5 1238 L 554.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1537"
          d="M 564.5 1238 L 569 1238.5 L 564.5 1239 L 564.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1538"
          d="M 574.5 1239 L 579 1239.5 L 574.5 1240 L 574.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1539"
          d="M 705.5 1239 L 706 1241.5 L 705 1241.5 L 705.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1540"
          d="M 1371.5 1239 L 1372 1243.5 L 1371 1243.5 L 1371.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1541"
          d="M 584.5 1240 L 589 1240.5 L 584.5 1241 L 584.5 1240 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1542"
          d="M 1310.5 1240 L 1315 1240.5 L 1310.5 1241 L 1310.5 1240 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1543"
          d="M 1323.5 1240 L 1325 1243.5 L 1324 1243.5 L 1323.5 1240 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1544"
          d="M 594.5 1241 L 599 1241.5 L 594.5 1242 L 594.5 1241 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1545"
          d="M 1300.5 1241 L 1305 1241.5 L 1300.5 1242 L 1300.5 1241 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1546"
          d="M 548.5 1242 L 549 1246.5 L 548 1246.5 L 548.5 1242 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1547"
          d="M 604.5 1242 L 609 1242.5 L 604.5 1243 L 604.5 1242 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1548"
          d="M 1290.5 1242 L 1295 1242.5 L 1290.5 1243 L 1290.5 1242 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1549"
          d="M 501.5 1243 L 502 1247.5 L 501 1247.5 L 501.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1550"
          d="M 614.5 1243 L 619 1243.5 L 614.5 1244 L 614.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1551"
          d="M 1280.5 1243 L 1285 1243.5 L 1280.5 1244 L 1280.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1552"
          d="M 624.5 1244 L 629 1244.5 L 624.5 1245 L 624.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1553"
          d="M 1270.5 1244 L 1275 1244.5 L 1270.5 1245 L 1270.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1554"
          d="M 634.5 1245 L 639 1245.5 L 634.5 1246 L 634.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1555"
          d="M 1167.5 1245 L 1168 1248.5 L 1167 1248.5 L 1167.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1556"
          d="M 1260.5 1245 L 1265 1245.5 L 1260.5 1246 L 1260.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1557"
          d="M 644.5 1246 L 649 1246.5 L 644.5 1247 L 644.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1558"
          d="M 706.5 1246 L 707 1253.5 L 706 1253.5 L 706.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1559"
          d="M 1250.5 1246 L 1255 1246.5 L 1250.5 1247 L 1250.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1560"
          d="M 654.5 1247 L 658 1247.5 L 654.5 1248 L 654.5 1247 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1561"
          d="M 1240.5 1247 L 1245 1247.5 L 1240.5 1248 L 1240.5 1247 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1562"
          d="M 1230.5 1248 L 1235 1248.5 L 1230.5 1249 L 1230.5 1248 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1563"
          d="M 659.5 1249 L 660 1254.5 L 659 1254.5 L 659.5 1249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1564"
          d="M 1220.5 1249 L 1225 1249.5 L 1220.5 1250 L 1220.5 1249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1565"
          d="M 1325.5 1249 L 1326 1253.5 L 1325 1253.5 L 1325.5 1249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1566"
          d="M 1372.5 1249 L 1373 1253.5 L 1372 1253.5 L 1372.5 1249 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1567"
          d="M 1215.5 1250 L 1214.5 1252 L 1215.5 1250 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1568"
          d="M 547.5 1252 L 548 1256.5 L 547 1256.5 L 547.5 1252 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1569"
          d="M 500.5 1253 L 501 1257.5 L 500 1257.5 L 500.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1570"
          d="M 1167.5 1256 L 1168 1260.5 L 1167 1260.5 L 1167.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1571"
          d="M 1214.5 1257 L 1215 1261.5 L 1214 1261.5 L 1214.5 1257 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1572"
          d="M 705.5 1259 L 706 1263.5 L 705 1263.5 L 705.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1573"
          d="M 1326.5 1259 L 1327 1264.5 L 1326 1264.5 L 1326.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1574"
          d="M 1373.5 1259 L 1374 1263.5 L 1373 1263.5 L 1373.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1575"
          d="M 658.5 1260 L 659 1264.5 L 658 1264.5 L 658.5 1260 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1576"
          d="M 546.5 1262 L 547 1266.5 L 546 1266.5 L 546.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1577"
          d="M 499.5 1263 L 500 1267.5 L 499 1267.5 L 499.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1578"
          d="M 1168.5 1266 L 1169 1270.5 L 1168 1270.5 L 1168.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1579"
          d="M 1215.5 1267 L 1216 1271.5 L 1215 1271.5 L 1215.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1580"
          d="M 704.5 1269 L 705 1273.5 L 704 1273.5 L 704.5 1269 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1581"
          d="M 1374.5 1269 L 1375 1273.5 L 1374 1273.5 L 1374.5 1269 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1582"
          d="M 657.5 1270 L 658 1274.5 L 657 1274.5 L 657.5 1270 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1583"
          d="M 1327.5 1270 L 1328 1274.5 L 1327 1274.5 L 1327.5 1270 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1584"
          d="M 545.5 1272 L 546 1276.5 L 545 1276.5 L 545.5 1272 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1585"
          d="M 498.5 1273 L 499 1277.5 L 498 1277.5 L 498.5 1273 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1586"
          d="M 1169.5 1276 L 1170 1280.5 L 1169 1280.5 L 1169.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1587"
          d="M 1216.5 1277 L 1217 1281.5 L 1216 1281.5 L 1216.5 1277 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1588"
          d="M 703.5 1279 L 704 1283.5 L 703 1283.5 L 703.5 1279 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1589"
          d="M 1375.5 1279 L 1376 1283.5 L 1375 1283.5 L 1375.5 1279 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1590"
          d="M 656.5 1280 L 657 1283.5 L 656 1283.5 L 656.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1591"
          d="M 1328.5 1280 L 1329 1284.5 L 1328 1284.5 L 1328.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1592"
          d="M 544.5 1282 L 545 1286.5 L 544 1286.5 L 544.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1593"
          d="M 497.5 1283 L 498 1287.5 L 497 1287.5 L 497.5 1283 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1594"
          d="M 1170.5 1286 L 1171 1290.5 L 1170 1290.5 L 1170.5 1286 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1595"
          d="M 1217.5 1287 L 1218 1291.5 L 1217 1291.5 L 1217.5 1287 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1596"
          d="M 655.5 1289 L 656 1293.5 L 655 1293.5 L 655.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1597"
          d="M 702.5 1289 L 703 1293.5 L 702 1293.5 L 702.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1598"
          d="M 1376.5 1289 L 1377 1293.5 L 1376 1293.5 L 1376.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1599"
          d="M 1329.5 1290 L 1330 1294.5 L 1329 1294.5 L 1329.5 1290 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1600"
          d="M 543.5 1292 L 544 1296.5 L 543 1296.5 L 543.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1601"
          d="M 496.5 1293 L 497 1297.5 L 496 1297.5 L 496.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1602"
          d="M 1171.5 1296 L 1172 1300.5 L 1171 1300.5 L 1171.5 1296 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1603"
          d="M 1218.5 1297 L 1219 1301.5 L 1218 1301.5 L 1218.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1604"
          d="M 654.5 1299 L 655 1303.5 L 654 1303.5 L 654.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1605"
          d="M 701.5 1299 L 702 1303.5 L 701 1303.5 L 701.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1606"
          d="M 1377.5 1299 L 1378 1303.5 L 1377 1303.5 L 1377.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1607"
          d="M 1330.5 1300 L 1331 1304.5 L 1330 1304.5 L 1330.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1608"
          d="M 543.5 1302 L 546 1302.5 L 543.5 1303 L 543.5 1302 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1609"
          d="M 495.5 1303 L 496 1307.5 L 495 1307.5 L 495.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1610"
          d="M 551.5 1303 L 556 1303.5 L 551.5 1304 L 551.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1611"
          d="M 561.5 1304 L 566 1304.5 L 561.5 1305 L 561.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1612"
          d="M 571.5 1305 L 576 1305.5 L 571.5 1306 L 571.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1613"
          d="M 1320.5 1305 L 1325 1305.5 L 1320.5 1306 L 1320.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1614"
          d="M 581.5 1306 L 586 1306.5 L 581.5 1307 L 581.5 1306 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1615"
          d="M 1172.5 1306 L 1173 1310.5 L 1172 1310.5 L 1172.5 1306 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1616"
          d="M 1310.5 1306 L 1315 1306.5 L 1310.5 1307 L 1310.5 1306 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1617"
          d="M 591.5 1307 L 596 1307.5 L 591.5 1308 L 591.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1618"
          d="M 1219.5 1307 L 1220 1311.5 L 1219 1311.5 L 1219.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1619"
          d="M 1300.5 1307 L 1305 1307.5 L 1300.5 1308 L 1300.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1620"
          d="M 601.5 1308 L 606 1308.5 L 601.5 1309 L 601.5 1308 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1621"
          d="M 1290.5 1308 L 1295 1308.5 L 1290.5 1309 L 1290.5 1308 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1622"
          d="M 611.5 1309 L 616 1309.5 L 611.5 1310 L 611.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1623"
          d="M 653.5 1309 L 654 1312.5 L 651.5 1314 L 651.5 1313 L 653 1313 L 653.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1624"
          d="M 700.5 1309 L 701 1313.5 L 700 1313.5 L 700.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1625"
          d="M 1280.5 1309 L 1285 1309.5 L 1280.5 1310 L 1280.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1626"
          d="M 1378.5 1309 L 1380 1312.5 L 1378 1311.5 L 1378.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1627"
          d="M 621.5 1310 L 626 1310.5 L 621.5 1311 L 621.5 1310 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1628"
          d="M 1270.5 1310 L 1275 1310.5 L 1270.5 1311 L 1270.5 1310 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1629"
          d="M 631.5 1311 L 636 1311.5 L 631.5 1312 L 631.5 1311 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1630"
          d="M 1260.5 1311 L 1265 1311.5 L 1260.5 1312 L 1260.5 1311 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1631"
          d="M 641.5 1312 L 646 1312.5 L 641.5 1313 L 641.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1632"
          d="M 1250.5 1312 L 1255 1312.5 L 1250.5 1313 L 1250.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1633"
          d="M 1240.5 1313 L 1245 1313.5 L 1240.5 1314 L 1240.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1634"
          d="M 1230.5 1314 L 1235 1314.5 L 1230.5 1315 L 1230.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1635"
          d="M 1220.5 1315 L 1225 1315.5 L 1220.5 1316 L 1220.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1636"
          d="M 1173.5 1316 L 1174 1320.5 L 1173 1320.5 L 1173.5 1316 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1637"
          d="M 1389.5 1317 L 1390.5 1319 L 1389.5 1317 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1638"
          d="M 699.5 1319 L 700 1323.5 L 699 1323.5 L 699.5 1319 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1639"
          d="M 475.5 1320 L 474.5 1322 L 475.5 1320 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1640"
          d="M 1394.5 1320 L 1395.5 1322 L 1394.5 1320 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1641"
          d="M 472.5 1322 L 471.5 1324 L 472.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1642"
          d="M 468.5 1325 L 467.5 1327 L 468.5 1325 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1643"
          d="M 1174.5 1326 L 1175 1330.5 L 1174 1330.5 L 1174.5 1326 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1644"
          d="M 465.5 1327 L 463.5 1330 L 465.5 1327 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1645"
          d="M 1406.5 1328 L 1407.5 1330 L 1406.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1646"
          d="M 460.5 1331 L 458.5 1334 L 460.5 1331 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1647"
          d="M 700.5 1331 L 702.5 1334 L 700.5 1331 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1648"
          d="M 1410.5 1331 L 1412.5 1334 L 1410.5 1331 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1649"
          d="M 1174.5 1332 L 1172.5 1335 L 1174.5 1332 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1650"
          d="M 455.5 1335 L 437.5 1354 L 455.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1651"
          d="M 705.5 1335 L 707.5 1338 L 705.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1652"
          d="M 1415.5 1335 L 1418.5 1339 L 1415.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1653"
          d="M 1169.5 1336 L 1167.5 1339 L 1169.5 1336 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1654"
          d="M 711.5 1340 L 723.5 1353 L 711.5 1340 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1655"
          d="M 1164.5 1340 L 1147.5 1358 L 1164.5 1340 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1656"
          d="M 1423.5 1342 L 1432.5 1352 L 1423.5 1342 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1657"
          d="M 531.5 1348 L 536 1348.5 L 531.5 1349 L 531.5 1348 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1658"
          d="M 541.5 1349 L 546 1349.5 L 541.5 1350 L 541.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1659"
          d="M 551.5 1350 L 556 1350.5 L 551.5 1351 L 551.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1660"
          d="M 1339.5 1350 L 1344 1350.5 L 1339.5 1351 L 1339.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1661"
          d="M 561.5 1351 L 566 1351.5 L 561.5 1352 L 561.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1662"
          d="M 1329.5 1351 L 1334 1351.5 L 1329.5 1352 L 1329.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1663"
          d="M 571.5 1352 L 576 1352.5 L 571.5 1353 L 571.5 1352 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1664"
          d="M 1319.5 1352 L 1324 1352.5 L 1319.5 1353 L 1319.5 1352 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1665"
          d="M 581.5 1353 L 586 1353.5 L 581.5 1354 L 581.5 1353 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1666"
          d="M 1309.5 1353 L 1314 1353.5 L 1309.5 1354 L 1309.5 1353 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1667"
          d="M 591.5 1354 L 596 1354.5 L 591.5 1355 L 591.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1668"
          d="M 1300.5 1354 L 1305 1354.5 L 1300.5 1355 L 1300.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1669"
          d="M 601.5 1355 L 606 1355.5 L 601.5 1356 L 601.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1670"
          d="M 725.5 1355 L 728.5 1359 L 725.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1671"
          d="M 1290.5 1355 L 1295 1355.5 L 1290.5 1356 L 1290.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1672"
          d="M 1435.5 1355 L 1439.5 1360 L 1435.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1673"
          d="M 611.5 1356 L 616 1356.5 L 611.5 1357 L 611.5 1356 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1674"
          d="M 1280.5 1356 L 1285 1356.5 L 1280.5 1357 L 1280.5 1356 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1675"
          d="M 434.5 1357 L 432.5 1360 L 434.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1676"
          d="M 621.5 1357 L 626 1357.5 L 621.5 1358 L 621.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1677"
          d="M 1270.5 1357 L 1275 1357.5 L 1270.5 1358 L 1270.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1678"
          d="M 631.5 1358 L 636 1358.5 L 631.5 1359 L 631.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1679"
          d="M 1260.5 1358 L 1265 1358.5 L 1260.5 1359 L 1260.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1680"
          d="M 641.5 1359 L 646 1359.5 L 641.5 1360 L 641.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1681"
          d="M 1250.5 1359 L 1255 1359.5 L 1250.5 1360 L 1250.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1682"
          d="M 651.5 1360 L 656 1360.5 L 651.5 1361 L 651.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1683"
          d="M 1145.5 1360 L 1143.5 1363 L 1145.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1684"
          d="M 1240.5 1360 L 1245 1360.5 L 1240.5 1361 L 1240.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1685"
          d="M 730.5 1361 L 732.5 1364 L 730.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1686"
          d="M 1230.5 1361 L 1235 1361.5 L 1230.5 1362 L 1230.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1687"
          d="M 1371.5 1361 L 1372.5 1363 L 1371.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1688"
          d="M 430.5 1362 L 428.5 1365 L 430.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1689"
          d="M 1220.5 1362 L 1225 1362.5 L 1220.5 1363 L 1220.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1690"
          d="M 1441.5 1362 L 1443.5 1365 L 1441.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1691"
          d="M 664.5 1363 L 665.5 1365 L 664.5 1363 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1692"
          d="M 1374.5 1363 L 1375.5 1365 L 1374.5 1363 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1693"
          d="M 494.5 1364 L 493.5 1366 L 494.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1694"
          d="M 667.5 1365 L 668.5 1367 L 667.5 1365 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1695"
          d="M 1141.5 1365 L 1139.5 1368 L 1141.5 1365 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1696"
          d="M 1377.5 1365 L 1378.5 1367 L 1377.5 1365 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1697"
          d="M 734.5 1366 L 735.5 1368 L 734.5 1366 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1698"
          d="M 426.5 1367 L 425.5 1369 L 426.5 1367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1699"
          d="M 490.5 1367 L 487.5 1371 L 490.5 1367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1700"
          d="M 1445.5 1367 L 1446.5 1369 L 1445.5 1367 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1701"
          d="M 671.5 1368 L 672.5 1370 L 671.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1702"
          d="M 1381.5 1368 L 1383.5 1371 L 1381.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1703"
          d="M 736.5 1369 L 737.5 1371 L 736.5 1369 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1704"
          d="M 1138.5 1369 L 1137.5 1371 L 1138.5 1369 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1705"
          d="M 1203.5 1369 L 1202.5 1371 L 1203.5 1369 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1706"
          d="M 423.5 1371 L 422.5 1373 L 423.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1707"
          d="M 675.5 1371 L 679.5 1376 L 675.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1708"
          d="M 1448.5 1371 L 1449.5 1373 L 1448.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1709"
          d="M 1199.5 1372 L 1197.5 1375 L 1199.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1710"
          d="M 1387.5 1373 L 1401.5 1388 L 1387.5 1373 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1711"
          d="M 421.5 1374 L 420.5 1376 L 421.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1712"
          d="M 482.5 1374 L 476.5 1381 L 482.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1713"
          d="M 1451.5 1375 L 1452.5 1377 L 1451.5 1375 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1714"
          d="M 419.5 1377 L 418.5 1379 L 419.5 1377 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1715"
          d="M 1193.5 1377 L 1185.5 1386 L 1193.5 1377 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1716"
          d="M 742.5 1378 L 743.5 1380 L 742.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1717"
          d="M 1453.5 1378 L 1454.5 1380 L 1453.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1718"
          d="M 417.5 1380 L 416.5 1382 L 417.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1719"
          d="M 1455.5 1381 L 1456.5 1383 L 1455.5 1381 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1720"
          d="M 687.5 1383 L 691.5 1388 L 687.5 1383 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1721"
          d="M 745.5 1383 L 746.5 1385 L 745.5 1383 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1722"
          d="M 472.5 1385 L 469.5 1389 L 472.5 1385 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1723"
          d="M 412.5 1388 L 411.5 1390 L 412.5 1388 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1724"
          d="M 1182.5 1389 L 1180.5 1392 L 1182.5 1389 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1725"
          d="M 1460.5 1389 L 1461.5 1391 L 1460.5 1389 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1726"
          d="M 693.5 1390 L 695.5 1393 L 693.5 1390 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1727"
          d="M 1403.5 1390 L 1405.5 1393 L 1403.5 1390 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1728"
          d="M 467.5 1391 L 465.5 1394 L 467.5 1391 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1729"
          d="M 750.5 1392 L 751.5 1394 L 750.5 1392 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1730"
          d="M 696.5 1394 L 697.5 1396 L 696.5 1394 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1731"
          d="M 1178.5 1394 L 1177.5 1396 L 1178.5 1394 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1732"
          d="M 408.5 1395 L 407.5 1397 L 408.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1733"
          d="M 1407.5 1395 L 1409.5 1398 L 1407.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1734"
          d="M 463.5 1396 L 462.5 1398 L 463.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1735"
          d="M 1175.5 1398 L 1174.5 1400 L 1175.5 1398 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1736"
          d="M 461.5 1399 L 460.5 1401 L 461.5 1399 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1737"
          d="M 1410.5 1399 L 1411.5 1401 L 1410.5 1399 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1738"
          d="M 1173.5 1401 L 1172.5 1403 L 1173.5 1401 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1739"
          d="M 1413.5 1403 L 1414.5 1405 L 1413.5 1403 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1740"
          d="M 1171.5 1404 L 1170.5 1406 L 1171.5 1404 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1741"
          d="M 1415.5 1406 L 1416.5 1408 L 1415.5 1406 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1742"
          d="M 455.5 1408 L 454.5 1410 L 455.5 1408 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1743"
          d="M 1168.5 1409 L 1167.5 1411 L 1168.5 1409 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1744"
          d="M 1420.5 1414 L 1421.5 1416 L 1420.5 1414 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1745"
          d="M 1424.5 1421 L 1425.5 1423 L 1424.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1746"
          d="M 775.5 1464 L 776 1466.5 L 775 1466.5 L 775.5 1464 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1747"
          d="M 728.5 1469 L 729 1471.5 L 728 1471.5 L 728.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1748"
          d="M 1144.5 1473 L 1145 1475.5 L 1144 1475.5 L 1144.5 1473 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1749"
          d="M 729.5 1474 L 730 1476.5 L 729 1476.5 L 729.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1750"
          d="M 1096.5 1474 L 1097 1476.5 L 1096 1476.5 L 1096.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1751"
          d="M 777.5 1475 L 778 1477.5 L 777 1477.5 L 777.5 1475 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1752"
          d="M 1143.5 1478 L 1144 1480.5 L 1143 1480.5 L 1143.5 1478 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1753"
          d="M 730.5 1479 L 731 1481.5 L 730 1481.5 L 730.5 1479 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1754"
          d="M 1095.5 1480 L 1096 1482.5 L 1095 1482.5 L 1095.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1755"
          d="M 778.5 1481 L 779 1484.5 L 778 1484.5 L 778.5 1481 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1756"
          d="M 1142.5 1483 L 1143 1485.5 L 1142 1485.5 L 1142.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1757"
          d="M 731.5 1485 L 732 1487.5 L 731 1487.5 L 731.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1758"
          d="M 1094.5 1487 L 1095 1489.5 L 1094 1489.5 L 1094.5 1487 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1759"
          d="M 779.5 1489 L 780 1492.5 L 779 1492.5 L 779.5 1489 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1760"
          d="M 1141.5 1489 L 1142 1492.5 L 1141 1492.5 L 1141.5 1489 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1761"
          d="M 732.5 1491 L 733 1494.5 L 732 1494.5 L 732.5 1491 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1762"
          d="M 1093.5 1494 L 1094 1498.5 L 1093 1498.5 L 1093.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1763"
          d="M 1501.5 1494 L 1502 1496.5 L 1501 1496.5 L 1501.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1764"
          d="M 1140.5 1496 L 1141 1499.5 L 1140 1499.5 L 1140.5 1496 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1765"
          d="M 780.5 1497 L 781 1501.5 L 780 1501.5 L 780.5 1497 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1766"
          d="M 733.5 1499 L 734 1502.5 L 733 1502.5 L 733.5 1499 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1767"
          d="M 1503.5 1503 L 1504 1505.5 L 1503 1505.5 L 1503.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1768"
          d="M 369.5 1504 L 370 1506.5 L 369 1506.5 L 369.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1769"
          d="M 1092.5 1504 L 1093 1508.5 L 1092 1508.5 L 1092.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1770"
          d="M 1139.5 1504 L 1140 1508.5 L 1139 1508.5 L 1139.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1771"
          d="M 781.5 1507 L 782 1513.5 L 781 1513.5 L 781.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1772"
          d="M 416.5 1508 L 417 1510.5 L 416 1510.5 L 416.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1773"
          d="M 734.5 1508 L 735 1512.5 L 734 1512.5 L 734.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1774"
          d="M 1504.5 1508 L 1505 1510.5 L 1504 1510.5 L 1504.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1775"
          d="M 1138.5 1514 L 1139 1520.5 L 1138 1520.5 L 1138.5 1514 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1776"
          d="M 367.5 1515 L 368 1517.5 L 367 1517.5 L 367.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1777"
          d="M 1091.5 1516 L 1092 1523.5 L 1091 1523.5 L 1091.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1778"
          d="M 1458.5 1517 L 1459 1519.5 L 1458 1519.5 L 1458.5 1517 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1779"
          d="M 414.5 1518 L 415 1520.5 L 414 1520.5 L 414.5 1518 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1780"
          d="M 1506.5 1519 L 1507 1521.5 L 1506 1521.5 L 1506.5 1519 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1781"
          d="M 735.5 1520 L 736 1529.5 L 735 1529.5 L 735.5 1520 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1782"
          d="M 782.5 1522 L 783 1536.5 L 782 1536.5 L 782.5 1522 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1783"
          d="M 1459.5 1522 L 1460 1524.5 L 1459 1524.5 L 1459.5 1522 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1784"
          d="M 413.5 1523 L 414 1525.5 L 413 1525.5 L 413.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1785"
          d="M 1507.5 1525 L 1508 1527.5 L 1507 1527.5 L 1507.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1786"
          d="M 365.5 1527 L 366 1529.5 L 365 1529.5 L 365.5 1527 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1787"
          d="M 1460.5 1528 L 1461 1530.5 L 1460 1530.5 L 1460.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1788"
          d="M 412.5 1529 L 413 1531.5 L 412 1531.5 L 412.5 1529 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1789"
          d="M 1137.5 1530 L 1138 1567.5 L 1137 1567.5 L 1137.5 1530 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1790"
          d="M 1508.5 1531 L 1509 1533.5 L 1508 1533.5 L 1508.5 1531 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1791"
          d="M 364.5 1533 L 365 1536.5 L 364 1536.5 L 364.5 1533 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1792"
          d="M 1461.5 1534 L 1462 1536.5 L 1461 1536.5 L 1461.5 1534 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1793"
          d="M 411.5 1535 L 412 1537.5 L 411 1537.5 L 411.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1794"
          d="M 1509.5 1538 L 1510 1540.5 L 1509 1540.5 L 1509.5 1538 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1795"
          d="M 1090.5 1539 L 1091 1557.5 L 1090 1557.5 L 1090.5 1539 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1796"
          d="M 363.5 1540 L 364 1543.5 L 363 1543.5 L 363.5 1540 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1797"
          d="M 1462.5 1540 L 1463 1542.5 L 1462 1542.5 L 1462.5 1540 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1798"
          d="M 410.5 1541 L 411 1544.5 L 410 1544.5 L 410.5 1541 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1799"
          d="M 1510.5 1545 L 1511 1548.5 L 1510 1548.5 L 1510.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1800"
          d="M 1463.5 1547 L 1464 1550.5 L 1463 1550.5 L 1463.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1801"
          d="M 362.5 1548 L 363 1551.5 L 362 1551.5 L 362.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1802"
          d="M 409.5 1549 L 410 1551.5 L 409 1551.5 L 409.5 1549 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1803"
          d="M 1511.5 1554 L 1512 1557.5 L 1511 1557.5 L 1511.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1804"
          d="M 1464.5 1555 L 1465 1558.5 L 1464 1558.5 L 1464.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1805"
          d="M 782.5 1556 L 783 1570.5 L 782 1570.5 L 782.5 1556 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1806"
          d="M 361.5 1557 L 362 1561.5 L 361 1561.5 L 361.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1807"
          d="M 408.5 1557 L 409 1560.5 L 408 1560.5 L 408.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1808"
          d="M 1227.5 1557 L 1230 1557.5 L 1227.5 1558 L 1227.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1809"
          d="M 1233.5 1557 L 1237 1557.5 L 1233.5 1558 L 1233.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1810"
          d="M 1242.5 1559 L 1243.5 1561 L 1242.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1811"
          d="M 474.5 1561 L 471.5 1565 L 474.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1812"
          d="M 505.5 1561 L 507.5 1564 L 505.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1813"
          d="M 1245.5 1561 L 1250.5 1567 L 1245.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1814"
          d="M 1216.5 1562 L 1213.5 1566 L 1216.5 1562 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1815"
          d="M 1465.5 1563 L 1466 1567.5 L 1465 1567.5 L 1465.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1816"
          d="M 1512.5 1563 L 1513 1567.5 L 1512 1567.5 L 1512.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1817"
          d="M 735.5 1565 L 736 1574.5 L 735 1574.5 L 735.5 1565 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1818"
          d="M 407.5 1566 L 408 1570.5 L 407 1570.5 L 407.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1819"
          d="M 470.5 1566 L 469.5 1568 L 470.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1820"
          d="M 360.5 1567 L 361 1573.5 L 360 1573.5 L 360.5 1567 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1821"
          d="M 1091.5 1573 L 1092 1581.5 L 1091 1581.5 L 1091.5 1573 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1822"
          d="M 1254.5 1574 L 1255 1576.5 L 1254 1576.5 L 1254.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1823"
          d="M 1466.5 1574 L 1467 1579.5 L 1466 1579.5 L 1466.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1824"
          d="M 1513.5 1575 L 1514 1583.5 L 1513 1583.5 L 1513.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1825"
          d="M 466.5 1576 L 467 1581.5 L 466 1581.5 L 466.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1826"
          d="M 1208.5 1576 L 1209 1579.5 L 1208 1579.5 L 1208.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1827"
          d="M 406.5 1578 L 407 1586.5 L 406 1586.5 L 406.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1828"
          d="M 513.5 1578 L 514 1580.5 L 513 1580.5 L 513.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1829"
          d="M 1138.5 1578 L 1139 1584.5 L 1138 1584.5 L 1138.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1830"
          d="M 781.5 1581 L 782 1587.5 L 781 1587.5 L 781.5 1581 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1831"
          d="M 359.5 1583 L 360 1615.5 L 359 1615.5 L 359.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1832"
          d="M 734.5 1583 L 735 1588.5 L 734 1588.5 L 734.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1833"
          d="M 1254.5 1585 L 1255 1593.5 L 1254 1593.5 L 1254.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1834"
          d="M 512.5 1587 L 513 1602.5 L 512 1602.5 L 512.5 1587 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1835"
          d="M 1207.5 1587 L 1208 1605.5 L 1207 1605.5 L 1207.5 1587 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1836"
          d="M 1092.5 1589 L 1093 1595.5 L 1092 1595.5 L 1092.5 1589 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1837"
          d="M 1467.5 1591 L 1468 1611.5 L 1467 1611.5 L 1467.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1838"
          d="M 1139.5 1592 L 1140 1596.5 L 1139 1596.5 L 1139.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1839"
          d="M 780.5 1594 L 781 1599.5 L 780 1599.5 L 780.5 1594 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1840"
          d="M 733.5 1595 L 734 1599.5 L 733 1599.5 L 733.5 1595 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1841"
          d="M 1254.5 1598 L 1255 1606.5 L 1254 1606.5 L 1254.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1842"
          d="M 1093.5 1601 L 1094 1605.5 L 1093 1605.5 L 1093.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1843"
          d="M 1140.5 1602 L 1141 1605.5 L 1140 1605.5 L 1140.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1844"
          d="M 732.5 1604 L 733 1607.5 L 732 1607.5 L 732.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1845"
          d="M 779.5 1605 L 780 1608.5 L 779 1608.5 L 779.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1846"
          d="M 466.5 1608 L 467 1613.5 L 466 1613.5 L 466.5 1608 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1847"
          d="M 513.5 1609 L 514 1612.5 L 513 1612.5 L 513.5 1609 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1848"
          d="M 1141.5 1610 L 1142 1613.5 L 1141 1613.5 L 1141.5 1610 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1849"
          d="M 1094.5 1611 L 1095 1614.5 L 1094 1614.5 L 1094.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1850"
          d="M 731.5 1612 L 732 1615.5 L 731 1615.5 L 731.5 1612 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1851"
          d="M 1255.5 1612 L 1256 1614.5 L 1255 1614.5 L 1255.5 1612 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1852"
          d="M 406.5 1613 L 407 1622.5 L 406 1622.5 L 406.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1853"
          d="M 778.5 1613 L 779 1616.5 L 778 1616.5 L 778.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1854"
          d="M 1208.5 1613 L 1209 1617.5 L 1208 1617.5 L 1208.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1855"
          d="M 514.5 1616 L 515 1618.5 L 514 1618.5 L 514.5 1616 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1856"
          d="M 1142.5 1617 L 1143 1620.5 L 1142 1620.5 L 1142.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1857"
          d="M 1513.5 1617 L 1514 1625.5 L 1513 1625.5 L 1513.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1858"
          d="M 467.5 1618 L 468 1620.5 L 467 1620.5 L 467.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1859"
          d="M 1256.5 1618 L 1257 1620.5 L 1256 1620.5 L 1256.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1860"
          d="M 730.5 1619 L 731 1621.5 L 730 1621.5 L 730.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1861"
          d="M 1095.5 1619 L 1096 1621.5 L 1095 1621.5 L 1095.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1862"
          d="M 777.5 1621 L 778 1623.5 L 777 1623.5 L 777.5 1621 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1863"
          d="M 1209.5 1622 L 1210 1624.5 L 1209 1624.5 L 1209.5 1622 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1864"
          d="M 1466.5 1622 L 1467 1628.5 L 1466 1628.5 L 1466.5 1622 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1865"
          d="M 468.5 1624 L 469 1626.5 L 468 1626.5 L 468.5 1624 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1866"
          d="M 360.5 1625 L 361 1631.5 L 360 1631.5 L 360.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1867"
          d="M 1096.5 1626 L 1097 1628.5 L 1096 1628.5 L 1096.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1868"
          d="M 776.5 1627 L 777 1629.5 L 776 1629.5 L 776.5 1627 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1869"
          d="M 407.5 1629 L 408 1633.5 L 407 1633.5 L 407.5 1629 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1870"
          d="M 1144.5 1629 L 1145 1631.5 L 1144 1631.5 L 1144.5 1629 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1871"
          d="M 728.5 1630 L 729 1632.5 L 728 1632.5 L 728.5 1630 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1872"
          d="M 1097.5 1632 L 1098 1634.5 L 1097 1634.5 L 1097.5 1632 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1873"
          d="M 775.5 1633 L 776 1635.5 L 775 1635.5 L 775.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1874"
          d="M 1512.5 1633 L 1513 1637.5 L 1512 1637.5 L 1512.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1875"
          d="M 1145.5 1634 L 1146 1636.5 L 1145 1636.5 L 1145.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1876"
          d="M 1465.5 1634 L 1466 1638.5 L 1465 1638.5 L 1465.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1877"
          d="M 361.5 1637 L 362 1641.5 L 361 1641.5 L 361.5 1637 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1878"
          d="M 1098.5 1637 L 1099 1639.5 L 1098 1639.5 L 1098.5 1637 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1879"
          d="M 408.5 1639 L 409 1642.5 L 408 1642.5 L 408.5 1639 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1880"
          d="M 1099.5 1642 L 1100 1644.5 L 1099 1644.5 L 1099.5 1642 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1881"
          d="M 1464.5 1643 L 1465 1646.5 L 1464 1646.5 L 1464.5 1643 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1882"
          d="M 1511.5 1643 L 1512 1646.5 L 1511 1646.5 L 1511.5 1643 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1883"
          d="M 362.5 1646 L 363 1649.5 L 362 1649.5 L 362.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1884"
          d="M 409.5 1647 L 410 1649.5 L 409 1649.5 L 409.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1885"
          d="M 1100.5 1647 L 1101 1649.5 L 1100 1649.5 L 1100.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1886"
          d="M 772.5 1648 L 773 1650.5 L 772 1650.5 L 772.5 1648 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1887"
          d="M 1463.5 1650 L 1464 1652.5 L 1463 1652.5 L 1463.5 1650 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1888"
          d="M 1510.5 1651 L 1511 1653.5 L 1510 1653.5 L 1510.5 1651 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1889"
          d="M 527.5 1652 L 528.5 1654 L 527.5 1652 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1890"
          d="M 363.5 1653 L 364 1656.5 L 363 1656.5 L 363.5 1653 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1891"
          d="M 410.5 1653 L 411 1655.5 L 410 1655.5 L 410.5 1653 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1892"
          d="M 529.5 1655 L 530.5 1657 L 529.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1893"
          d="M 1270.5 1655 L 1271.5 1657 L 1270.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1894"
          d="M 1462.5 1656 L 1463 1658.5 L 1462 1658.5 L 1462.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1895"
          d="M 1509.5 1658 L 1510 1660.5 L 1509 1660.5 L 1509.5 1658 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1896"
          d="M 411.5 1659 L 412 1661.5 L 411 1661.5 L 411.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1897"
          d="M 532.5 1659 L 540.5 1668 L 532.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1898"
          d="M 1273.5 1659 L 1277.5 1664 L 1273.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1899"
          d="M 364.5 1660 L 365 1662.5 L 364 1662.5 L 364.5 1660 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1900"
          d="M 1508.5 1664 L 1509 1666.5 L 1508 1666.5 L 1508.5 1664 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1901"
          d="M 1279.5 1665 L 1282.5 1669 L 1279.5 1665 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1902"
          d="M 1507.5 1669 L 1508 1671.5 L 1507 1671.5 L 1507.5 1669 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1903"
          d="M 1285.5 1670 L 1286.5 1672 L 1285.5 1670 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1904"
          d="M 1459.5 1671 L 1460 1673.5 L 1459 1673.5 L 1459.5 1671 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1905"
          d="M 1506.5 1674 L 1507 1676.5 L 1506 1676.5 L 1506.5 1674 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1906"
          d="M 1227.5 1675 L 1228.5 1677 L 1227.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1907"
          d="M 561.5 1676 L 564 1676.5 L 561.5 1677 L 561.5 1676 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1908"
          d="M 1311.5 1679 L 1312.5 1681 L 1311.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1909"
          d="M 572.5 1680 L 573.5 1682 L 572.5 1680 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1910"
          d="M 1314.5 1681 L 1319.5 1687 L 1314.5 1681 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1911"
          d="M 576.5 1684 L 578.5 1687 L 576.5 1684 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1912"
          d="M 1233.5 1684 L 1234.5 1686 L 1233.5 1684 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1913"
          d="M 493.5 1685 L 495.5 1688 L 493.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1914"
          d="M 1236.5 1688 L 1238.5 1691 L 1236.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1915"
          d="M 1320.5 1688 L 1321.5 1690 L 1320.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1916"
          d="M 497.5 1690 L 509.5 1703 L 497.5 1690 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1917"
          d="M 1241.5 1694 L 1248.5 1702 L 1241.5 1694 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1918"
          d="M 1323.5 1695 L 1324 1697.5 L 1323 1697.5 L 1323.5 1695 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1919"
          d="M 1251.5 1703 L 1253.5 1706 L 1251.5 1703 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1920"
          d="M 1323.5 1703 L 1324 1705.5 L 1323 1705.5 L 1323.5 1703 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1921"
          d="M 512.5 1704 L 513.5 1706 L 512.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1922"
          d="M 516.5 1707 L 517.5 1709 L 516.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1923"
          d="M 1256.5 1707 L 1257.5 1709 L 1256.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1924"
          d="M 519.5 1709 L 520.5 1711 L 519.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1925"
          d="M 1259.5 1709 L 1260.5 1711 L 1259.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1926"
          d="M 577.5 1713 L 576.5 1715 L 577.5 1713 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1927"
          d="M 1319.5 1714 L 1315.5 1719 L 1319.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1928"
          d="M 574.5 1716 L 572.5 1719 L 574.5 1716 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1929"
          d="M 547.5 1721 L 550 1721.5 L 547.5 1722 L 547.5 1721 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1930"
          d="M 553.5 1722 L 557 1722.5 L 553.5 1723 L 553.5 1722 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1931"
          d="M 561.5 1722 L 564 1722.5 L 561.5 1723 L 561.5 1722 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1932"
          d="M 1289.5 1722 L 1292 1722.5 L 1289.5 1723 L 1289.5 1722 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1933"
          d="M 1295.5 1723 L 1306 1723.5 L 1295.5 1724 L 1295.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1934"
          d="M 691.5 1729 L 690.5 1731 L 691.5 1729 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1935"
          d="M 1184.5 1734 L 1185.5 1736 L 1184.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1936"
          d="M 686.5 1737 L 685.5 1739 L 686.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1937"
          d="M 684.5 1740 L 683.5 1742 L 684.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1938"
          d="M 737.5 1743 L 736.5 1745 L 737.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1939"
          d="M 1190.5 1743 L 1191.5 1745 L 1190.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1940"
          d="M 1192.5 1746 L 1193.5 1748 L 1192.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1941"
          d="M 1430.5 1746 L 1429.5 1748 L 1430.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1942"
          d="M 679.5 1747 L 678.5 1749 L 679.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1943"
          d="M 444.5 1748 L 445.5 1750 L 444.5 1748 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1944"
          d="M 733.5 1750 L 732.5 1752 L 733.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1945"
          d="M 1195.5 1750 L 1196.5 1752 L 1195.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1946"
          d="M 676.5 1751 L 675.5 1753 L 676.5 1751 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1947"
          d="M 1198.5 1754 L 1200.5 1757 L 1198.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1948"
          d="M 1425.5 1754 L 1424.5 1756 L 1425.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1949"
          d="M 673.5 1755 L 671.5 1758 L 673.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1950"
          d="M 730.5 1755 L 729.5 1757 L 730.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1951"
          d="M 1478.5 1755 L 1477.5 1757 L 1478.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1952"
          d="M 450.5 1757 L 451.5 1759 L 450.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1953"
          d="M 397.5 1759 L 398.5 1761 L 397.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1954"
          d="M 1202.5 1759 L 1205.5 1763 L 1202.5 1759 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1955"
          d="M 452.5 1760 L 453.5 1762 L 452.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1956"
          d="M 669.5 1760 L 665.5 1765 L 669.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1957"
          d="M 1145.5 1760 L 1146.5 1762 L 1145.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1958"
          d="M 1420.5 1761 L 1419.5 1763 L 1420.5 1761 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1959"
          d="M 1147.5 1763 L 1148.5 1765 L 1147.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1960"
          d="M 455.5 1764 L 457.5 1767 L 455.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1961"
          d="M 1207.5 1765 L 1225.5 1784 L 1207.5 1765 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1962"
          d="M 1417.5 1765 L 1415.5 1768 L 1417.5 1765 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1963"
          d="M 401.5 1766 L 402.5 1768 L 401.5 1766 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1964"
          d="M 1149.5 1766 L 1150.5 1768 L 1149.5 1766 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1965"
          d="M 662.5 1768 L 650.5 1781 L 662.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1966"
          d="M 459.5 1769 L 462.5 1773 L 459.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1967"
          d="M 1151.5 1769 L 1152.5 1771 L 1151.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1968"
          d="M 1413.5 1770 L 1410.5 1774 L 1413.5 1770 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1969"
          d="M 404.5 1771 L 405.5 1773 L 404.5 1771 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1970"
          d="M 718.5 1773 L 717.5 1775 L 718.5 1773 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1971"
          d="M 1154.5 1773 L 1155.5 1775 L 1154.5 1773 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1972"
          d="M 1467.5 1774 L 1466.5 1776 L 1467.5 1774 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1973"
          d="M 465.5 1776 L 475.5 1787 L 465.5 1776 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1974"
          d="M 1156.5 1776 L 1157.5 1778 L 1156.5 1776 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1975"
          d="M 715.5 1777 L 714.5 1779 L 715.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1976"
          d="M 1465.5 1777 L 1464.5 1779 L 1465.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1977"
          d="M 1406.5 1778 L 1399.5 1786 L 1406.5 1778 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1978"
          d="M 1159.5 1780 L 1161.5 1783 L 1159.5 1780 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1979"
          d="M 1463.5 1780 L 1462.5 1782 L 1463.5 1780 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1980"
          d="M 712.5 1781 L 711.5 1783 L 712.5 1781 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1981"
          d="M 412.5 1783 L 413.5 1785 L 412.5 1783 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1982"
          d="M 646.5 1783 L 643.5 1787 L 646.5 1783 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1983"
          d="M 1461.5 1783 L 1460.5 1785 L 1461.5 1783 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1984"
          d="M 1162.5 1784 L 1164.5 1787 L 1162.5 1784 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1985"
          d="M 709.5 1785 L 707.5 1788 L 709.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1986"
          d="M 1228.5 1785 L 1231.5 1789 L 1228.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1987"
          d="M 414.5 1786 L 415.5 1788 L 414.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1988"
          d="M 1459.5 1786 L 1458.5 1788 L 1459.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1989"
          d="M 640.5 1788 L 638.5 1791 L 640.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1990"
          d="M 1395.5 1788 L 1392.5 1792 L 1395.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1991"
          d="M 479.5 1789 L 482.5 1793 L 479.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1992"
          d="M 417.5 1790 L 418.5 1792 L 417.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1993"
          d="M 705.5 1790 L 701.5 1795 L 705.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1994"
          d="M 1167.5 1790 L 1170.5 1794 L 1167.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1995"
          d="M 1234.5 1790 L 1235.5 1792 L 1234.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1996"
          d="M 1456.5 1790 L 1455.5 1792 L 1456.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1997"
          d="M 635.5 1792 L 634.5 1794 L 635.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1998"
          d="M 1238.5 1793 L 1239.5 1795 L 1238.5 1793 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_1999"
          d="M 1389.5 1793 L 1387.5 1796 L 1389.5 1793 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2000"
          d="M 420.5 1794 L 422.5 1797 L 420.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2001"
          d="M 485.5 1794 L 486.5 1796 L 485.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2002"
          d="M 632.5 1794 L 631.5 1796 L 632.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2003"
          d="M 1453.5 1794 L 1451.5 1797 L 1453.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2004"
          d="M 1172.5 1796 L 1181.5 1806 L 1172.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2005"
          d="M 1384.5 1797 L 1383.5 1799 L 1384.5 1797 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2006"
          d="M 698.5 1798 L 680.5 1817 L 698.5 1798 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2007"
          d="M 424.5 1799 L 427.5 1803 L 424.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2008"
          d="M 1381.5 1799 L 1380.5 1801 L 1381.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2009"
          d="M 1449.5 1799 L 1446.5 1803 L 1449.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2010"
          d="M 429.5 1805 L 447.5 1824 L 429.5 1805 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2011"
          d="M 1371.5 1805 L 1370.5 1807 L 1371.5 1805 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2012"
          d="M 1443.5 1806 L 1426.5 1824 L 1443.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2013"
          d="M 1186.5 1810 L 1194.5 1819 L 1186.5 1810 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2014"
          d="M 538.5 1818 L 541 1818.5 L 538.5 1819 L 538.5 1818 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2015"
          d="M 575.5 1818 L 578 1818.5 L 575.5 1819 L 575.5 1818 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2016"
          d="M 1292.5 1818 L 1295 1818.5 L 1292.5 1819 L 1292.5 1818 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2017"
          d="M 1335.5 1818 L 1338 1818.5 L 1335.5 1819 L 1335.5 1818 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2018"
          d="M 544.5 1819 L 549 1819.5 L 544.5 1820 L 544.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2019"
          d="M 567.5 1819 L 571 1819.5 L 567.5 1820 L 567.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2020"
          d="M 676.5 1819 L 673.5 1823 L 676.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2021"
          d="M 1298.5 1819 L 1302 1819.5 L 1298.5 1820 L 1298.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2022"
          d="M 1329.5 1819 L 1332 1819.5 L 1329.5 1820 L 1329.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2023"
          d="M 1307.5 1820 L 1324 1820.5 L 1307.5 1821 L 1307.5 1820 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2024"
          d="M 1198.5 1821 L 1201.5 1825 L 1198.5 1821 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2025"
          d="M 670.5 1824 L 668.5 1827 L 670.5 1824 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2026"
          d="M 450.5 1825 L 453.5 1829 L 450.5 1825 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2027"
          d="M 1204.5 1826 L 1205.5 1828 L 1204.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2028"
          d="M 1422.5 1826 L 1420.5 1829 L 1422.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2029"
          d="M 665.5 1828 L 664.5 1830 L 665.5 1828 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2030"
          d="M 1208.5 1829 L 1209.5 1831 L 1208.5 1829 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2031"
          d="M 456.5 1830 L 458.5 1833 L 456.5 1830 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2032"
          d="M 1417.5 1830 L 1415.5 1833 L 1417.5 1830 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2033"
          d="M 661.5 1831 L 660.5 1833 L 661.5 1831 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2034"
          d="M 1212.5 1832 L 1213.5 1834 L 1212.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2035"
          d="M 460.5 1833 L 461.5 1835 L 460.5 1833 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2036"
          d="M 658.5 1833 L 657.5 1835 L 658.5 1833 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2037"
          d="M 1215.5 1834 L 1216.5 1836 L 1215.5 1834 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2038"
          d="M 1412.5 1834 L 1411.5 1836 L 1412.5 1834 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2039"
          d="M 464.5 1836 L 465.5 1838 L 464.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2040"
          d="M 1409.5 1836 L 1408.5 1838 L 1409.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2041"
          d="M 467.5 1838 L 468.5 1840 L 467.5 1838 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2042"
          d="M 1221.5 1838 L 1222.5 1840 L 1221.5 1838 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2043"
          d="M 649.5 1839 L 648.5 1841 L 649.5 1839 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2044"
          d="M 470.5 1840 L 471.5 1842 L 470.5 1840 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2045"
          d="M 644.5 1842 L 643.5 1844 L 644.5 1842 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2046"
          d="M 1400.5 1842 L 1399.5 1844 L 1400.5 1842 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2047"
          d="M 1395.5 1845 L 1394.5 1847 L 1395.5 1845 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2048"
          d="M 482.5 1847 L 483.5 1849 L 482.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2049"
          d="M 594.5 1862 L 597 1862.5 L 594.5 1863 L 594.5 1862 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2050"
          d="M 524.5 1863 L 527 1863.5 L 524.5 1864 L 524.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2051"
          d="M 584.5 1864 L 587 1864.5 L 584.5 1865 L 584.5 1864 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2052"
          d="M 1284.5 1864 L 1287 1864.5 L 1284.5 1865 L 1284.5 1864 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2053"
          d="M 536.5 1865 L 540 1865.5 L 536.5 1866 L 536.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2054"
          d="M 577.5 1865 L 581 1865.5 L 577.5 1866 L 577.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2055"
          d="M 1290.5 1865 L 1293 1865.5 L 1290.5 1866 L 1290.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2056"
          d="M 1337.5 1865 L 1341 1865.5 L 1337.5 1866 L 1337.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2057"
          d="M 545.5 1866 L 554 1866.5 L 545.5 1867 L 545.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2058"
          d="M 562.5 1866 L 572 1866.5 L 562.5 1867 L 562.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2059"
          d="M 1297.5 1866 L 1302 1866.5 L 1297.5 1867 L 1297.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2060"
          d="M 1328.5 1866 L 1333 1866.5 L 1328.5 1867 L 1328.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.6941176"
          stroke="currentColor"
          strokeOpacity="0.6941176"
          strokeWidth="1"/>
        <path
          id="path_2061"
          d="M 1837.5 1 L 1850.5 1 Q 1858.5 3.5 1863 9.5 Q 1869 15.5 1867 29.5 Q 1864.5 38.5 1857.5 43 L 1843.5 48 L 1772.5 62 L 1767.5 62 L 1756.5 65 L 1740.5 67 L 1734.5 69 L 1717.5 71 L 1711.5 73 L 1706.5 73 L 1657.5 82 L 1651.5 82 L 1618.5 88 L 1598.5 90 L 1591.5 92 L 1577.5 93 L 1576.5 94 L 1548.5 97 L 1540.5 99 L 1533.5 99 L 1532.5 100 L 1525.5 100 L 1524.5 101 L 1517.5 101 L 1516 102.5 L 1516 111.5 L 1517 112.5 L 1517 121.5 L 1518 122.5 L 1518 131.5 L 1519 132.5 L 1519 141.5 L 1520 142.5 L 1522 170 L 1548.5 168 L 1549.5 167 L 1562.5 167 L 1579.5 172 L 1595 184.5 Q 1603.5 194 1606 209.5 L 1606 218.5 L 1607 219.5 L 1610 258.5 L 1612 268.5 L 1612 277.5 Q 1614.8 279.3 1613 285.5 L 1614.5 287 Q 1648.3 302.7 1671 329.5 Q 1692 353.5 1707 383.5 Q 1720.7 411.3 1730 443.5 L 1738 475.5 L 1743 502.5 L 1744 515.5 L 1745 516.5 L 1745 523.5 L 1747 532.5 L 1747 542.5 L 1748 543.5 L 1748 558.5 L 1749 559.5 L 1749 590.5 L 1748 591.5 L 1748 606.5 L 1747 607.5 L 1746 624.5 L 1741 653.5 Q 1734.5 682.5 1724 707.5 Q 1702.5 759.5 1664.5 795 Q 1639.6 818.6 1604.5 832 L 1587.5 837 L 1570.5 840 L 1539.5 841 L 1538.5 840 L 1522.5 839 L 1498.5 833 L 1470.5 821 Q 1432.9 800.1 1406 768.5 Q 1362.2 718.3 1341 645.5 L 1334 616.5 L 1334 611.5 L 1330 592.5 L 1329 576.5 L 1328 575.5 L 1327 548.5 L 1326 547.5 L 1326 497.5 L 1327 496.5 L 1327 482.5 L 1328 481.5 L 1328 472.5 L 1329 471.5 L 1329 464.5 L 1330 463.5 L 1332 445.5 L 1339 415.5 L 1346 394.5 Q 1362.8 349.3 1394.5 319 L 1410 306.5 L 1402 223.5 L 1404 212.5 L 1409 201.5 L 1419.5 189 Q 1427.2 182.2 1438.5 179 L 1476 175 L 1470 107 L 1456.5 108 L 1455.5 109 L 1447.5 109 L 1446.5 110 L 1438.5 110 L 1437.5 111 L 1419.5 112 L 1418.5 113 L 1389.5 115 L 1388.5 116 L 1346.5 119 L 1345.5 120 L 1297.5 123 L 1296.5 124 L 1284.5 124 L 1283.5 125 L 1270.5 125 L 1269.5 126 L 1240.5 127 L 1239.5 128 L 1208.5 129 L 1207.5 130 L 1149.5 132 L 1148.5 133 L 1126.5 133 L 1125.5 134 L 1099.5 134 L 1098.5 135 L 1067.5 135 L 1066.5 136 L 958.5 137 L 957 138.5 L 957 200 L 987.5 200 L 988.5 201 L 996.5 201 L 1006.5 204 Q 1016.3 208.3 1023 215.5 Q 1032.9 225.1 1036 241.5 L 1036 324.5 L 1037.5 326 Q 1061.8 339.7 1079 360.5 Q 1099.2 384.3 1113 414.5 L 1120 431.5 L 1131 466.5 L 1139 506.5 L 1141 528.5 L 1142 529.5 L 1142 539.5 L 1143 540.5 L 1143 554.5 L 1144 555.5 L 1144 612.5 L 1143 613.5 L 1143 624.5 L 1142 625.5 L 1141 641.5 L 1134 677.5 L 1124 710.5 L 1113 737.5 Q 1088.7 790.7 1047.5 827 Q 1021.9 849.9 986.5 863 L 968.5 868 L 958.5 870 L 951.5 870 L 950.5 871 L 918.5 871 L 891.5 866 Q 869.4 859.6 851.5 849 Q 823.9 832.6 803 809.5 Q 761.9 765.1 741 700.5 L 732 666.5 L 727 637.5 L 726 620.5 L 725 619.5 L 725 604.5 L 724 603.5 L 724 566.5 L 725 565.5 L 726 534.5 L 727 533.5 L 728 516.5 L 729 515.5 L 732 491.5 L 738 464.5 L 747 435.5 Q 756.8 408.3 771 385.5 Q 785.3 362.8 804.5 345 L 832 324.5 L 832 243.5 Q 835.8 221.8 850.5 211 Q 858.8 203.8 871.5 201 L 911 200 L 911 137 L 838.5 137 L 837.5 136 L 796.5 136 L 795.5 135 L 737.5 134 L 736.5 133 L 714.5 133 L 713.5 132 L 693.5 132 L 692.5 131 L 674.5 131 L 673.5 130 L 656.5 130 L 655.5 129 L 608.5 127 L 607.5 126 L 580.5 125 L 579.5 124 L 567.5 124 L 566.5 123 L 554.5 123 L 553.5 122 L 542.5 122 L 541.5 121 L 530.5 121 L 529.5 120 L 485.5 117 L 484.5 116 L 445.5 113 L 444.5 112 L 426.5 111 L 425.5 110 L 417.5 110 L 416.5 109 Q 408.5 109.7 404 108 L 403 113.5 L 403 122.5 L 402 123.5 L 402 132.5 L 401 133.5 L 401 142.5 L 400 143.5 L 400 152.5 L 399 153.5 L 399 162.5 L 398 163.5 L 398 172.5 L 397 173.5 L 398.5 175 Q 403.3 173.7 404.5 176 L 431.5 178 L 441.5 181 Q 454.1 186.9 462 197.5 Q 468.7 205.8 471 218.5 L 471 235.5 L 470 236.5 L 465 295.5 L 464 296.5 L 464 306.5 L 491 331.5 Q 504.7 347.3 515 366.5 Q 528 391 536 420.5 L 542 447.5 L 544 466.5 L 545 467.5 L 545 475.5 L 546 476.5 L 547 507.5 L 548 508.5 L 548 535.5 L 547 536.5 L 546 570.5 L 545 571.5 L 545 580.5 L 544 581.5 L 544 589.5 L 543 590.5 L 541 608.5 L 533 643.5 L 521 679.5 Q 494.4 746.4 445.5 791 Q 418.4 816.4 380.5 831 L 350.5 839 L 334.5 840 L 333.5 841 L 313.5 841 L 312.5 840 L 296.5 839 L 278.5 835 L 248.5 823 Q 216 805.5 193 778.5 Q 158.1 738.4 140 681.5 L 133 655.5 L 128 628.5 L 128 621.5 L 127 620.5 L 126 600.5 L 125 599.5 L 125 550.5 L 126 549.5 L 126 538.5 L 127 537.5 L 129 512.5 L 136 473.5 L 145 438.5 L 155 409.5 Q 166.4 380.9 182 356.5 Q 195 336.5 211.5 320 Q 232.2 299.2 260 285.5 L 261 283.5 L 261 274.5 L 262 273.5 L 262 264.5 L 263 263.5 L 263 254.5 L 264 253.5 L 268 206.5 Q 272.4 186.9 286.5 177 Q 299.1 165.6 324.5 167 L 325.5 168 L 334.5 168 L 335.5 169 L 351 170 L 352 167.5 L 352 158.5 L 353 157.5 L 353 148.5 L 354 147.5 L 354 138.5 L 355 137.5 L 355 128.5 L 356 127.5 L 356 118.5 L 357 117.5 L 357 108.5 L 358 103 L 354.5 102 L 309.5 97 L 308.5 96 L 301.5 96 L 300.5 95 L 294.5 95 L 293.5 94 L 287.5 94 L 286.5 93 L 280.5 93 L 251.5 88 L 245.5 88 L 238.5 86 L 206.5 82 L 157.5 73 L 146.5 72 L 140.5 70 L 129.5 69 L 123.5 67 L 96.5 63 L 20.5 48 Q 11.1 45.9 6 39.5 L 1 29.5 L 1 20.5 Q 3.3 9.8 11.5 5 Q 17.3 -0.2 30.5 2 L 140.5 24 L 145.5 24 L 157.5 27 L 162.5 27 L 211.5 36 L 217.5 36 L 230.5 39 L 256.5 42 L 263.5 44 L 269.5 44 L 298.5 49 L 305.5 49 L 320.5 52 L 327.5 52 L 335.5 54 L 391.5 60 L 392.5 61 L 400.5 61 L 401.5 62 L 409.5 62 L 418.5 64 L 445.5 66 L 446.5 67 L 455.5 67 L 456.5 68 L 465.5 68 L 466.5 69 L 475.5 69 L 476.5 70 L 485.5 70 L 486.5 71 L 529.5 74 L 530.5 75 L 554.5 76 L 555.5 77 L 579.5 78 L 580.5 79 L 593.5 79 L 594.5 80 L 607.5 80 L 608.5 81 L 622.5 81 L 623.5 82 L 638.5 82 L 639.5 83 L 692.5 85 L 693.5 86 L 713.5 86 L 714.5 87 L 736.5 87 L 737.5 88 L 762.5 88 L 763.5 89 L 835.5 90 L 836.5 91 L 1026.5 91 L 1027.5 90 L 1099.5 89 L 1100.5 88 L 1126.5 88 L 1127.5 87 L 1149.5 87 L 1150.5 86 L 1207.5 84 L 1208.5 83 L 1223.5 83 L 1224.5 82 L 1239.5 82 L 1240.5 81 L 1254.5 81 L 1255.5 80 L 1308.5 77 L 1309.5 76 L 1344.5 74 L 1345.5 73 L 1355.5 73 L 1356.5 72 L 1366.5 72 L 1367.5 71 L 1426.5 66 L 1427.5 65 L 1435.5 65 L 1436.5 64 L 1444.5 64 L 1445.5 63 L 1453.5 63 L 1454.5 62 L 1462.5 62 L 1471.5 60 L 1479.5 60 L 1480.5 59 L 1535.5 53 L 1543.5 51 L 1550.5 51 L 1551.5 50 L 1613.5 42 L 1633.5 38 L 1639.5 38 L 1640.5 37 L 1717.5 25 L 1745.5 19 L 1750.5 19 L 1761.5 16 L 1766.5 16 L 1782.5 12 L 1787.5 12 L 1832.5 3 L 1837.5 1 Z M 317 213 L 314 214 L 308 279 L 418 290 L 419 289 Q 417 282 420 281 L 420 272 L 421 271 L 421 262 L 422 261 L 422 252 L 423 251 L 425 226 L 420 223 L 411 223 L 410 222 L 401 222 L 400 221 L 391 221 L 390 220 L 381 220 L 380 219 L 371 219 L 370 218 L 361 218 L 360 217 L 351 217 L 350 216 L 341 216 L 340 215 L 331 215 L 330 214 L 317 213 Z M 1555 213 L 1554 214 L 1495 219 L 1494 220 L 1485 220 L 1484 221 L 1475 221 L 1474 222 L 1465 222 L 1464 223 L 1455 223 L 1449 226 L 1449 235 L 1450 236 L 1450 245 L 1451 246 L 1451 255 L 1452 256 L 1452 265 L 1453 266 L 1453 275 L 1454 276 L 1454 285 L 1455 290 L 1459 289 L 1468 289 L 1469 288 L 1478 288 L 1479 287 L 1488 287 L 1489 286 L 1498 286 L 1499 285 L 1508 285 L 1509 284 L 1518 284 L 1519 283 L 1528 283 L 1529 282 L 1538 282 L 1539 281 L 1566 279 L 1560 216 Q 1559 212 1555 213 Z M 879 247 L 878 250 L 878 312 L 880 313 L 990 313 L 990 249 L 989 247 L 879 247 Z M 290 324 Q 265 333 248 350 Q 231 366 219 386 Q 205 408 195 436 L 187 461 L 178 500 L 175 525 L 174 526 L 174 533 L 173 534 L 172 555 L 171 556 L 171 595 L 172 596 L 172 608 L 173 609 L 175 630 L 183 664 Q 199 717 232 753 Q 250 772 275 784 L 294 791 L 308 794 L 317 794 L 318 795 L 330 795 L 331 794 L 345 793 L 369 786 Q 392 776 411 760 Q 451 725 474 672 L 482 652 L 491 622 L 497 592 L 499 567 L 500 566 L 500 554 L 501 553 L 501 495 L 500 494 L 500 483 L 498 474 L 498 467 L 493 441 L 481 404 Q 472 382 458 365 Q 445 348 426 337 L 382 333 L 381 332 L 372 332 L 371 331 L 362 331 L 361 330 L 352 330 L 351 329 L 342 329 L 341 328 L 332 328 L 331 327 L 322 327 L 321 326 L 312 326 L 311 325 L 302 325 L 301 324 L 290 324 Z M 1574 324 L 1573 325 L 1564 325 L 1563 326 L 1554 326 L 1553 327 L 1544 327 L 1543 328 L 1534 328 L 1533 329 L 1524 329 L 1523 330 L 1514 330 L 1513 331 L 1504 331 L 1503 332 L 1494 332 L 1493 333 L 1484 333 L 1483 334 L 1474 334 L 1473 335 L 1448 337 L 1430 350 Q 1403 375 1389 413 L 1381 439 L 1377 458 L 1375 478 L 1374 479 L 1374 489 L 1373 490 L 1373 505 L 1372 506 L 1372 542 L 1373 543 L 1373 559 L 1374 560 L 1375 580 L 1376 581 L 1376 588 L 1379 601 L 1379 606 L 1387 638 Q 1406 699 1444 742 Q 1464 764 1491 779 L 1517 790 L 1529 793 L 1544 794 L 1545 795 L 1566 794 L 1590 788 Q 1613 779 1630 764 Q 1664 733 1683 686 Q 1693 661 1698 633 L 1700 614 L 1701 613 L 1701 604 L 1702 603 L 1702 587 L 1703 586 L 1703 565 L 1702 564 L 1702 548 L 1701 547 L 1700 529 L 1699 528 L 1697 508 L 1695 502 L 1693 487 L 1686 459 Q 1676 424 1660 395 L 1638 363 Q 1624 345 1604 333 L 1585 324 L 1574 324 Z M 867 359 Q 851 366 840 376 Q 824 389 813 407 Q 799 428 790 454 L 784 473 L 776 509 L 774 530 L 773 531 L 773 539 L 772 540 L 771 572 L 770 573 L 770 599 L 771 600 L 771 616 L 772 617 L 773 634 L 777 657 L 784 684 Q 800 736 832 774 Q 850 795 875 809 L 903 821 L 923 825 L 946 825 Q 947 823 953 824 L 978 817 Q 1004 806 1024 787 Q 1056 755 1075 710 Q 1085 686 1091 659 L 1095 637 L 1096 621 L 1097 620 L 1097 609 L 1098 608 L 1098 562 L 1097 561 L 1096 536 L 1095 535 L 1095 527 L 1094 526 L 1094 519 L 1091 506 L 1091 501 L 1085 475 Q 1078 447 1066 425 Q 1054 402 1038 385 Q 1023 368 1002 359 L 867 359 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_2062"
          d="M 252.5 531 Q 268.4 530.6 274 540.5 L 278 548.5 L 278 566.5 Q 275.7 567.8 277 572.5 L 278 573.5 L 279 591.5 L 284 610.5 Q 290.5 629 303.5 641 Q 313.3 650.7 331.5 652 Q 338.9 654.6 343 660.5 Q 348.5 666.5 347 679.5 L 341 691 L 329.5 697 L 316.5 697 Q 279.8 689.2 261 663.5 Q 244.8 644.2 237 616.5 L 232 591.5 L 231 561.5 L 232 560.5 L 233 546.5 L 240.5 536 L 252.5 531 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_2063"
          d="M 1464.5 531 Q 1478 531 1484 538.5 Q 1490.6 544.9 1490 558.5 L 1489 559.5 L 1489 580.5 L 1490 581.5 L 1491 594.5 L 1498 616.5 Q 1505.1 632.4 1517.5 643 L 1530.5 650 L 1543.5 652 L 1553 658.5 Q 1559.1 664.4 1559 676.5 Q 1557 688.5 1548.5 694 Q 1541.9 698.9 1528.5 697 L 1515.5 694 L 1501.5 688 Q 1486.2 679.3 1475 666.5 Q 1458.6 647.9 1450 621.5 L 1446 606.5 L 1444 587.5 L 1443 586.5 L 1443 554.5 L 1447 541.5 L 1453.5 535 L 1464.5 531 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_2064"
          d="M 850.5 569 L 861.5 570 L 872 577.5 L 877 588.5 L 878 612.5 L 884 635.5 Q 892 658 908.5 672 L 922.5 680 L 943.5 683 L 953 690.5 Q 959 696.5 957 710.5 Q 954.5 719.5 947.5 724 L 937.5 728 L 927.5 728 L 911.5 725 L 890.5 716 Q 875.8 707.2 865 694.5 Q 846 673 837 641.5 L 831 609.5 L 831 586.5 Q 833.4 577.4 840.5 573 L 850.5 569 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_2065"
          d="M 1841.5 996 L 1851.5 997 Q 1859.6 999.9 1864 1006.5 Q 1868.8 1012.7 1867 1025.5 Q 1864.5 1033.5 1858.5 1038 L 1846.5 1043 L 1781.5 1056 L 1776.5 1056 L 1715.5 1068 L 1710.5 1068 L 1661.5 1077 L 1655.5 1077 L 1642.5 1080 L 1636.5 1080 L 1629.5 1082 L 1616.5 1083 L 1609.5 1085 L 1603.5 1085 L 1602.5 1086 L 1596.5 1086 L 1567.5 1091 L 1560.5 1091 L 1552.5 1093 L 1545.5 1093 L 1537.5 1095 L 1530.5 1095 L 1529.5 1096 L 1522.5 1096 L 1521.5 1097 L 1514.5 1097 L 1513.5 1098 L 1506.5 1098 L 1505.5 1099 L 1498.5 1099 L 1481.5 1102 L 1473.5 1102 L 1472.5 1103 L 1464.5 1103 L 1463.5 1104 L 1455.5 1104 L 1454.5 1105 L 1446.5 1105 L 1445.5 1106 L 1437.5 1106 L 1436.5 1107 L 1428.5 1107 L 1427.5 1108 L 1418.5 1108 L 1417.5 1109 L 1408.5 1109 L 1407.5 1110 L 1398.5 1110 L 1397.5 1111 L 1388.5 1111 L 1377.5 1113 L 1367.5 1113 L 1366.5 1114 L 1356.5 1114 L 1355.5 1115 L 1345.5 1115 L 1344.5 1116 L 1309.5 1118 L 1308.5 1119 L 1282.5 1120 L 1280 1121 L 1287 1196 L 1315.5 1194 L 1316.5 1193 L 1326.5 1193 L 1336.5 1195 L 1347.5 1200 L 1359 1209.5 Q 1368.4 1219.1 1371 1235.5 L 1375 1283.5 L 1376 1284.5 L 1376 1293.5 L 1377 1294.5 L 1377 1303.5 Q 1379.8 1305.2 1378 1311.5 L 1379.5 1313 Q 1412.8 1328.2 1435 1354.5 Q 1452 1373.5 1465 1396.5 Q 1481.1 1425.4 1492 1459.5 L 1503 1501.5 L 1510 1541.5 L 1512 1567.5 L 1513 1568.5 L 1513 1583.5 L 1514 1584.5 L 1514 1616.5 L 1513 1617.5 L 1513 1632.5 L 1512 1633.5 L 1511 1650.5 L 1506 1678.5 L 1498 1708.5 L 1487 1737.5 Q 1464.1 1790.6 1423.5 1826 Q 1400.7 1846.2 1369.5 1858 L 1348.5 1864 L 1337.5 1865 L 1336.5 1866 L 1328.5 1866 L 1327.5 1867 L 1302.5 1867 L 1269.5 1861 Q 1248.7 1854.8 1231.5 1845 Q 1203.6 1828.9 1182 1806.5 Q 1134 1757.5 1110 1684.5 L 1101 1651.5 L 1096 1625.5 L 1095 1611.5 L 1094 1610.5 L 1093 1589.5 L 1092 1588.5 L 1092 1573.5 L 1091 1572.5 L 1091 1524.5 L 1092 1523.5 L 1092 1509.5 L 1093 1508.5 L 1094 1490.5 L 1099 1461.5 Q 1105.1 1434.1 1115 1410.5 Q 1133.3 1367.3 1166.5 1339 L 1175 1332.5 L 1167 1249.5 L 1170 1235.5 Q 1174.8 1223.8 1183.5 1216 Q 1191.5 1208.5 1203.5 1205 L 1241 1201 L 1234 1124 L 1200.5 1125 L 1199.5 1126 L 1182.5 1126 L 1181.5 1127 L 1162.5 1127 L 1161.5 1128 L 1141.5 1128 L 1140.5 1129 L 1117.5 1129 L 1116.5 1130 L 1058.5 1131 L 1057.5 1132 L 1014.5 1132 L 1013.5 1133 L 850.5 1133 L 849.5 1132 L 806.5 1132 L 805.5 1131 L 774.5 1131 L 773.5 1130 L 723.5 1129 L 722.5 1128 L 682.5 1127 L 681.5 1126 L 664.5 1126 L 663.5 1125 L 647.5 1125 L 646.5 1124 L 640 1124 L 639 1126.5 L 639 1135.5 L 638 1136.5 L 633 1195.5 L 632 1198 L 634.5 1199 L 643.5 1199 L 644.5 1200 L 668.5 1202 Q 685.4 1206.6 695 1218.5 Q 701.8 1226.2 705 1237.5 L 706 1242.5 L 706 1258.5 L 705 1259.5 L 705 1268.5 L 704 1269.5 L 704 1278.5 L 703 1279.5 L 703 1288.5 L 702 1289.5 L 702 1298.5 L 701 1299.5 L 701 1308.5 L 700 1309.5 L 700 1318.5 L 698 1329.5 L 725 1354.5 Q 740.7 1372.3 752 1394.5 L 761 1414.5 L 770 1441.5 L 777 1472.5 L 779 1492.5 L 780 1493.5 L 781 1513.5 L 782 1514.5 L 783 1555.5 L 782 1556.5 L 782 1580.5 L 781 1581.5 L 780 1604.5 L 779 1605.5 L 779 1612.5 L 778 1613.5 L 778 1620.5 L 777 1621.5 L 775 1638.5 L 765 1678.5 L 753 1711.5 Q 726 1776 677.5 1819 Q 651 1843 614.5 1857 L 589.5 1864 L 577.5 1865 L 576.5 1866 L 554.5 1867 L 553.5 1866 L 532.5 1865 L 514.5 1861 L 484.5 1849 Q 451.4 1831.1 428 1803.5 Q 391.1 1760.9 373 1699.5 L 365 1665.5 L 363 1646.5 L 362 1645.5 L 362 1637.5 L 361 1636.5 L 361 1625.5 L 360 1624.5 L 360 1574.5 L 361 1573.5 L 361 1562.5 L 362 1561.5 L 363 1544.5 L 364 1543.5 L 366 1523.5 L 368 1517.5 L 371 1497.5 L 381 1459.5 L 393 1426.5 Q 405.9 1395.9 424 1370.5 Q 438.7 1350.2 457.5 1334 Q 474.2 1319.7 495 1309.5 L 496 1307.5 L 496 1298.5 L 497 1297.5 L 497 1288.5 L 498 1287.5 L 498 1278.5 L 499 1277.5 L 503 1230.5 Q 506.9 1212.9 518.5 1203 Q 526.4 1195.4 538.5 1192 L 542.5 1191 L 563.5 1191 L 564.5 1192 L 583.5 1193 L 586 1194 L 587 1191.5 L 587 1182.5 L 588 1181.5 L 588 1172.5 L 589 1171.5 L 593 1121 L 544.5 1118 L 543.5 1117 L 532.5 1117 L 531.5 1116 L 520.5 1116 L 519.5 1115 L 509.5 1115 L 508.5 1114 L 498.5 1114 L 497.5 1113 L 487.5 1113 L 486.5 1112 L 476.5 1112 L 475.5 1111 L 446.5 1109 L 436.5 1107 L 427.5 1107 L 426.5 1106 L 418.5 1106 L 417.5 1105 L 409.5 1105 L 408.5 1104 L 400.5 1104 L 399.5 1103 L 391.5 1103 L 382.5 1101 L 374.5 1101 L 373.5 1100 L 326.5 1095 L 318.5 1093 L 311.5 1093 L 310.5 1092 L 296.5 1091 L 295.5 1090 L 254.5 1085 L 247.5 1083 L 234.5 1082 L 227.5 1080 L 221.5 1080 L 220.5 1079 L 202.5 1077 L 201.5 1076 L 148.5 1068 L 142.5 1066 L 131.5 1065 L 17.5 1043 Q 8.8 1039.8 4 1032.5 L 1 1024.5 L 1 1016.5 Q 3.1 1007.1 9.5 1002 Q 15.7 996.7 27.5 997 L 42.5 1001 L 67.5 1006 L 72.5 1006 L 93.5 1011 L 98.5 1011 L 109.5 1014 L 114.5 1014 L 159.5 1023 L 170.5 1024 L 207.5 1031 L 213.5 1031 L 226.5 1034 L 232.5 1034 L 239.5 1036 L 245.5 1036 L 252.5 1038 L 258.5 1038 L 259.5 1039 L 265.5 1039 L 266.5 1040 L 272.5 1040 L 273.5 1041 L 279.5 1041 L 280.5 1042 L 286.5 1042 L 315.5 1047 L 322.5 1047 L 330.5 1049 L 377.5 1054 L 378.5 1055 L 386.5 1055 L 395.5 1057 L 403.5 1057 L 404.5 1058 L 412.5 1058 L 413.5 1059 L 421.5 1059 L 422.5 1060 L 430.5 1060 L 440.5 1062 L 449.5 1062 L 459.5 1064 L 468.5 1064 L 469.5 1065 L 489.5 1066 L 490.5 1067 L 534.5 1070 L 535.5 1071 L 546.5 1071 L 547.5 1072 L 558.5 1072 L 559.5 1073 L 571.5 1073 L 572.5 1074 L 584.5 1074 L 585.5 1075 L 628.5 1077 L 629.5 1078 L 679.5 1080 L 680.5 1081 L 699.5 1081 L 700.5 1082 L 721.5 1082 L 722.5 1083 L 745.5 1083 L 746.5 1084 L 807.5 1085 L 808.5 1086 L 855.5 1086 L 856.5 1087 L 1007.5 1087 L 1008.5 1086 L 1055.5 1086 L 1056.5 1085 L 1117.5 1084 L 1118.5 1083 L 1141.5 1083 L 1142.5 1082 L 1163.5 1082 L 1164.5 1081 L 1218.5 1079 L 1219.5 1078 L 1234.5 1078 L 1235.5 1077 L 1249.5 1077 L 1250.5 1076 L 1264.5 1076 L 1265.5 1075 L 1277.5 1075 L 1278.5 1074 L 1304.5 1073 L 1305.5 1072 L 1340.5 1070 L 1341.5 1069 L 1351.5 1069 L 1352.5 1068 L 1362.5 1068 L 1363.5 1067 L 1373.5 1067 L 1374.5 1066 L 1423.5 1062 L 1424.5 1061 L 1468.5 1057 L 1469.5 1056 L 1476.5 1056 L 1477.5 1055 L 1540.5 1048 L 1541.5 1047 L 1617.5 1037 L 1624.5 1035 L 1630.5 1035 L 1637.5 1033 L 1643.5 1033 L 1644.5 1032 L 1715.5 1021 L 1754.5 1013 L 1759.5 1013 L 1841.5 996 Z M 551 1237 L 548 1243 L 548 1252 L 547 1253 L 543 1303 L 571 1305 L 572 1306 L 581 1306 L 582 1307 L 591 1307 L 592 1308 L 601 1308 L 602 1309 L 611 1309 L 612 1310 L 621 1310 L 622 1311 L 631 1311 L 632 1312 L 641 1312 L 642 1313 L 651 1313 L 653 1314 L 654 1313 L 660 1250 L 658 1247 L 551 1237 Z M 1321 1239 L 1320 1240 L 1261 1245 L 1260 1246 L 1251 1246 L 1250 1247 L 1241 1247 L 1240 1248 L 1231 1248 L 1230 1249 L 1221 1249 L 1214 1252 L 1214 1262 L 1215 1263 L 1215 1272 L 1216 1273 L 1216 1282 L 1217 1283 L 1217 1292 L 1218 1293 L 1218 1302 L 1219 1303 Q 1218 1311 1220 1316 L 1331 1305 L 1325 1242 L 1321 1239 Z M 525 1348 Q 500 1357 483 1374 Q 466 1390 454 1410 Q 439 1434 429 1463 L 422 1485 L 413 1524 L 411 1541 L 410 1542 L 410 1549 L 409 1550 L 409 1557 L 408 1558 L 408 1566 L 407 1567 L 407 1578 L 406 1579 L 406 1623 L 407 1624 L 407 1634 L 408 1635 L 408 1643 L 409 1644 L 411 1662 L 417 1687 Q 432 1740 465 1777 Q 479 1793 499 1804 L 520 1814 L 545 1820 L 571 1820 L 572 1819 L 583 1818 L 600 1813 Q 629 1801 651 1781 Q 687 1746 709 1697 L 722 1661 L 729 1633 L 729 1628 L 732 1616 L 732 1609 L 733 1608 L 733 1601 L 734 1600 L 735 1576 L 736 1575 L 736 1521 L 735 1520 L 735 1509 L 734 1508 L 733 1492 L 729 1470 Q 724 1446 715 1426 Q 706 1404 692 1388 Q 679 1371 661 1361 L 637 1359 L 636 1358 L 627 1358 L 626 1357 L 617 1357 L 616 1356 L 607 1356 L 606 1355 L 597 1355 L 596 1354 L 587 1354 L 586 1353 L 577 1353 L 576 1352 L 567 1352 L 566 1351 L 557 1351 L 556 1350 L 547 1350 L 546 1349 L 537 1349 L 536 1348 L 525 1348 Z M 1340 1350 L 1339 1351 L 1330 1351 L 1329 1352 L 1301 1354 L 1300 1355 L 1291 1355 L 1290 1356 L 1281 1356 L 1280 1357 L 1271 1357 L 1270 1358 L 1261 1358 L 1260 1359 L 1251 1359 L 1250 1360 L 1214 1363 L 1194 1377 Q 1180 1390 1170 1406 L 1154 1439 L 1149 1454 L 1142 1484 L 1140 1504 L 1139 1505 L 1139 1514 L 1138 1515 L 1138 1530 L 1137 1531 L 1137 1568 L 1138 1569 L 1139 1597 L 1140 1598 L 1140 1606 L 1141 1607 L 1141 1614 L 1144 1627 L 1144 1632 L 1151 1661 Q 1169 1723 1207 1766 Q 1227 1788 1254 1804 Q 1267 1812 1285 1817 L 1308 1821 L 1332 1820 L 1358 1813 Q 1382 1803 1400 1786 Q 1432 1755 1449 1710 L 1458 1682 L 1463 1659 L 1465 1640 L 1466 1639 L 1466 1630 L 1467 1629 L 1467 1613 L 1468 1612 L 1467 1575 L 1466 1574 L 1466 1564 L 1464 1555 L 1464 1548 L 1463 1547 L 1463 1541 L 1459 1518 L 1450 1482 Q 1441 1449 1426 1423 Q 1416 1403 1402 1388 Q 1387 1370 1367 1358 L 1349 1350 L 1340 1350 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_2066"
          d="M 486.5 1556 Q 503.2 1555.3 509 1565.5 Q 514.8 1572.2 513 1586.5 L 512 1587.5 L 512 1602.5 L 513 1603.5 L 514 1618.5 L 520 1638.5 Q 526.9 1656.6 540.5 1668 L 550.5 1674 L 568.5 1678 L 576 1683.5 Q 583 1689.5 582 1703.5 L 576 1716 L 568.5 1721 L 557.5 1723 L 541.5 1720 L 526.5 1714 Q 508.4 1704 496 1688.5 Q 479.8 1669.2 472 1641.5 L 467 1617.5 L 466 1582.5 L 467 1581.5 L 468 1570.5 L 476.5 1560 L 486.5 1556 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_2067"
          d="M 1230.5 1557 L 1241.5 1559 L 1252 1568.5 L 1255 1577.5 L 1255 1584.5 L 1254 1585.5 L 1254 1606.5 L 1255 1607.5 L 1256 1620.5 L 1262 1640.5 Q 1269 1658 1282.5 1669 L 1292.5 1675 L 1310.5 1679 L 1320 1687.5 Q 1324.2 1692.8 1324 1702.5 Q 1322 1714.5 1313.5 1720 L 1307.5 1723 L 1292.5 1723 Q 1276.3 1720.2 1264.5 1713 Q 1249.8 1704.2 1239 1691.5 Q 1222.5 1672 1214 1644.5 L 1208 1612.5 L 1208 1580.5 L 1212 1567.5 L 1218.5 1561 L 1230.5 1557 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'FairyLights')

export default icon
